export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: string;
  GenericScalar: any;
  JSONString: any;
  Metadata: any;
  UUID: string;
  Upload: any;
};


export type AcceptCareRecommendationMutation = {
  __typename: 'AcceptCareRecommendationMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type AcceptContractsMutation = {
  __typename: 'AcceptContractsMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum AccountDeviceOs {
  Ios = 'IOS',
  Android = 'ANDROID'
}

export type AccountDoesNotExist = {
  __typename: 'AccountDoesNotExist';
  uuid: Scalars['UUID'];
};

export enum AccountInsuranceStatus {
  Eligible = 'ELIGIBLE',
  NotEligible = 'NOT_ELIGIBLE',
  Incomplete = 'INCOMPLETE'
}

export enum AccountLocalTimezone {
  A = 'A_',
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  AfricaAccra = 'AFRICA_ACCRA',
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  AfricaAlgiers = 'AFRICA_ALGIERS',
  AfricaAsmara = 'AFRICA_ASMARA',
  AfricaAsmera = 'AFRICA_ASMERA',
  AfricaBamako = 'AFRICA_BAMAKO',
  AfricaBangui = 'AFRICA_BANGUI',
  AfricaBanjul = 'AFRICA_BANJUL',
  AfricaBissau = 'AFRICA_BISSAU',
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  AfricaCairo = 'AFRICA_CAIRO',
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  AfricaCeuta = 'AFRICA_CEUTA',
  AfricaConakry = 'AFRICA_CONAKRY',
  AfricaDakar = 'AFRICA_DAKAR',
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  AfricaDouala = 'AFRICA_DOUALA',
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  AfricaFreetown = 'AFRICA_FREETOWN',
  AfricaGaborone = 'AFRICA_GABORONE',
  AfricaHarare = 'AFRICA_HARARE',
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  AfricaJuba = 'AFRICA_JUBA',
  AfricaKampala = 'AFRICA_KAMPALA',
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  AfricaKigali = 'AFRICA_KIGALI',
  AfricaKinshasa = 'AFRICA_KINSHASA',
  AfricaLagos = 'AFRICA_LAGOS',
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  AfricaLome = 'AFRICA_LOME',
  AfricaLuanda = 'AFRICA_LUANDA',
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  AfricaLusaka = 'AFRICA_LUSAKA',
  AfricaMalabo = 'AFRICA_MALABO',
  AfricaMaputo = 'AFRICA_MAPUTO',
  AfricaMaseru = 'AFRICA_MASERU',
  AfricaMbabane = 'AFRICA_MBABANE',
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  AfricaMonrovia = 'AFRICA_MONROVIA',
  AfricaNairobi = 'AFRICA_NAIROBI',
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  AfricaNiamey = 'AFRICA_NIAMEY',
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  AfricaTripoli = 'AFRICA_TRIPOLI',
  AfricaTunis = 'AFRICA_TUNIS',
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  AmericaAdak = 'AMERICA_ADAK',
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  AmericaAntigua = 'AMERICA_ANTIGUA',
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  AmericaAruba = 'AMERICA_ARUBA',
  AmericaAsuncion = 'AMERICA_ASUNCION',
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  AmericaAtka = 'AMERICA_ATKA',
  AmericaBahia = 'AMERICA_BAHIA',
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  AmericaBarbados = 'AMERICA_BARBADOS',
  AmericaBelem = 'AMERICA_BELEM',
  AmericaBelize = 'AMERICA_BELIZE',
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  AmericaBogota = 'AMERICA_BOGOTA',
  AmericaBoise = 'AMERICA_BOISE',
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  AmericaCancun = 'AMERICA_CANCUN',
  AmericaCaracas = 'AMERICA_CARACAS',
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  AmericaCayenne = 'AMERICA_CAYENNE',
  AmericaCayman = 'AMERICA_CAYMAN',
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  AmericaCordoba = 'AMERICA_CORDOBA',
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  AmericaCreston = 'AMERICA_CRESTON',
  AmericaCuiaba = 'AMERICA_CUIABA',
  AmericaCuracao = 'AMERICA_CURACAO',
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  AmericaDawson = 'AMERICA_DAWSON',
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaDetroit = 'AMERICA_DETROIT',
  AmericaDominica = 'AMERICA_DOMINICA',
  AmericaEdmonton = 'AMERICA_EDMONTON',
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  AmericaEnsenada = 'AMERICA_ENSENADA',
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  AmericaGodthab = 'AMERICA_GODTHAB',
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  AmericaGrenada = 'AMERICA_GRENADA',
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  AmericaGuyana = 'AMERICA_GUYANA',
  AmericaHalifax = 'AMERICA_HALIFAX',
  AmericaHavana = 'AMERICA_HAVANA',
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  AmericaInuvik = 'AMERICA_INUVIK',
  AmericaIqaluit = 'AMERICA_IQALUIT',
  AmericaJamaica = 'AMERICA_JAMAICA',
  AmericaJujuy = 'AMERICA_JUJUY',
  AmericaJuneau = 'AMERICA_JUNEAU',
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  AmericaLima = 'AMERICA_LIMA',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  AmericaMaceio = 'AMERICA_MACEIO',
  AmericaManagua = 'AMERICA_MANAGUA',
  AmericaManaus = 'AMERICA_MANAUS',
  AmericaMarigot = 'AMERICA_MARIGOT',
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  AmericaMendoza = 'AMERICA_MENDOZA',
  AmericaMenominee = 'AMERICA_MENOMINEE',
  AmericaMerida = 'AMERICA_MERIDA',
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  AmericaMiquelon = 'AMERICA_MIQUELON',
  AmericaMoncton = 'AMERICA_MONCTON',
  AmericaMonterrey = 'AMERICA_MONTERREY',
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  AmericaMontreal = 'AMERICA_MONTREAL',
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  AmericaNassau = 'AMERICA_NASSAU',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AmericaNipigon = 'AMERICA_NIPIGON',
  AmericaNome = 'AMERICA_NOME',
  AmericaNoronha = 'AMERICA_NORONHA',
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  AmericaNuuk = 'AMERICA_NUUK',
  AmericaOjinaga = 'AMERICA_OJINAGA',
  AmericaPanama = 'AMERICA_PANAMA',
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  AmericaPhoenix = 'AMERICA_PHOENIX',
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  AmericaRecife = 'AMERICA_RECIFE',
  AmericaRegina = 'AMERICA_REGINA',
  AmericaResolute = 'AMERICA_RESOLUTE',
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  AmericaRosario = 'AMERICA_ROSARIO',
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  AmericaSantarem = 'AMERICA_SANTAREM',
  AmericaSantiago = 'AMERICA_SANTIAGO',
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  AmericaShiprock = 'AMERICA_SHIPROCK',
  AmericaSitka = 'AMERICA_SITKA',
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  AmericaStKitts = 'AMERICA_ST_KITTS',
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  AmericaThule = 'AMERICA_THULE',
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  AmericaTijuana = 'AMERICA_TIJUANA',
  AmericaToronto = 'AMERICA_TORONTO',
  AmericaTortola = 'AMERICA_TORTOLA',
  AmericaVancouver = 'AMERICA_VANCOUVER',
  AmericaVirgin = 'AMERICA_VIRGIN',
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  AmericaYakutat = 'AMERICA_YAKUTAT',
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  AsiaAden = 'ASIA_ADEN',
  AsiaAlmaty = 'ASIA_ALMATY',
  AsiaAmman = 'ASIA_AMMAN',
  AsiaAnadyr = 'ASIA_ANADYR',
  AsiaAqtau = 'ASIA_AQTAU',
  AsiaAqtobe = 'ASIA_AQTOBE',
  AsiaAshgabat = 'ASIA_ASHGABAT',
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  AsiaAtyrau = 'ASIA_ATYRAU',
  AsiaBaghdad = 'ASIA_BAGHDAD',
  AsiaBahrain = 'ASIA_BAHRAIN',
  AsiaBaku = 'ASIA_BAKU',
  AsiaBangkok = 'ASIA_BANGKOK',
  AsiaBarnaul = 'ASIA_BARNAUL',
  AsiaBeirut = 'ASIA_BEIRUT',
  AsiaBishkek = 'ASIA_BISHKEK',
  AsiaBrunei = 'ASIA_BRUNEI',
  AsiaCalcutta = 'ASIA_CALCUTTA',
  AsiaChita = 'ASIA_CHITA',
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  AsiaChongqing = 'ASIA_CHONGQING',
  AsiaChungking = 'ASIA_CHUNGKING',
  AsiaColombo = 'ASIA_COLOMBO',
  AsiaDacca = 'ASIA_DACCA',
  AsiaDamascus = 'ASIA_DAMASCUS',
  AsiaDhaka = 'ASIA_DHAKA',
  AsiaDili = 'ASIA_DILI',
  AsiaDubai = 'ASIA_DUBAI',
  AsiaDushanbe = 'ASIA_DUSHANBE',
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  AsiaGaza = 'ASIA_GAZA',
  AsiaHarbin = 'ASIA_HARBIN',
  AsiaHebron = 'ASIA_HEBRON',
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  AsiaHongKong = 'ASIA_HONG_KONG',
  AsiaHovd = 'ASIA_HOVD',
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  AsiaIstanbul = 'ASIA_ISTANBUL',
  AsiaJakarta = 'ASIA_JAKARTA',
  AsiaJayapura = 'ASIA_JAYAPURA',
  AsiaJerusalem = 'ASIA_JERUSALEM',
  AsiaKabul = 'ASIA_KABUL',
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  AsiaKarachi = 'ASIA_KARACHI',
  AsiaKashgar = 'ASIA_KASHGAR',
  AsiaKathmandu = 'ASIA_KATHMANDU',
  AsiaKatmandu = 'ASIA_KATMANDU',
  AsiaKhandyga = 'ASIA_KHANDYGA',
  AsiaKolkata = 'ASIA_KOLKATA',
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  AsiaKuching = 'ASIA_KUCHING',
  AsiaKuwait = 'ASIA_KUWAIT',
  AsiaMacao = 'ASIA_MACAO',
  AsiaMacau = 'ASIA_MACAU',
  AsiaMagadan = 'ASIA_MAGADAN',
  AsiaMakassar = 'ASIA_MAKASSAR',
  AsiaManila = 'ASIA_MANILA',
  AsiaMuscat = 'ASIA_MUSCAT',
  AsiaNicosia = 'ASIA_NICOSIA',
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  AsiaOmsk = 'ASIA_OMSK',
  AsiaOral = 'ASIA_ORAL',
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  AsiaPontianak = 'ASIA_PONTIANAK',
  AsiaPyongyang = 'ASIA_PYONGYANG',
  AsiaQatar = 'ASIA_QATAR',
  AsiaQostanay = 'ASIA_QOSTANAY',
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  AsiaRangoon = 'ASIA_RANGOON',
  AsiaRiyadh = 'ASIA_RIYADH',
  AsiaSaigon = 'ASIA_SAIGON',
  AsiaSakhalin = 'ASIA_SAKHALIN',
  AsiaSamarkand = 'ASIA_SAMARKAND',
  AsiaSeoul = 'ASIA_SEOUL',
  AsiaShanghai = 'ASIA_SHANGHAI',
  AsiaSingapore = 'ASIA_SINGAPORE',
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  AsiaTaipei = 'ASIA_TAIPEI',
  AsiaTashkent = 'ASIA_TASHKENT',
  AsiaTbilisi = 'ASIA_TBILISI',
  AsiaTehran = 'ASIA_TEHRAN',
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  AsiaThimbu = 'ASIA_THIMBU',
  AsiaThimphu = 'ASIA_THIMPHU',
  AsiaTokyo = 'ASIA_TOKYO',
  AsiaTomsk = 'ASIA_TOMSK',
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  AsiaUrumqi = 'ASIA_URUMQI',
  AsiaUstNera = 'ASIA_UST_NERA',
  AsiaVientiane = 'ASIA_VIENTIANE',
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  AsiaYakutsk = 'ASIA_YAKUTSK',
  AsiaYangon = 'ASIA_YANGON',
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  AsiaYerevan = 'ASIA_YEREVAN',
  AtlanticAzores = 'ATLANTIC_AZORES',
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  AtlanticCanary = 'ATLANTIC_CANARY',
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  AtlanticFaroe = 'ATLANTIC_FAROE',
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  AtlanticStanley = 'ATLANTIC_STANLEY',
  AustraliaAct = 'AUSTRALIA_ACT',
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  AustraliaHobart = 'AUSTRALIA_HOBART',
  AustraliaLhi = 'AUSTRALIA_LHI',
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  AustraliaNsw = 'AUSTRALIA_NSW',
  AustraliaNorth = 'AUSTRALIA_NORTH',
  AustraliaPerth = 'AUSTRALIA_PERTH',
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  AustraliaWest = 'AUSTRALIA_WEST',
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  BrazilAcre = 'BRAZIL_ACRE',
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  BrazilEast = 'BRAZIL_EAST',
  BrazilWest = 'BRAZIL_WEST',
  Cet = 'CET',
  Cst6Cdt = 'CST6CDT',
  CanadaAtlantic = 'CANADA_ATLANTIC',
  CanadaCentral = 'CANADA_CENTRAL',
  CanadaEastern = 'CANADA_EASTERN',
  CanadaMountain = 'CANADA_MOUNTAIN',
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  CanadaPacific = 'CANADA_PACIFIC',
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  CanadaYukon = 'CANADA_YUKON',
  ChileContinental = 'CHILE_CONTINENTAL',
  ChileEasterisland = 'CHILE_EASTERISLAND',
  Cuba = 'CUBA',
  Eet = 'EET',
  Est = 'EST',
  Est5Edt = 'EST5EDT',
  Egypt = 'EGYPT',
  Eire = 'EIRE',
  EtcGmt = 'ETC_GMT',
  EtcGmt_0 = 'ETC_GMT_0',
  EtcGmt_1 = 'ETC_GMT_1',
  EtcGmt_10 = 'ETC_GMT_10',
  EtcGmt_11 = 'ETC_GMT_11',
  EtcGmt_12 = 'ETC_GMT_12',
  EtcGmt_2 = 'ETC_GMT_2',
  EtcGmt_3 = 'ETC_GMT_3',
  EtcGmt_4 = 'ETC_GMT_4',
  EtcGmt_5 = 'ETC_GMT_5',
  EtcGmt_6 = 'ETC_GMT_6',
  EtcGmt_7 = 'ETC_GMT_7',
  EtcGmt_8 = 'ETC_GMT_8',
  EtcGmt_9 = 'ETC_GMT_9',
  EtcGmt_0_405 = 'ETC_GMT_0_405',
  EtcGmt_1_406 = 'ETC_GMT_1_406',
  EtcGmt_10_407 = 'ETC_GMT_10_407',
  EtcGmt_11_408 = 'ETC_GMT_11_408',
  EtcGmt_12_409 = 'ETC_GMT_12_409',
  EtcGmt_13 = 'ETC_GMT_13',
  EtcGmt_14 = 'ETC_GMT_14',
  EtcGmt_2_412 = 'ETC_GMT_2_412',
  EtcGmt_3_413 = 'ETC_GMT_3_413',
  EtcGmt_4_414 = 'ETC_GMT_4_414',
  EtcGmt_5_415 = 'ETC_GMT_5_415',
  EtcGmt_6_416 = 'ETC_GMT_6_416',
  EtcGmt_7_417 = 'ETC_GMT_7_417',
  EtcGmt_8_418 = 'ETC_GMT_8_418',
  EtcGmt_9_419 = 'ETC_GMT_9_419',
  EtcGmt0 = 'ETC_GMT0',
  EtcGreenwich = 'ETC_GREENWICH',
  EtcUct = 'ETC_UCT',
  EtcUtc = 'ETC_UTC',
  EtcUniversal = 'ETC_UNIVERSAL',
  EtcZulu = 'ETC_ZULU',
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  EuropeAndorra = 'EUROPE_ANDORRA',
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  EuropeAthens = 'EUROPE_ATHENS',
  EuropeBelfast = 'EUROPE_BELFAST',
  EuropeBelgrade = 'EUROPE_BELGRADE',
  EuropeBerlin = 'EUROPE_BERLIN',
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  EuropeBrussels = 'EUROPE_BRUSSELS',
  EuropeBucharest = 'EUROPE_BUCHAREST',
  EuropeBudapest = 'EUROPE_BUDAPEST',
  EuropeBusingen = 'EUROPE_BUSINGEN',
  EuropeChisinau = 'EUROPE_CHISINAU',
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  EuropeDublin = 'EUROPE_DUBLIN',
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  EuropeHelsinki = 'EUROPE_HELSINKI',
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  EuropeJersey = 'EUROPE_JERSEY',
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  EuropeKiev = 'EUROPE_KIEV',
  EuropeKirov = 'EUROPE_KIROV',
  EuropeLisbon = 'EUROPE_LISBON',
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  EuropeLondon = 'EUROPE_LONDON',
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  EuropeMadrid = 'EUROPE_MADRID',
  EuropeMalta = 'EUROPE_MALTA',
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  EuropeMinsk = 'EUROPE_MINSK',
  EuropeMonaco = 'EUROPE_MONACO',
  EuropeMoscow = 'EUROPE_MOSCOW',
  EuropeNicosia = 'EUROPE_NICOSIA',
  EuropeOslo = 'EUROPE_OSLO',
  EuropeParis = 'EUROPE_PARIS',
  EuropePodgorica = 'EUROPE_PODGORICA',
  EuropePrague = 'EUROPE_PRAGUE',
  EuropeRiga = 'EUROPE_RIGA',
  EuropeRome = 'EUROPE_ROME',
  EuropeSamara = 'EUROPE_SAMARA',
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  EuropeSaratov = 'EUROPE_SARATOV',
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  EuropeSkopje = 'EUROPE_SKOPJE',
  EuropeSofia = 'EUROPE_SOFIA',
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  EuropeTallinn = 'EUROPE_TALLINN',
  EuropeTirane = 'EUROPE_TIRANE',
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  EuropeVaduz = 'EUROPE_VADUZ',
  EuropeVatican = 'EUROPE_VATICAN',
  EuropeVienna = 'EUROPE_VIENNA',
  EuropeVilnius = 'EUROPE_VILNIUS',
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  EuropeWarsaw = 'EUROPE_WARSAW',
  EuropeZagreb = 'EUROPE_ZAGREB',
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  EuropeZurich = 'EUROPE_ZURICH',
  Gb = 'GB',
  GbEire = 'GB_EIRE',
  Gmt = 'GMT',
  Gmt_0 = 'GMT_0',
  Gmt_0_493 = 'GMT_0_493',
  Gmt0 = 'GMT0',
  Greenwich = 'GREENWICH',
  Hst = 'HST',
  Hongkong = 'HONGKONG',
  Iceland = 'ICELAND',
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  IndianChagos = 'INDIAN_CHAGOS',
  IndianChristmas = 'INDIAN_CHRISTMAS',
  IndianCocos = 'INDIAN_COCOS',
  IndianComoro = 'INDIAN_COMORO',
  IndianKerguelen = 'INDIAN_KERGUELEN',
  IndianMahe = 'INDIAN_MAHE',
  IndianMaldives = 'INDIAN_MALDIVES',
  IndianMauritius = 'INDIAN_MAURITIUS',
  IndianMayotte = 'INDIAN_MAYOTTE',
  IndianReunion = 'INDIAN_REUNION',
  Iran = 'IRAN',
  Israel = 'ISRAEL',
  Jamaica = 'JAMAICA',
  Japan = 'JAPAN',
  Kwajalein = 'KWAJALEIN',
  Libya = 'LIBYA',
  Met = 'MET',
  Mst = 'MST',
  Mst7Mdt = 'MST7MDT',
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  MexicoBajasur = 'MEXICO_BAJASUR',
  MexicoGeneral = 'MEXICO_GENERAL',
  Nz = 'NZ',
  NzChat = 'NZ_CHAT',
  Navajo = 'NAVAJO',
  Prc = 'PRC',
  Pst8Pdt = 'PST8PDT',
  PacificApia = 'PACIFIC_APIA',
  PacificAuckland = 'PACIFIC_AUCKLAND',
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  PacificChatham = 'PACIFIC_CHATHAM',
  PacificChuuk = 'PACIFIC_CHUUK',
  PacificEaster = 'PACIFIC_EASTER',
  PacificEfate = 'PACIFIC_EFATE',
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  PacificFiji = 'PACIFIC_FIJI',
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  PacificGambier = 'PACIFIC_GAMBIER',
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  PacificGuam = 'PACIFIC_GUAM',
  PacificHonolulu = 'PACIFIC_HONOLULU',
  PacificJohnston = 'PACIFIC_JOHNSTON',
  PacificKanton = 'PACIFIC_KANTON',
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  PacificKosrae = 'PACIFIC_KOSRAE',
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  PacificMajuro = 'PACIFIC_MAJURO',
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  PacificMidway = 'PACIFIC_MIDWAY',
  PacificNauru = 'PACIFIC_NAURU',
  PacificNiue = 'PACIFIC_NIUE',
  PacificNorfolk = 'PACIFIC_NORFOLK',
  PacificNoumea = 'PACIFIC_NOUMEA',
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  PacificPalau = 'PACIFIC_PALAU',
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  PacificPohnpei = 'PACIFIC_POHNPEI',
  PacificPonape = 'PACIFIC_PONAPE',
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  PacificSaipan = 'PACIFIC_SAIPAN',
  PacificSamoa = 'PACIFIC_SAMOA',
  PacificTahiti = 'PACIFIC_TAHITI',
  PacificTarawa = 'PACIFIC_TARAWA',
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  PacificTruk = 'PACIFIC_TRUK',
  PacificWake = 'PACIFIC_WAKE',
  PacificWallis = 'PACIFIC_WALLIS',
  PacificYap = 'PACIFIC_YAP',
  Poland = 'POLAND',
  Portugal = 'PORTUGAL',
  Roc = 'ROC',
  Rok = 'ROK',
  Singapore = 'SINGAPORE',
  Turkey = 'TURKEY',
  Uct = 'UCT',
  UsAlaska = 'US_ALASKA',
  UsAleutian = 'US_ALEUTIAN',
  UsArizona = 'US_ARIZONA',
  UsCentral = 'US_CENTRAL',
  UsEastIndiana = 'US_EAST_INDIANA',
  UsEastern = 'US_EASTERN',
  UsHawaii = 'US_HAWAII',
  UsIndianaStarke = 'US_INDIANA_STARKE',
  UsMichigan = 'US_MICHIGAN',
  UsMountain = 'US_MOUNTAIN',
  UsPacific = 'US_PACIFIC',
  UsSamoa = 'US_SAMOA',
  Utc = 'UTC',
  Universal = 'UNIVERSAL',
  WSu = 'W_SU',
  Wet = 'WET',
  Zulu = 'ZULU'
}

export enum AccountOnboardingStatus {
  Ineligible = 'INELIGIBLE',
  Eligible = 'ELIGIBLE',
  Active = 'ACTIVE',
  Deprovisioned = 'DEPROVISIONED',
  Unmatchable = 'UNMATCHABLE'
}

export enum AccountProviderSchedulingType {
  Calendar = 'CALENDAR',
  Roster = 'ROSTER',
  MaximumMembers = 'MAXIMUM_MEMBERS',
  NotSet = 'NOT_SET'
}

export enum AccountProviderType {
  Coach = 'COACH',
  Therapist = 'THERAPIST',
  Psychiatrist = 'PSYCHIATRIST'
}

export enum AccountPsychiatristSubtype {
  PsychiatricNursePractitioner = 'PSYCHIATRIC_NURSE_PRACTITIONER',
  Psychiatrist = 'PSYCHIATRIST',
  PrimaryCarePhysician = 'PRIMARY_CARE_PHYSICIAN'
}

export enum AccountRegistrationSource {
  MagicLink = 'MAGIC_LINK',
  OrganicRegistration = 'ORGANIC_REGISTRATION',
  DependentInvitation = 'DEPENDENT_INVITATION',
  SingleSignOn = 'SINGLE_SIGN_ON',
  ScimProvisioning = 'SCIM_PROVISIONING'
}

export enum AccountRole {
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR',
  PowerUser = 'POWER_USER',
  Coach = 'COACH',
  Member = 'MEMBER',
  GroupPractice = 'GROUP_PRACTICE'
}

export type AccountSharedPreferencesRecordNode = {
  __typename: 'AccountSharedPreferencesRecordNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ActivityDoesNotExist = {
  __typename: 'ActivityDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type ActivityGroupDoesNotExist = {
  __typename: 'ActivityGroupDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type AddCareNavigationRequestMutation = {
  __typename: 'AddCareNavigationRequestMutation';
  careNavigationRequest?: Maybe<CareNavigationRequestNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddCoachMutation = {
  __typename: 'AddCoachMutation';
  coachAssignment?: Maybe<CoachAssignmentNode>;
};

export type AddLanguageResponseType = {
  __typename: 'AddLanguageResponseType';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageNode>;
};

export type AddMemberCarePreferenceMutation = {
  __typename: 'AddMemberCarePreferenceMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddNoteMutation = {
  __typename: 'AddNoteMutation';
  note?: Maybe<NoteNode>;
};

export type AddSymptomsExperiencedMutation = {
  __typename: 'AddSymptomsExperiencedMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddTranslationKeyResponseType = {
  __typename: 'AddTranslationKeyResponseType';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  translationKey?: Maybe<TranslationKeyNode>;
};

export type AddTranslationResponseType = {
  __typename: 'AddTranslationResponseType';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  translation?: Maybe<TranslationNode>;
};

export type AddUpdateCompanyFeatureMutation = {
  __typename: 'AddUpdateCompanyFeatureMutation';
  ok?: Maybe<Scalars['Boolean']>;
  feature?: Maybe<CompanyFeatureNode>;
};

export type AllCompaniesOutput = AllCompaniesSuccessResponse | InternalToolPermissionDeniedError;

export type AllCompaniesSuccessResponse = {
  __typename: 'AllCompaniesSuccessResponse';
  companies?: Maybe<Array<Maybe<LaunchOpsCompanyNode>>>;
};

export type AllCompanyAdditionalBenefitNode = Node & {
  __typename: 'AllCompanyAdditionalBenefitNode';
  uuid: Scalars['UUID'];
  title: Scalars['String'];
  link: Scalars['String'];
  description: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  countries: Array<CountryNode>;
  states?: Maybe<Array<Scalars['String']>>;
  providerName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  topics: Array<TopicOfFocusNode>;
  subtopicOfFocus?: Maybe<SubtopicOfFocusNode>;
  availableForDependents: Scalars['Boolean'];
  isModernHealthAddOn: Scalars['Boolean'];
  source?: Maybe<CompanyAdditionalBenefitSource>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  segments: Array<CompanySegmentNode>;
  id: Scalars['ID'];
  benefitId?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<CompanyNode>>>;
  image?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type AllCompanyAdditionalBenefitNodeConnection = {
  __typename: 'AllCompanyAdditionalBenefitNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<AllCompanyAdditionalBenefitNodeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
  edgeCount?: Maybe<Scalars['Int']>;
};

export type AllCompanyAdditionalBenefitNodeEdge = {
  __typename: 'AllCompanyAdditionalBenefitNodeEdge';
  node?: Maybe<AllCompanyAdditionalBenefitNode>;
  cursor: Scalars['String'];
};

export type AllCompanyAdditionalBenefitOutput = AllCompanyAdditionalBenefitSuccessResponse | InternalToolPermissionDeniedError;

export type AllCompanyAdditionalBenefitSuccessResponse = {
  __typename: 'AllCompanyAdditionalBenefitSuccessResponse';
  companyAdditionalBenefits?: Maybe<AllCompanyAdditionalBenefitNodeConnection>;
};


export type AllCompanyAdditionalBenefitSuccessResponseCompanyAdditionalBenefitsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  isModernHealthAddOn?: Maybe<Scalars['Boolean']>;
  availableForDependents?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
  benefitId?: Maybe<Scalars['String']>;
  topicOfFocusUuid?: Maybe<Scalars['UUID']>;
  subtopicOfFocusUuid?: Maybe<Scalars['UUID']>;
  companyUuid?: Maybe<Scalars['UUID']>;
  countryId?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};

export type AllCompanyFeaturesOutput = AllCompanyFeaturesResponse | InternalToolPermissionDeniedError;

export type AllCompanyFeaturesResponse = {
  __typename: 'AllCompanyFeaturesResponse';
  features?: Maybe<Array<Maybe<CompanyFeatureNode>>>;
};

export type AllContentLanguagesOutput = AllContentLanguagesSuccessResponse | InternalToolPermissionDeniedError;

export type AllContentLanguagesSuccessResponse = {
  __typename: 'AllContentLanguagesSuccessResponse';
  contentLanguages?: Maybe<Array<Maybe<ContentLanguageNode>>>;
};

export type AllContentTagCategoriesResponse = {
  __typename: 'AllContentTagCategoriesResponse';
  contentTagCategories?: Maybe<Array<Maybe<ContentTagCategoryNode>>>;
};

export type AllContentTagCategoryOutput = AllContentTagCategoriesResponse | InternalToolPermissionDeniedError;

export type AllContentTagRelationsOutput = AllContentTagRelationsResponse | InternalToolPermissionDeniedError;

export type AllContentTagRelationsResponse = {
  __typename: 'AllContentTagRelationsResponse';
  contentTagRelations?: Maybe<ContentTagRelationNodeConnection>;
};


export type AllContentTagRelationsResponseContentTagRelationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['String']>;
  contentTagId?: Maybe<Scalars['String']>;
};

export type AllContentTagsOutput = AllContentTagsResponse | InternalToolPermissionDeniedError;

export type AllContentTagsResponse = {
  __typename: 'AllContentTagsResponse';
  contentTags?: Maybe<Array<Maybe<ContentTagNode>>>;
};

export type AllContentTranslationAvailabilitiesOutput = AllContentTranslationAvailabilitiesSuccessResponse | InternalToolPermissionDeniedError;

export type AllContentTranslationAvailabilitiesSuccessResponse = {
  __typename: 'AllContentTranslationAvailabilitiesSuccessResponse';
  contentTranslationAvailabilities?: Maybe<Array<Maybe<ContentTranslationAvailabilityNode>>>;
};

export type AllContentUuidsOutput = SyncUuidsSuccessResponse | InvalidEnvironmentError | InternalToolPermissionDeniedError;

export type AllCourseGuidesOutput = AllGuidesResponse | InternalToolPermissionDeniedError;

export type AllCourseHeroesOutput = AllCourseHeroesSuccessResponse | InternalToolPermissionDeniedError;

export type AllCourseHeroesSuccessResponse = {
  __typename: 'AllCourseHeroesSuccessResponse';
  courseHeroes?: Maybe<Array<Maybe<CourseHeroNode>>>;
};

export type AllGuidesResponse = {
  __typename: 'AllGuidesResponse';
  courseGuides?: Maybe<Array<Maybe<CourseGuideNode>>>;
};

export type AllHrAdminRolesOutput = AllHrAdminRolesResponse | InternalToolPermissionDeniedError;

export type AllHrAdminRolesResponse = {
  __typename: 'AllHRAdminRolesResponse';
  hrAdminRoles?: Maybe<Array<Maybe<HrAdminRoleNode>>>;
};

export type AllHrAdminsOutput = AllHrAdminsResponse | InternalToolPermissionDeniedError;

export type AllHrAdminsResponse = {
  __typename: 'AllHRAdminsResponse';
  hrAdmins?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type AllMediaTypesOutput = AllMediaTypesSuccessResponse | InternalToolPermissionDeniedError;

export type AllMediaTypesSuccessResponse = {
  __typename: 'AllMediaTypesSuccessResponse';
  mediaTypes?: Maybe<Array<Maybe<MediaTypeNode>>>;
};

export type AllProvidersOutput = AllProvidersSuccessResponse | InternalToolPermissionDeniedError;

export type AllProvidersSuccessResponse = {
  __typename: 'AllProvidersSuccessResponse';
  providers?: Maybe<Array<Maybe<CoachNode>>>;
};

export type AllScheduledContentOutput = AllScheduledContentResponse | InternalToolPermissionDeniedError;

export type AllScheduledContentResponse = {
  __typename: 'AllScheduledContentResponse';
  scheduledContent?: Maybe<Array<Maybe<ScheduledContentNode>>>;
};

export type AllScreensOutput = AllScreensSuccessResponse | InternalToolPermissionDeniedError;

export type AllScreensSuccessResponse = {
  __typename: 'AllScreensSuccessResponse';
  screens?: Maybe<Array<Maybe<GenericScreenNode>>>;
};

export type AllVideoContentOutput = AllVideoContentSuccessResponse | InternalToolPermissionDeniedError;

export type AllVideoContentSuccessResponse = {
  __typename: 'AllVideoContentSuccessResponse';
  videoContent?: Maybe<Array<Maybe<VideoContentNode>>>;
};

export type AssessmentActivityNode = {
  __typename: 'AssessmentActivityNode';
  assessment?: Maybe<AssessmentNode>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  contentResponses?: Maybe<ContentResponsesNode>;
};

export type AssessmentAnswerNode = {
  __typename: 'AssessmentAnswerNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  answerOrder: Scalars['Int'];
  value: Scalars['Int'];
  answerText: Scalars['String'];
  answerTextEnUs?: Maybe<Scalars['String']>;
  answerTextEs?: Maybe<Scalars['String']>;
  answerTextFrCa?: Maybe<Scalars['String']>;
  answerTextFr?: Maybe<Scalars['String']>;
  answerTextKo?: Maybe<Scalars['String']>;
  answerTextJa?: Maybe<Scalars['String']>;
  answerTextZhHans?: Maybe<Scalars['String']>;
  answerTextDe?: Maybe<Scalars['String']>;
  answerTextHi?: Maybe<Scalars['String']>;
  answerTextPt?: Maybe<Scalars['String']>;
  answerTextMy?: Maybe<Scalars['String']>;
  answerTextIt?: Maybe<Scalars['String']>;
  answerTextPl?: Maybe<Scalars['String']>;
  questions: Array<AssessmentQuestionNode>;
};

export type AssessmentDetailNode = Node & {
  __typename: 'AssessmentDetailNode';
  id: Scalars['ID'];
  assessmentType: Scalars['String'];
  assessmentTitle: Scalars['String'];
  assessmentDescription: Scalars['String'];
  date: Scalars['String'];
  score: Scalars['Int'];
  color: Scalars['String'];
  responses: Array<Maybe<AssessmentResponseNode>>;
};

export type AssessmentFlowNode = {
  __typename: 'AssessmentFlowNode';
  member: MemberNode;
  careRecommendation?: Maybe<CareRecommendationNode>;
  uuid: Scalars['UUID'];
  startedAt: Scalars['DateTime'];
};

export enum AssessmentJourneyCreationSource {
  Courses = 'COURSES',
  Email = 'EMAIL',
  InitialOnboarding = 'INITIAL_ONBOARDING',
  Retriage = 'RETRIAGE',
  HomePage = 'HOME_PAGE',
  PushNotification = 'PUSH_NOTIFICATION',
  LegacyProgram = 'LEGACY_PROGRAM',
  MemberWebSettings = 'MEMBER_WEB_SETTINGS',
  PreSession = 'PRE_SESSION'
}

export type AssessmentJourneyNode = {
  __typename: 'AssessmentJourneyNode';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum AssessmentKey {
  Who5 = 'WHO5',
  Gad2 = 'GAD2',
  Gad7Remainder = 'GAD7_REMAINDER',
  Gad7 = 'GAD7',
  Phq2 = 'PHQ2',
  Phq8Remainder = 'PHQ8_REMAINDER',
  Phq9Remainder = 'PHQ9_REMAINDER',
  Phq8 = 'PHQ8',
  Phq9 = 'PHQ9',
  EmploymentHealth = 'EMPLOYMENT_HEALTH',
  EmploymentHealthV2 = 'EMPLOYMENT_HEALTH_V2',
  ManagerEssentials = 'MANAGER_ESSENTIALS',
  Burnout = 'BURNOUT'
}

export type AssessmentLinkNode = Node & {
  __typename: 'AssessmentLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  assessment: AssessmentNode;
};

export type AssessmentNode = {
  __typename: 'AssessmentNode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  calculation: Scalars['String'];
  mandatory: Scalars['Boolean'];
  questions?: Maybe<Scalars['JSONString']>;
  resources?: Maybe<Array<Maybe<Scalars['String']>>>;
  headerText?: Maybe<Scalars['String']>;
  englishOnlyHeaderText?: Maybe<Scalars['String']>;
  assessmentQuestions: Array<AssessmentQuestionNode>;
};

export type AssessmentOverviewDataNode = Node & {
  __typename: 'AssessmentOverviewDataNode';
  id: Scalars['ID'];
  date: Scalars['String'];
  score: Scalars['Int'];
  color: Scalars['String'];
  assessmentFlowUuid: Scalars['UUID'];
};

export type AssessmentOverviewNode = Node & {
  __typename: 'AssessmentOverviewNode';
  id: Scalars['ID'];
  assessmentType: Scalars['String'];
  assessmentTitle: Scalars['String'];
  assessmentDescription: Scalars['String'];
  data: Array<Maybe<AssessmentOverviewDataNode>>;
};

export type AssessmentQuestionNode = {
  __typename: 'AssessmentQuestionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  questionOrder: Scalars['Int'];
  questionKey: Scalars['String'];
  questionText: Scalars['String'];
  responseType: Array<AssessmentAnswerNode>;
  optional: Scalars['Boolean'];
  displayCrisisWarning: Scalars['Boolean'];
  calloutText?: Maybe<Scalars['String']>;
};

export type AssessmentResponseNode = Node & {
  __typename: 'AssessmentResponseNode';
  id: Scalars['ID'];
  prompt: Scalars['String'];
  answer: Scalars['String'];
  score: Scalars['Int'];
};

export type AvailableHourInput = {
  day: Scalars['String'];
  start: Scalars['String'];
  end: Scalars['String'];
};

export type AvailableHourNode = {
  __typename: 'AvailableHourNode';
  day?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
};

export type AvailablePeriodNode = {
  __typename: 'AvailablePeriodNode';
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};

export type AvailableReportType = {
  __typename: 'AvailableReportType';
  reportOrSectionEnum: Scalars['String'];
  lookerUrl: Scalars['String'];
  lookerUrlTtl: Scalars['Int'];
  dashboardId: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
};

export type AvailableSectionType = {
  __typename: 'AvailableSectionType';
  reportOrSectionEnum: Scalars['String'];
  title: Scalars['String'];
  reports: Array<Maybe<PossibleReportType>>;
};

export type BaseError = {
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type BaseSurveyError = {
  message: Scalars['String'];
  debug: Scalars['String'];
};

export type BenefitByTopicInput = {
  benefitId: Scalars['ID'];
  topicId: Scalars['ID'];
};

export type BenefitFeatureInput = {
  benefitsByTopic: Array<BenefitByTopicInput>;
};

export type BenefitNode = {
  __typename: 'BenefitNode';
  id: Scalars['ID'];
  score: Scalars['Float'];
  topic: Scalars['ID'];
};

export type BenefitUnitNode = {
  __typename: 'BenefitUnitNode';
  contents?: Maybe<Array<BenefitNode>>;
  modelMetadata: ModelMetadataNode;
};

export type BypassAssessmentsMutation = {
  __typename: 'BypassAssessmentsMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type CalendarAuthLinkNode = {
  __typename: 'CalendarAuthLinkNode';
  url?: Maybe<Scalars['String']>;
  alreadyConnected?: Maybe<Scalars['Boolean']>;
};

export type CalendarEventNode = {
  __typename: 'CalendarEventNode';
  title: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  recurrence?: Maybe<CalendarEventRecurFrequency>;
};

export enum CalendarEventRecurFrequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type CalendarNode = {
  __typename: 'CalendarNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  calendarProfile: CalendarProfileNode;
  isActive: Scalars['Boolean'];
  isTarget: Scalars['Boolean'];
  isReadonly: Scalars['Boolean'];
  calendarName: Scalars['String'];
};

export type CalendarProfileNode = {
  __typename: 'CalendarProfileNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  providerName: Scalars['String'];
  profileId: Scalars['String'];
  profileName: Scalars['String'];
  calendars: Array<CalendarNode>;
};

export type CancelEventMutation = {
  __typename: 'CancelEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelMemberPathwayMutationInput = {
  pathwayUuid: Scalars['UUID'];
};

export type CancelMemberPathwayMutationResponse = {
  __typename: 'CancelMemberPathwayMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelledSessionDoesNotExist = {
  __typename: 'CancelledSessionDoesNotExist';
  coachingVisitUuidDoesNotExist?: Maybe<Scalars['UUID']>;
};

export type CancelledSessionReviewInput = {
  coachingVisitUuid: Scalars['UUID'];
  reasons: Array<Maybe<Scalars['String']>>;
  otherText?: Maybe<Scalars['String']>;
};

export type CancelledSessionReviewOutput = CancelledSessionReviewResponse | CancelledSessionDoesNotExist;

export type CancelledSessionReviewResponse = {
  __typename: 'CancelledSessionReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum CareNavigationRequestContactPreference {
  Phone = 'PHONE',
  Email = 'EMAIL'
}

export type CareNavigationRequestNode = {
  __typename: 'CareNavigationRequestNode';
  uuid: Scalars['UUID'];
  member: MemberNode;
  message?: Maybe<Scalars['String']>;
  contactPreference: Scalars['String'];
  contactPhone?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  zendeskTicketId?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  createdAt: Scalars['DateTime'];
  subtopicsOfFocus: Array<SubtopicOfFocusNode>;
  inAppConsent?: Maybe<Scalars['Boolean']>;
  isClinical?: Maybe<Scalars['Boolean']>;
  zendeskLink?: Maybe<Scalars['String']>;
};

export enum CareNavigationRequestSource {
  WellbeingReport = 'WELLBEING_REPORT',
  BenefitsPage = 'BENEFITS_PAGE',
  ContactUs = 'CONTACT_US',
  CareOptions = 'CARE_OPTIONS'
}

export enum CareNavigationRequestTopic {
  NavigatingMh = 'NAVIGATING_MH',
  CompanyBenefits = 'COMPANY_BENEFITS',
  OneOnOneCare = 'ONE_ON_ONE_CARE',
  TopicsOfFocus = 'TOPICS_OF_FOCUS',
  Other = 'OTHER'
}

export enum CareOption {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Courses = 'COURSES',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Coaching = 'COACHING'
}

export enum CareRecommendationClinicalRecommendation {
  Coaching = 'COACHING',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Therapy = 'THERAPY'
}

export enum CareRecommendationModality {
  Unspecified = 'UNSPECIFIED',
  OnMyOwn = 'ON_MY_OWN',
  WithASmallGroup = 'WITH_A_SMALL_GROUP',
  OneOnOne = 'ONE_ON_ONE'
}

export enum CareRecommendationModalityPreference {
  Unspecified = 'UNSPECIFIED',
  OnMyOwn = 'ON_MY_OWN',
  WithASmallGroup = 'WITH_A_SMALL_GROUP',
  OneOnOne = 'ONE_ON_ONE'
}

export type CareRecommendationNode = {
  __typename: 'CareRecommendationNode';
  uuid: Scalars['UUID'];
  member: MemberNode;
  calculatedUsingContentResponses?: Maybe<ContentResponsesNode>;
  modalityPreference?: Maybe<CareRecommendationModalityPreference>;
  recommendation?: Maybe<CareRecommendationRecommendation>;
  clinicalRecommendation?: Maybe<CareRecommendationClinicalRecommendation>;
  outcome?: Maybe<CareRecommendationOutcome>;
  state: CareRecommendationState;
  startedAt: Scalars['DateTime'];
  recommendedAt?: Maybe<Scalars['DateTime']>;
  acceptedAt?: Maybe<Scalars['DateTime']>;
  onboarding: Scalars['Boolean'];
  topicSelections: Array<TopicSelectionNode>;
};

export enum CareRecommendationOutcome {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Courses = 'COURSES',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Coaching = 'COACHING'
}

export enum CareRecommendationRecommendation {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Courses = 'COURSES',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Coaching = 'COACHING'
}

export enum CareRecommendationState {
  Started = 'STARTED',
  TopicsSelected = 'TOPICS_SELECTED',
  SymptomsSelected = 'SYMPTOMS_SELECTED',
  PrimaryFocusSelected = 'PRIMARY_FOCUS_SELECTED',
  DifficultySelected = 'DIFFICULTY_SELECTED',
  ModalitySelected = 'MODALITY_SELECTED',
  AssessmentsCompleted = 'ASSESSMENTS_COMPLETED',
  Recommended = 'RECOMMENDED',
  Accepted = 'ACCEPTED',
  BypassedAssessments = 'BYPASSED_ASSESSMENTS'
}

export type CertificationNode = {
  __typename: 'CertificationNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  certificationRequirements: Array<CertificationRequirementNode>;
};

export enum CertificationRequirementCareOption {
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  Courses = 'COURSES',
  Circles = 'CIRCLES',
  Therapy = 'THERAPY',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Coaching = 'COACHING'
}

export type CertificationRequirementNode = {
  __typename: 'CertificationRequirementNode';
  uuid: Scalars['UUID'];
  certification: CertificationNode;
  careOption: CertificationRequirementCareOption;
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type ChangeAccountTopicsOutput = ChangeAccountTopicsResponse | SubtopicOfFocusDoesNotExist | TopicSelectionTypeInvalid;

export type ChangeAccountTopicsResponse = {
  __typename: 'ChangeAccountTopicsResponse';
  ok?: Maybe<Scalars['Boolean']>;
  debug?: Maybe<Scalars['String']>;
};

export type ChangeTopicsInput = {
  subtopicUuids: Array<Maybe<Scalars['UUID']>>;
  selectionType: Scalars['String'];
};

export type CheckEligibilityInput = {
  member: CheckMemberInput;
  insurance: CheckInsuranceInput;
};

export type CheckEligibilityResponse = {
  __typename: 'CheckEligibilityResponse';
  ok: Scalars['Boolean'];
  ineligibleReason?: Maybe<IneligibleReason>;
};

export type CheckInsuranceInput = {
  employerInsurance: Scalars['Int'];
  policyMemberId: Scalars['String'];
  policyNumber: Scalars['String'];
  relationshipCode: Scalars['String'];
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
};

export type CheckMemberInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  address: Scalars['String'];
  addressTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
};

export type ChooseProviderMutation = {
  __typename: 'ChooseProviderMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type CircleAdminCreateBooleanQuestionMutationResponse = CirclePermissionDeniedError | CircleBooleanQuestionDefinitionNode;

export type CircleAdminCreateFacilitatorMutationResponse = CirclePermissionDeniedError | CircleFacilitatorNode;

export type CircleAdminCreateFeaturedItemMutationResponse = CircleNotFoundError | CircleValidationError | CirclePermissionDeniedError | CircleFeaturedItemNode;

export type CircleAdminCreateFreeResponseQuestionMutationResponse = CirclePermissionDeniedError | CircleFreeResponseQuestionDefinitionNode;

export type CircleAdminCreateMultipleChoiceQuestionMutationResponse = CirclePermissionDeniedError | CircleMultipleChoiceQuestionDefinitionNode;

export type CircleAdminCreateOnDemandTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleOnDemandNode;

export type CircleAdminCreateRsvpQuestionTopicDataInput = {
  topicId: Scalars['ID'];
  questionId: Scalars['ID'];
  displayOrder: Scalars['Int'];
};

export type CircleAdminCreateRsvpQuestionTopicMutationResponse = CirclePermissionDeniedError | CircleNotFoundError | CircleValidationError | CircleRsvpQuestionTopicNode;

export type CircleAdminCreateSegmentedScaleQuestionMutationResponse = CirclePermissionDeniedError | CircleSegmentedScaleQuestionDefinitionNode;

export type CircleAdminCreateSeriesMutationResponse = CirclePermissionDeniedError | CircleValidationError | CircleSeriesNode;

export type CircleAdminCreateSessionMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleSessionNode;

export type CircleAdminCreateShortResponseQuestionMutationResponse = CirclePermissionDeniedError | CircleShortResponseQuestionDefinitionNode;

export type CircleAdminCreateTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleTopicNode;

export type CircleAdminDeleteFeaturedItemMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleDeleteSuccessful;

export type CircleAdminDeleteRsvpQuestionTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleDeleteSuccessful;

export type CircleAdminFacilitatorCollectionResponse = CirclePermissionDeniedError | CircleFacilitatorCollection;

export type CircleAdminFeaturedItemCollectionResponse = CirclePermissionDeniedError | CircleFeaturedItemCollection;

export type CircleAdminOnDemandTopicQueryResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleOnDemandNode;

export type CircleAdminRsvpQuestionDefinitionsResponse = CirclePermissionDeniedError | CircleRsvpQuestionDefinitionCollection;

export type CircleAdminScheduledTaskConnectionResponse = CirclePermissionDeniedError | CircleValidationError | CircleScheduledTaskConnection;

export type CircleAdminScheduledTaskListInput = {
  taskState: Scalars['String'];
};

export type CircleAdminScheduledTasksCollection = {
  __typename: 'CircleAdminScheduledTasksCollection';
  items: Array<CircleScheduledTaskNode>;
  totalCount: Scalars['Int'];
};

export type CircleAdminUpdateFacilitatorMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleFacilitatorNode;

export type CircleAdminUpdateOnDemandTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleOnDemandNode;

export type CircleAdminUpdateSeriesMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleSeriesNode;

export type CircleAdminUpdateSessionMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleSessionNode;

export type CircleAdminUpdateTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError | CircleTopicNode;

/** An answer option in a dropdown question */
export type CircleAnswerDropdownOptionNode = Node & {
  __typename: 'CircleAnswerDropdownOptionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
};

export type CircleAnswerMultipleChoiceDefinitionNode = Node & {
  __typename: 'CircleAnswerMultipleChoiceDefinitionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
};

/** An answer option in a radio group question */
export type CircleAnswerRadioOptionNode = Node & {
  __typename: 'CircleAnswerRadioOptionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
};

export type CircleAnswerSegmentedScaleDefinitionNode = Node & {
  __typename: 'CircleAnswerSegmentedScaleDefinitionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
  optionValue: Scalars['Int'];
};

export type CircleBaseQuestion = {
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/**
 * A question definition representing a "boolean question", or one
 * with only a True/False answer
 */
export type CircleBooleanQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename: 'CircleBooleanQuestionDefinitionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
};

export type CircleCalendarLinks = {
  __typename: 'CircleCalendarLinks';
  /** Add to Google Calendar link */
  google?: Maybe<Scalars['String']>;
  /** Add to Outlook (Online) link */
  outlook?: Maybe<Scalars['String']>;
  /**
   * Download ICS link
   *
   * The link returned is formatted as /circles/rsvp/<uuid>/ics-download,
   * the site must support this relative URL redirecting to the
   * backend
   */
  ics?: Maybe<Scalars['String']>;
};

export type CircleCalendarLinksByRsvpQueryResponse = CircleCalendarLinks | CircleNotFoundError | CircleValidationError;

export type CircleCancelAuthenticatedRsvpMutationResponse = CircleRsvpCancellationSuccessful | CircleValidationError | CirclePermissionDeniedError | CircleNotFoundError | CircleSessionAlreadyStartedError;

export type CircleCancelUnauthenticatedRsvpMutationResponse = CircleRsvpCancellationSuccessful | CirclePermissionDeniedError | CircleNotFoundError | CircleSessionAlreadyStartedError;

/**
 * A question representing a boolean checkbox, if this
 * question is required that indicates the checkbox must
 * be checked prior to submission.
 */
export type CircleCheckboxQuestionNode = CircleBaseQuestion & {
  __typename: 'CircleCheckboxQuestionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
};

export type CircleCompanyRsvpUnauthenticatedUserInfoInput = {
  email: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type CircleCreateAuthenticatedRsvpDataInput = {
  sessionId: Scalars['ID'];
  rsvpQuestionAnswers?: Maybe<Array<CircleRsvpQuestionAnswerInput>>;
};

export type CircleCreateAuthenticatedRsvpMutationResponse = CircleRsvpSuccessful | CirclePermissionDeniedError | CircleNotFoundError | CircleValidationError | CircleProcessingError | CircleSessionSeatLimitExceededError | CircleSessionAlreadyStartedError | CircleRsvpForSessionExistsForUserError;

/** Defines a boolean response question */
export type CircleCreateBooleanQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/** CircleCreateFacilitatorDataInput input used for adminCreateFacilitator mutation */
export type CircleCreateFacilitatorDataInput = {
  name: Scalars['String'];
  title: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

/** CircleCreateFeaturedItemDataInput input used for adminCreateFeaturedItem mutation */
export type CircleCreateFeaturedItemDataInput = {
  id: Scalars['ID'];
  displayOrder: Scalars['Int'];
};

/** Defines a free response question */
export type CircleCreateFreeResponseQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleCreateItemFeedbackInput = {
  type: CircleItemFeedbackType;
  itemId: Scalars['ID'];
  rating: Scalars['Int'];
  freeText?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Scalars['String']>>;
};

export type CircleCreateItemFeedbackMutationResponse = CircleNotFoundError | CircleValidationError | CirclePermissionDeniedError | CircleCreateItemFeedbackSuccessful;

export type CircleCreateItemFeedbackSuccessful = {
  __typename: 'CircleCreateItemFeedbackSuccessful';
  message: Scalars['String'];
};

export type CircleCreateMultipleChoiceOption = {
  optionText: Scalars['String'];
};

/** Defines a multiple choice question */
export type CircleCreateMultipleChoiceQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
  options: Array<CircleCreateMultipleChoiceOption>;
};

export type CircleCreateOnDemandDataInput = {
  description: Scalars['String'];
  duration: Scalars['Int'];
  externalVideoUrl: Scalars['String'];
  facilitatorIds?: Maybe<Array<Scalars['ID']>>;
  languageCode: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  relatedTopicIds?: Maybe<Array<Scalars['ID']>>;
  seriesId: Scalars['ID'];
  slug: Scalars['String'];
  thumbnail: Scalars['String'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type CircleCreateSegmentedScaleOption = {
  optionText: Scalars['String'];
  optionValue: Scalars['Int'];
};

/** Defines a segmented scale question */
export type CircleCreateSegmentedScaleQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
  options: Array<CircleCreateSegmentedScaleOption>;
};

/** CircleCreateSeriesDataInput input used for adminCreateSeries mutation */
export type CircleCreateSeriesDataInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  shortDescription: Scalars['String'];
  illustrationUrl: Scalars['String'];
  archived: Scalars['Boolean'];
  slug: Scalars['String'];
  accessType?: Maybe<Scalars['String']>;
  heroImage?: Maybe<Scalars['String']>;
  heroBackgroundColor?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  other?: Maybe<Scalars['String']>;
};

/** CircleCreateSessionDataInput input used for adminCreateSession mutation */
export type CircleCreateSessionDataInput = {
  startTime: Scalars['DateTime'];
  seatLimit: Scalars['Int'];
  archived: Scalars['Boolean'];
  topicId: Scalars['ID'];
  seatsLeft?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  rsvpLink?: Maybe<Scalars['String']>;
  meetingUrl?: Maybe<Scalars['String']>;
  useInHouseRsvp?: Maybe<Scalars['Boolean']>;
  facilitatorIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isExternalMeetingUrl?: Maybe<Scalars['Boolean']>;
  meetingInstructions?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  companySurveyUrl?: Maybe<Scalars['String']>;
};

/** Defines a short response question */
export type CircleCreateShortResponseQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/** CircleCreateTopicDataInput input used for adminCreateTopic mutation */
export type CircleCreateTopicDataInput = {
  slug: Scalars['String'];
  format: CircleTopicFormat;
  duration: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  languageCode: Scalars['String'];
  seriesId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  surveyUrl?: Maybe<Scalars['String']>;
};

export type CircleCreateUnauthenticatedCompanyRsvpDataInput = {
  sessionId: Scalars['ID'];
  userInfo: CircleCompanyRsvpUnauthenticatedUserInfoInput;
};

export type CircleCreateUnauthenticatedCompanyRsvpMutationResponse = CircleRsvpSuccessful | CirclePermissionDeniedError | CircleNotFoundError | CircleValidationError | CircleProcessingError | CircleSessionSeatLimitExceededError | CircleSessionAlreadyStartedError | CircleSeriesAccessTypeNotAllowedError;

export type CircleCreateUnauthenticatedRsvpDataInput = {
  sessionId: Scalars['ID'];
  userInfo: CircleRsvpUnauthenticatedUserInfoInput;
  rsvpQuestionAnswers?: Maybe<Array<CircleRsvpQuestionAnswerInput>>;
};

export type CircleCreateUnauthenticatedRsvpMutationResponse = CircleRsvpSuccessful | CirclePermissionDeniedError | CircleNotFoundError | CircleValidationError | CircleProcessingError | CircleSessionSeatLimitExceededError | CircleSessionAlreadyStartedError | CircleSeriesAccessTypeNotAllowedError;

export type CircleDeleteSuccessful = {
  __typename: 'CircleDeleteSuccessful';
  message: Scalars['String'];
};

/** A question representing a dropdown of options */
export type CircleDropdownQuestionNode = CircleBaseQuestion & {
  __typename: 'CircleDropdownQuestionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  options: Array<CircleAnswerDropdownOptionNode>;
};

export type CircleFacilitatorCollection = {
  __typename: 'CircleFacilitatorCollection';
  items: Array<Maybe<CircleFacilitatorNode>>;
  totalCount: Scalars['Int'];
};

export type CircleFacilitatorConnection = {
  __typename: 'CircleFacilitatorConnection';
  edges: Array<Maybe<CircleFacilitatorEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleFacilitatorEdge = {
  __typename: 'CircleFacilitatorEdge';
  cursor: Scalars['String'];
  node: CircleFacilitatorNode;
};

export type CircleFacilitatorNode = Node & {
  __typename: 'CircleFacilitatorNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  credential: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
  photo?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

/** A collection of items to feature */
export type CircleFeaturedCollection = {
  __typename: 'CircleFeaturedCollection';
  /** The items to feature. */
  items: Array<CircleItem>;
  totalCount: Scalars['Int'];
};

export type CircleFeaturedItemCollection = {
  __typename: 'CircleFeaturedItemCollection';
  items: Array<Maybe<CircleFeaturedItemNode>>;
  totalCount: Scalars['Int'];
};

export type CircleFeaturedItemNode = Node & {
  __typename: 'CircleFeaturedItemNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  featuredTopic?: Maybe<CircleTopicNode>;
};

/** A question definition representing a long-form text answer */
export type CircleFreeResponseQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename: 'CircleFreeResponseQuestionDefinitionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
};

/**
 * A type representing all nodes which can be featured,
 * if a frontend does not support a type it should not
 * be rendered.
 */
export type CircleItem = CircleTopicNode;

export enum CircleItemFeedbackType {
  OnDemandTopicFeedback = 'ON_DEMAND_TOPIC_FEEDBACK'
}

/** A question definition representing a multiple choice question */
export type CircleMultipleChoiceQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename: 'CircleMultipleChoiceQuestionDefinitionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  options: Array<CircleAnswerMultipleChoiceDefinitionNode>;
};

export type CircleNotFoundError = {
  __typename: 'CircleNotFoundError';
  message: Scalars['String'];
};

export type CircleOnDemandBySlugQueryResponse = CirclePermissionDeniedError | CircleNotFoundError | CircleOnDemandNode;

export type CircleOnDemandConnection = {
  __typename: 'CircleOnDemandConnection';
  edges: Array<Maybe<CircleOnDemandEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleOnDemandConnectionQueryResponse = CirclePermissionDeniedError | CircleOnDemandConnection;

export type CircleOnDemandEdge = {
  __typename: 'CircleOnDemandEdge';
  cursor: Scalars['String'];
  node: CircleOnDemandNode;
};

export type CircleOnDemandNode = Node & {
  __typename: 'CircleOnDemandNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  slug: Scalars['String'];
  series: CircleSeriesNode;
  name: Scalars['String'];
  description: Scalars['String'];
  languageCode: Scalars['String'];
  facilitators: Array<CircleFacilitatorNode>;
  relatedTopics?: Maybe<Array<CircleTopicNode>>;
  video: CircleVideoNode;
  note?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

/**
 * A question representing a paragraph or multi-line text
 * input.
 */
export type CircleParagraphQuestionNode = CircleBaseQuestion & {
  __typename: 'CircleParagraphQuestionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  maxCharacters?: Maybe<Scalars['Int']>;
  lines?: Maybe<Scalars['Int']>;
};

export type CirclePermissionDeniedError = {
  __typename: 'CirclePermissionDeniedError';
  message: Scalars['String'];
};

export type CircleProcessingError = {
  __typename: 'CircleProcessingError';
  message: Scalars['String'];
};

/**
 * A type representing all nodes which can be returned
 * as question objects in Circles forms
 */
export type CircleQuestion = CircleRadioGroupQuestionNode | CircleDropdownQuestionNode | CircleSingleLineQuestionNode | CircleParagraphQuestionNode | CircleCheckboxQuestionNode;

export type CircleQuestionDefinitionNode = {
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleRsvpQuestionAnswerInput = {
  questionId: Scalars['ID'];
  answerId?: Maybe<Scalars['ID']>;
  answerText?: Maybe<Scalars['String']>;
};

export type CircleRsvpUnauthenticatedUserInfoInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  country: Scalars['String'];
  isMember: Scalars['Boolean'];
  company?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

/** A question representing a group of radio options */
export type CircleRadioGroupQuestionNode = CircleBaseQuestion & {
  __typename: 'CircleRadioGroupQuestionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  options: Array<CircleAnswerRadioOptionNode>;
};

export type CircleRetryFailedScheduledTasksMutationResponse = CirclePermissionDeniedError | CircleAdminScheduledTasksCollection;

export type CircleRsvpCancellationSuccessful = {
  __typename: 'CircleRsvpCancellationSuccessful';
  rsvpState: CircleRsvpState;
};

/** Rsvp collection for a member */
export type CircleRsvpCollection = {
  __typename: 'CircleRsvpCollection';
  edges: Array<Maybe<CircleRsvpEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleRsvpEdge = {
  __typename: 'CircleRsvpEdge';
  cursor: Scalars['String'];
  node: CircleRsvpNode;
};

export type CircleRsvpForSessionExistsForUserError = {
  __typename: 'CircleRsvpForSessionExistsForUserError';
  message: Scalars['String'];
};

export type CircleRsvpNode = Node & {
  __typename: 'CircleRsvpNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  session: CircleSessionNode;
  state: CircleRsvpState;
  joinSessionUrl?: Maybe<Scalars['String']>;
};

export type CircleRsvpQueryResponse = CircleNotFoundError | CircleRsvpNode;

export type CircleRsvpQuestionDefinitionCollection = {
  __typename: 'CircleRsvpQuestionDefinitionCollection';
  totalCount: Scalars['Int'];
  definitions: Array<CircleQuestionDefinitionNode>;
};

/** Node that has the relationship between a topic and a rsvpQuestion object */
export type CircleRsvpQuestionTopicNode = Node & {
  __typename: 'CircleRsvpQuestionTopicNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  topic: CircleTopicNode;
  rsvpQuestion: CircleQuestion;
  displayOrder: Scalars['Int'];
};

export enum CircleRsvpState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type CircleRsvpSuccessful = {
  __typename: 'CircleRsvpSuccessful';
  rsvpId: Scalars['ID'];
};

export type CircleRsvpsQueryResponse = CirclePermissionDeniedError | CircleRsvpCollection;

export type CircleScheduledTaskConnection = {
  __typename: 'CircleScheduledTaskConnection';
  edges: Array<Maybe<CircleScheduledTaskEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleScheduledTaskEdge = {
  __typename: 'CircleScheduledTaskEdge';
  cursor: Scalars['String'];
  node: CircleScheduledTaskNode;
};

export type CircleScheduledTaskNode = Node & {
  __typename: 'CircleScheduledTaskNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  taskName: Scalars['String'];
  taskState: CircleScheduledTaskState;
  scheduledAt: Scalars['DateTime'];
  startedProcessingAt?: Maybe<Scalars['DateTime']>;
  finishedProcessingAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
};

export enum CircleScheduledTaskState {
  Unprocessed = 'UNPROCESSED',
  Processing = 'PROCESSING',
  Processed = 'PROCESSED',
  Cancelled = 'CANCELLED',
  Error = 'ERROR'
}

/**
 * A question definition representing a segmented scale
 *
 * A segmented scale is a linear list of multiple choice options
 * where each option is assigned a score.
 */
export type CircleSegmentedScaleQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename: 'CircleSegmentedScaleQuestionDefinitionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  options: Array<CircleAnswerSegmentedScaleDefinitionNode>;
};

export type CircleSeriesAccessTypeNotAllowedError = {
  __typename: 'CircleSeriesAccessTypeNotAllowedError';
  message: Scalars['String'];
};

export type CircleSeriesCollection = {
  __typename: 'CircleSeriesCollection';
  items: Array<Maybe<CircleSeriesNode>>;
  totalCount: Scalars['Int'];
};

export type CircleSeriesLinkNode = Node & {
  __typename: 'CircleSeriesLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  circleSeries?: Maybe<CircleSeriesNode>;
};

export type CircleSeriesNode = Node & {
  __typename: 'CircleSeriesNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  description: Scalars['String'];
  shortDescription: Scalars['String'];
  originalName: Scalars['String'];
  originalDescription: Scalars['String'];
  originalShortDescription: Scalars['String'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
  illustration?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  heroImage?: Maybe<Scalars['String']>;
  heroBackgroundColor?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  accessType?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  topics: CircleTopicConnection;
  /** Returns All topics including those with expired sessions */
  allTopics: CircleTopicConnection;
  onDemand: CircleOnDemandConnection;
};


export type CircleSeriesNodeTopicsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CircleSeriesNodeAllTopicsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CircleSeriesNodeOnDemandArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

export type CircleSessionAlreadyStartedError = {
  __typename: 'CircleSessionAlreadyStartedError';
  message: Scalars['String'];
};

export enum CircleSessionBookingStatus {
  FullyBooked = 'FULLY_BOOKED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  SpotsAvailable = 'SPOTS_AVAILABLE',
  ManySpotsAvailable = 'MANY_SPOTS_AVAILABLE'
}

export type CircleSessionConnection = {
  __typename: 'CircleSessionConnection';
  edges: Array<Maybe<CircleSessionEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleSessionEdge = {
  __typename: 'CircleSessionEdge';
  cursor: Scalars['String'];
  node: CircleSessionNode;
};

export enum CircleSessionFilterType {
  Upcoming = 'UPCOMING',
  Past = 'PAST',
  Archived = 'ARCHIVED'
}

export type CircleSessionLinkNode = Node & {
  __typename: 'CircleSessionLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  circleSession?: Maybe<CircleSessionNode>;
};

export type CircleSessionNode = Node & {
  __typename: 'CircleSessionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  topic: CircleTopicNode;
  startTime: Scalars['DateTime'];
  facilitators: Array<Maybe<CircleFacilitatorNode>>;
  seatLimit: Scalars['Int'];
  seatsLeft?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
  bookingStatus?: Maybe<CircleSessionBookingStatus>;
  rsvpLink: Scalars['String'];
  archived: Scalars['Boolean'];
  meetingUrl?: Maybe<Scalars['String']>;
  meetingInstructions?: Maybe<Scalars['String']>;
  useInHouseRsvp: Scalars['Boolean'];
  isJoinable: Scalars['Boolean'];
  companyUuid?: Maybe<Scalars['UUID']>;
  isExternalMeetingUrl: Scalars['Boolean'];
  companyName?: Maybe<Scalars['String']>;
  companySurveyUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type CircleSessionRegistrantCollection = {
  __typename: 'CircleSessionRegistrantCollection';
  items: Array<CircleSessionRegistrantNode>;
  totalCount: Scalars['Int'];
};

export type CircleSessionRegistrantCollectionResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleSessionRegistrantCollection;

export type CircleSessionRegistrantNode = {
  __typename: 'CircleSessionRegistrantNode';
  email: Scalars['String'];
  isMember: Scalars['Boolean'];
};

export type CircleSessionRsvpAnswer = {
  __typename: 'CircleSessionRsvpAnswer';
  questionId: Scalars['ID'];
  answer: Scalars['String'];
};

export type CircleSessionSeatLimitExceededError = {
  __typename: 'CircleSessionSeatLimitExceededError';
  message: Scalars['String'];
};

export type CircleSessionsByDateTimeResponse = CircleSessionConnection;

/** A question definition representing a short text answer */
export type CircleShortResponseQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename: 'CircleShortResponseQuestionDefinitionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
};

/** A question representing a single line of text input. */
export type CircleSingleLineQuestionNode = CircleBaseQuestion & {
  __typename: 'CircleSingleLineQuestionNode';
  id: Scalars['ID'];
  required: Scalars['Boolean'];
  questionText: Scalars['String'];
  maxCharacters?: Maybe<Scalars['Int']>;
};

export type CircleSuccessfulResponse = {
  __typename: 'CircleSuccessfulResponse';
  message: Scalars['String'];
};

export type CircleTopicConnection = {
  __typename: 'CircleTopicConnection';
  edges: Array<Maybe<CircleTopicEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleTopicEdge = {
  __typename: 'CircleTopicEdge';
  cursor: Scalars['String'];
  node: CircleTopicNode;
};

export enum CircleTopicFormat {
  Workshop = 'WORKSHOP',
  ListenAndLearn = 'LISTEN_AND_LEARN',
  Fireside = 'FIRESIDE',
  Discussion = 'DISCUSSION'
}

export type CircleTopicLinkNode = Node & {
  __typename: 'CircleTopicLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  circleTopic?: Maybe<CircleTopicNode>;
};

export type CircleTopicNode = Node & {
  __typename: 'CircleTopicNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  series: CircleSeriesNode;
  name: Scalars['String'];
  description: Scalars['String'];
  format: CircleTopicFormat;
  /** Number of minutes */
  duration: Scalars['Int'];
  slug?: Maybe<Scalars['String']>;
  /** The list of questions for RSVPing to sessions in this topic */
  rsvpQuestions: Array<Maybe<CircleQuestion>>;
  /** The list of RsvpQuestionTopic objects */
  rsvpQuestionTopics?: Maybe<Array<Maybe<CircleRsvpQuestionTopicNode>>>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** A special note to indicate content considerations, participation requirements, etc. */
  note?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  surveyUrl?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  /** Deprecated. Use activeCommunityRsvps. When authenticated, this returns a list of active Rsvps for that user. */
  activeRsvps?: Maybe<Array<CircleRsvpNode>>;
  /** A list of active rsvps for company sessions in this topic for the authenticated user. */
  activeCompanyRsvps?: Maybe<Array<CircleRsvpNode>>;
  /** A list of active rsvps for community sessions in this topic for the authenticated user. */
  activeCommunityRsvps?: Maybe<Array<CircleRsvpNode>>;
  /** Company sessions for this topic. companyId is only used to filter sessions if the user is not authenticated. */
  companySessions: Array<CircleSessionNode>;
  /** Community sessions for this topic, excluding already RSVPd sessions for authenticated users. */
  communitySessions: Array<CircleSessionNode>;
  /** All company sessions for this topic for admins */
  allCompanySessions?: Maybe<Array<CircleSessionNode>>;
  /** All Community sessions for this topic for admins */
  allCommunitySessions?: Maybe<Array<CircleSessionNode>>;
  /** Deprecated. Use communitySessions or companySessions. */
  sessions: CircleSessionConnection;
  facilitators: CircleFacilitatorConnection;
};


export type CircleTopicNodeCompanySessionsArgs = {
  companyId?: Maybe<Scalars['ID']>;
};


export type CircleTopicNodeAllCompanySessionsArgs = {
  filterBy?: Maybe<CircleSessionFilterType>;
};


export type CircleTopicNodeAllCommunitySessionsArgs = {
  filterBy?: Maybe<CircleSessionFilterType>;
};


export type CircleTopicNodeSessionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  excludeActiveRsvps?: Maybe<Scalars['Boolean']>;
};


export type CircleTopicNodeFacilitatorsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

/** CircleUpdateFacilitatorDataInput input used for adminUpdateFacilitator mutation */
export type CircleUpdateFacilitatorDataInput = {
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CircleUpdateOnDemandTopicDataInput = {
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  externalVideoUrl?: Maybe<Scalars['String']>;
  facilitatorIds?: Maybe<Array<Scalars['ID']>>;
  languageCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  relatedTopicIds?: Maybe<Array<Scalars['ID']>>;
  seriesId?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

/** CircleUpdateSeriesDataInput input used for updateSeries mutation */
export type CircleUpdateSeriesDataInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  illustrationUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  accessType?: Maybe<Scalars['String']>;
  heroImage?: Maybe<Scalars['String']>;
  heroBackgroundColor?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['Boolean']>;
};

/** CircleUpdateSessionDataInput input used for adminUpdateSession mutation */
export type CircleUpdateSessionDataInput = {
  startTime?: Maybe<Scalars['DateTime']>;
  seatLimit?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  useInHouseRsvp?: Maybe<Scalars['Boolean']>;
  topicId?: Maybe<Scalars['ID']>;
  seatsLeft?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  rsvpLink?: Maybe<Scalars['String']>;
  meetingUrl?: Maybe<Scalars['String']>;
  facilitatorIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isExternalMeetingUrl?: Maybe<Scalars['Boolean']>;
  meetingInstructions?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  companySurveyUrl?: Maybe<Scalars['String']>;
};

/** CircleUpdateTopicDataInput input used for adminUpdateTopic mutation */
export type CircleUpdateTopicDataInput = {
  slug?: Maybe<Scalars['String']>;
  format?: Maybe<CircleTopicFormat>;
  duration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  seriesId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  surveyUrl?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
};

export type CircleUserViewedOnDemandTopicMutationResponse = CirclePermissionDeniedError | CircleNotFoundError | CircleValidationError | CircleSuccessfulResponse;

export type CircleValidationError = {
  __typename: 'CircleValidationError';
  message: Scalars['String'];
};

export type CircleVideoNode = {
  __typename: 'CircleVideoNode';
  durationInSeconds: Scalars['Int'];
  externalVideoUrl: Scalars['String'];
  thumbnail: Scalars['String'];
  poster?: Maybe<Scalars['String']>;
};

export type ClientBucketNode = {
  __typename: 'ClientBucketNode';
  id: Scalars['Int'];
  companyUuid: Scalars['UUID'];
  notifyAccountUuid: Scalars['UUID'];
  bucketName: Scalars['String'];
  automated: Scalars['Boolean'];
  companyFolder?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientFileEventDetailsNode = {
  __typename: 'ClientFileEventDetailsNode';
  events?: Maybe<Array<Maybe<ClientFileEventNode>>>;
  issues?: Maybe<Array<Maybe<ClientFileIssueNode>>>;
  segments?: Maybe<Array<Maybe<ClientFileSegmentNode>>>;
};

export type ClientFileEventNode = {
  __typename: 'ClientFileEventNode';
  event: Scalars['String'];
  metadata?: Maybe<Scalars['Metadata']>;
  createdAt: Scalars['DateTime'];
};

export type ClientFileIssueNode = {
  __typename: 'ClientFileIssueNode';
  issueType: Scalars['String'];
  code: Scalars['String'];
  metadata?: Maybe<Scalars['Metadata']>;
  createdAt: Scalars['DateTime'];
};

export type ClientFileNode = {
  __typename: 'ClientFileNode';
  id: Scalars['Int'];
  companyUuid: Scalars['UUID'];
  source: Scalars['String'];
  originalFilePath: Scalars['String'];
  rowCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  uploader_uuid: Scalars['String'];
  mark_missing_ineligible?: Maybe<Scalars['Boolean']>;
  latest_event?: Maybe<Scalars['String']>;
  isLatestFile?: Maybe<Scalars['Boolean']>;
  existingCount?: Maybe<Scalars['Int']>;
  addedCount?: Maybe<Scalars['Int']>;
  ineligibleCount?: Maybe<Scalars['Int']>;
  invalidCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ClientFileSegmentNode = {
  __typename: 'ClientFileSegmentNode';
  id?: Maybe<Scalars['Int']>;
  filePath: Scalars['String'];
  preprocessedAt?: Maybe<Scalars['DateTime']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
};

export type ClientSummaryNode = Node & {
  __typename: 'ClientSummaryNode';
  memberName: Scalars['String'];
  memberFirstName: Scalars['String'];
  memberLastName: Scalars['String'];
  memberEmail: Scalars['String'];
  memberUuid: Scalars['UUID'];
  companyName: Scalars['String'];
  memberEnrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
  lastVisit?: Maybe<Scalars['DateTime']>;
  nextVisit?: Maybe<Scalars['DateTime']>;
  visitsUsed: Scalars['Int'];
  visitsCovered: Scalars['Int'];
  visitsRemaining: Scalars['Int'];
  lastWho5Score?: Maybe<Scalars['Int']>;
  appInstalled: Scalars['Boolean'];
  id: Scalars['ID'];
  matchStatus?: Maybe<Scalars['String']>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  memberInsuranceStatus?: Maybe<Scalars['String']>;
  isCompanyHpiEnabled?: Maybe<Scalars['Boolean']>;
  isCompanyPsychiatryEnabled?: Maybe<Scalars['Boolean']>;
  phq9SelfharmScore?: Maybe<Scalars['Int']>;
  coachingVisitsToReportCount?: Maybe<Scalars['Int']>;
  isMinor?: Maybe<Scalars['Boolean']>;
  remainingPathwayVisits?: Maybe<Scalars['Int']>;
};

export type ClientSummaryNodeConnection = {
  __typename: 'ClientSummaryNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ClientSummaryNodeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
  edgeCount?: Maybe<Scalars['Int']>;
};

export type ClientSummaryNodeEdge = {
  __typename: 'ClientSummaryNodeEdge';
  node?: Maybe<ClientSummaryNode>;
  cursor: Scalars['String'];
};

export type CoachAssignmentNode = {
  __typename: 'CoachAssignmentNode';
  uuid: Scalars['UUID'];
  coach?: Maybe<CoachNode>;
  createdAt: Scalars['DateTime'];
  active: Scalars['Boolean'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
  coachingVisits: Array<CoachingVisitNode>;
  conversation?: Maybe<ConversationNode>;
  member?: Maybe<MemberNode>;
  intakeForm?: Maybe<IntakeFormNode>;
  displayOnSchedule?: Maybe<Scalars['Boolean']>;
  isPathwayAssignment?: Maybe<Scalars['Boolean']>;
};

export type CoachMemberMatchingNode = {
  __typename: 'CoachMemberMatchingNode';
  id: Scalars['ID'];
  score: Scalars['Float'];
};

export type CoachMemberMatchingUnitNode = {
  __typename: 'CoachMemberMatchingUnitNode';
  results?: Maybe<Array<CoachMemberMatchingNode>>;
  modelMetadata: ModelMetadataNode;
};

export type CoachNode = {
  __typename: 'CoachNode';
  uuid: Scalars['UUID'];
  avatar?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<AccountLocalTimezone>;
  credentials?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  digitalBio?: Maybe<Scalars['String']>;
  providerSchedulingType?: Maybe<AccountProviderSchedulingType>;
  officeHours?: Maybe<Scalars['GenericScalar']>;
  newClientCapacity?: Maybe<Scalars['Int']>;
  providerType?: Maybe<Scalars['String']>;
  psychiatristSubtype?: Maybe<Scalars['String']>;
  providerInvoicingOnly?: Maybe<Scalars['Boolean']>;
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  therapistModalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  bufferTime?: Maybe<Scalars['Int']>;
  lateCancellationThreshold?: Maybe<Scalars['Int']>;
  defaultVisitDuration?: Maybe<Scalars['Int']>;
  maximumMemberSlots?: Maybe<Scalars['Int']>;
  races: Array<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  languagePreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  licensedStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  providerCertifications: Array<ProviderCertificationNode>;
  goalInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  languagePreference?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  matchScore?: Maybe<Scalars['Float']>;
  matchAlgorithmVersion?: Maybe<Scalars['String']>;
  isInAppProvider?: Maybe<Scalars['Boolean']>;
  preferencesMatched?: Maybe<Array<Maybe<MemberFilterPreferenceNode>>>;
  providerNextAvailability?: Maybe<Scalars['String']>;
};


export type CoachNodePreferencesMatchedArgs = {
  preferences: MemberPreferencesInput;
};

export type CoachingVisitClaimable = {
  __typename: 'CoachingVisitClaimable';
  claimable: Scalars['Boolean'];
};

export enum CoachingVisitModalityType {
  Video = 'VIDEO',
  Phone = 'PHONE',
  InPerson = 'IN_PERSON',
  Unknown = 'UNKNOWN'
}

export type CoachingVisitNode = {
  __typename: 'CoachingVisitNode';
  uuid: Scalars['UUID'];
  coachAssignment?: Maybe<CoachAssignmentNode>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  actualDuration?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  isTherapy: Scalars['Boolean'];
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isPsychiatryInitialEvaluation?: Maybe<Scalars['Boolean']>;
  visitInfo?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  state: CoachingVisitState;
  modalityType: CoachingVisitModalityType;
  videoService?: Maybe<Scalars['String']>;
  providerVideoStartTime?: Maybe<Scalars['DateTime']>;
  providerVideoEndTime?: Maybe<Scalars['DateTime']>;
  creationSource?: Maybe<Scalars['String']>;
  videoSessionUrl?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  coachUuid?: Maybe<Scalars['String']>;
  zoomUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<RatingNode>;
  reviews?: Maybe<Array<Maybe<ReviewNode>>>;
  previousProviderReview?: Maybe<CoachingVisitProviderReviewNode>;
  lastTokboxActivity?: Maybe<Scalars['DateTime']>;
  lastZoomActivity?: Maybe<Scalars['DateTime']>;
  googleCalendarEventUrl?: Maybe<Scalars['String']>;
  visitType?: Maybe<Scalars['String']>;
  createdByUuid?: Maybe<Scalars['String']>;
  isPathway?: Maybe<Scalars['Boolean']>;
};

export type CoachingVisitProviderReviewNode = {
  __typename: 'CoachingVisitProviderReviewNode';
  feedbackText?: Maybe<Scalars['String']>;
  abilityToHelpClient: Scalars['Int'];
  workedOnAgreedUponGoals: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
};

export enum CoachingVisitState {
  PendingPayment = 'PENDING_PAYMENT',
  PendingConfirmation = 'PENDING_CONFIRMATION',
  Scheduled = 'SCHEDULED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  LateCancellation = 'LATE_CANCELLATION',
  NoShow = 'NO_SHOW',
  CompletedCredited = 'COMPLETED_CREDITED',
  Unknown = 'UNKNOWN',
  Attended = 'ATTENDED'
}

export enum ColorScheme {
  Violet = 'VIOLET',
  Red = 'RED',
  Blue = 'BLUE',
  Orange = 'ORANGE',
  Cyan = 'CYAN',
  Grayscale = 'GRAYSCALE'
}

export type CompaniesWithSegmentsOutput = CompaniesWithSegmentsSuccessResponse | InternalToolPermissionDeniedError;

export type CompaniesWithSegmentsSuccessResponse = {
  __typename: 'CompaniesWithSegmentsSuccessResponse';
  companies?: Maybe<Array<Maybe<CompanyNode>>>;
};

export type CompanyAdditionalBenefitNode = {
  __typename: 'CompanyAdditionalBenefitNode';
  /** @deprecated Use uuid instead */
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  title: Scalars['String'];
  link: Scalars['String'];
  description: Scalars['String'];
  companies: Array<CompanyDropdownNode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  countries: Array<CountryNode>;
  states?: Maybe<Array<Scalars['String']>>;
  providerName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  topics: Array<TopicOfFocusNode>;
  subtopicOfFocus?: Maybe<SubtopicOfFocusNode>;
  availableForDependents: Scalars['Boolean'];
  isModernHealthAddOn: Scalars['Boolean'];
  source?: Maybe<CompanyAdditionalBenefitSource>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  segments: Array<CompanySegmentNode>;
  messageresourceSet: Array<MessageResourceNode>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  topicsInCommon?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer used. Use countries instead */
  country?: Maybe<CountryNode>;
  /** @deprecated Field no longer used. */
  needHelp?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer used */
  longDescription?: Maybe<Scalars['String']>;
};

export enum CompanyAdditionalBenefitSource {
  DjangoAdmin = 'DJANGO_ADMIN',
  DjangoBulkCsv = 'DJANGO_BULK_CSV',
  SelfServe = 'SELF_SERVE',
  Retool = 'RETOOL'
}

export type CompanyDoesNotExist = {
  __typename: 'CompanyDoesNotExist';
  uuid: Scalars['UUID'];
};

export type CompanyDropdownNode = {
  __typename: 'CompanyDropdownNode';
  name: Scalars['String'];
  uuid: Scalars['UUID'];
  id: Scalars['ID'];
};

export type CompanyFeatureNode = {
  __typename: 'CompanyFeatureNode';
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  latestUpdate?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
  featureType?: Maybe<Scalars['String']>;
};

export type CompanyFeatureStatusNode = {
  __typename: 'CompanyFeatureStatusNode';
  uuid?: Maybe<Scalars['UUID']>;
  companyName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CompanyNode = Node & {
  __typename: 'CompanyNode';
  name: Scalars['String'];
  ssoOnly?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
  coveredCoachingVisits: Scalars['Int'];
  coveredTherapyVisits: Scalars['Int'];
  resetDate: Scalars['Date'];
  specificInfo?: Maybe<Scalars['String']>;
  dependentInvitationFeature: Scalars['Boolean'];
  maximumNumberOfDependents: Scalars['Int'];
  minimumDependentTherapyAge: Scalars['Int'];
  hrEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @deprecated Field no longer used */
  benefitsPageSubheading?: Maybe<Scalars['String']>;
  companySegments: Array<CompanySegmentNode>;
};

export type CompanyOutput = CompanyNode | CompanyDoesNotExist;

export type CompanySegmentInput = {
  uuid?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  companyUuid: Scalars['UUID'];
};

export type CompanySegmentNode = {
  __typename: 'CompanySegmentNode';
  uuid: Scalars['UUID'];
  company: CompanyNode;
  name: Scalars['String'];
  members: Array<MemberNode>;
};

export type CompanySegmentsOutput = CompanySegmentsSuccessResponse | InternalToolPermissionDeniedError;

export type CompanySegmentsSuccessResponse = {
  __typename: 'CompanySegmentsSuccessResponse';
  companySegments?: Maybe<Array<Maybe<CompanySegmentNode>>>;
};

export type CompleteTestPammInitialEvaluation = {
  __typename: 'CompleteTestPammInitialEvaluation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ConfirmVisitWithoutPaymentMutation = {
  __typename: 'ConfirmVisitWithoutPaymentMutation';
  ok?: Maybe<Scalars['Boolean']>;
  sessionState?: Maybe<Scalars['String']>;
};

export type ContentBannerNode = Node & {
  __typename: 'ContentBannerNode';
  imageUrl: Scalars['String'];
  backgroundColor: Scalars['String'];
  id: Scalars['ID'];
};

export type ContentCollectionCreateErrorResponse = {
  __typename: 'ContentCollectionCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionCreateInput = {
  director?: Maybe<ContentCollectionDirectorNames>;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type ContentCollectionCreateOutput = InternalToolPermissionDeniedError | ContentCollectionCreateSuccessResponse | ContentCollectionCreateErrorResponse;

export type ContentCollectionCreateSuccessResponse = {
  __typename: 'ContentCollectionCreateSuccessResponse';
  contentCollection?: Maybe<ContentCollectionNode>;
};

export type ContentCollectionDeleteErrorResponse = {
  __typename: 'ContentCollectionDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionDeleteInput = {
  id: Scalars['ID'];
};

export type ContentCollectionDeleteOutput = InternalToolPermissionDeniedError | ContentCollectionDeleteSuccessResponse | ContentCollectionDeleteErrorResponse;

export type ContentCollectionDeleteSuccessResponse = {
  __typename: 'ContentCollectionDeleteSuccessResponse';
  contentCollection?: Maybe<ContentCollectionNode>;
};

export enum ContentCollectionDesignatedApplication {
  Member = 'MEMBER',
  HrAdmin = 'HR_ADMIN'
}

export enum ContentCollectionDirectorNames {
  ForYou = 'FOR_YOU',
  AllRecommendedContent = 'ALL_RECOMMENDED_CONTENT',
  CirclesRecommendedContent = 'CIRCLES_RECOMMENDED_CONTENT',
  ProgramsRecommendedContent = 'PROGRAMS_RECOMMENDED_CONTENT',
  MeditationsRecommendedContent = 'MEDITATIONS_RECOMMENDED_CONTENT',
  RecommendedContentTags = 'RECOMMENDED_CONTENT_TAGS',
  RecommendedNextStepContent = 'RECOMMENDED_NEXT_STEP_CONTENT',
  YourOneCare = 'YOUR_ONE_CARE',
  ManageCareTeam = 'MANAGE_CARE_TEAM',
  ExploreCareOptions = 'EXPLORE_CARE_OPTIONS',
  ExploreYourTopPicks = 'EXPLORE_YOUR_TOP_PICKS',
  JumpBackIn = 'JUMP_BACK_IN'
}

export type ContentCollectionLinkCreateErrorResponse = {
  __typename: 'ContentCollectionLinkCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkCreateInput = {
  linkType: Scalars['String'];
  mobileValue: Scalars['String'];
  webValue?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  contentCollectionId: Scalars['ID'];
  mediaTypeId?: Maybe<Scalars['ID']>;
  minimumMobileVersion?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkCreateOutput = InternalToolPermissionDeniedError | ContentCollectionLinkCreateSuccessResponse | ContentCollectionLinkCreateErrorResponse;

export type ContentCollectionLinkCreateSuccessResponse = {
  __typename: 'ContentCollectionLinkCreateSuccessResponse';
  contentCollectionLink?: Maybe<ContentCollectionLinkNode>;
};

export type ContentCollectionLinkDeleteErrorResponse = {
  __typename: 'ContentCollectionLinkDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkDeleteInput = {
  id: Scalars['ID'];
};

export type ContentCollectionLinkDeleteOutput = InternalToolPermissionDeniedError | ContentCollectionLinkDeleteSuccessResponse | ContentCollectionLinkDeleteErrorResponse;

export type ContentCollectionLinkDeleteSuccessResponse = {
  __typename: 'ContentCollectionLinkDeleteSuccessResponse';
  contentCollectionLink?: Maybe<ContentCollectionLinkNode>;
};

export enum ContentCollectionLinkLinkType {
  Program = 'PROGRAM',
  Meditation = 'MEDITATION',
  InternalLink = 'INTERNAL_LINK',
  ExternalLink = 'EXTERNAL_LINK',
  CircleTopic = 'CIRCLE_TOPIC',
  CircleSeries = 'CIRCLE_SERIES',
  CircleSession = 'CIRCLE_SESSION'
}

export type ContentCollectionLinkNode = Node & {
  __typename: 'ContentCollectionLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  linkType: Scalars['String'];
  index: Scalars['Int'];
  mobileValue: Scalars['String'];
  webValue?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  contentCollection: ContentCollectionNode;
  slug?: Maybe<Scalars['String']>;
  minimumMobileVersion: Scalars['String'];
  screensectionSet: DataDefinedScreenSectionNodeConnection;
};


export type ContentCollectionLinkNodeScreensectionSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentCollectionLinkNodeConnection = {
  __typename: 'ContentCollectionLinkNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ContentCollectionLinkNodeEdge>>;
};

export type ContentCollectionLinkNodeEdge = {
  __typename: 'ContentCollectionLinkNodeEdge';
  node?: Maybe<ContentCollectionLinkNode>;
  cursor: Scalars['String'];
};

export type ContentCollectionLinkUpdateErrorResponse = {
  __typename: 'ContentCollectionLinkUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkUpdateInput = {
  id: Scalars['ID'];
  linkType: Scalars['String'];
  mobileValue: Scalars['String'];
  webValue?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  mediaTypeId?: Maybe<Scalars['ID']>;
  minimumMobileVersion?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkUpdateOutput = InternalToolPermissionDeniedError | ContentCollectionLinkUpdateSuccessResponse | ContentCollectionLinkUpdateErrorResponse;

export type ContentCollectionLinkUpdateSuccessResponse = {
  __typename: 'ContentCollectionLinkUpdateSuccessResponse';
  contentCollectionLink?: Maybe<ContentCollectionLinkNode>;
};

export type ContentCollectionNode = Node & {
  __typename: 'ContentCollectionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  scheduledContent?: Maybe<ScheduledContentNode>;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  director?: Maybe<ContentCollectionDirectorNames>;
  slug?: Maybe<Scalars['String']>;
  designatedApplication: ContentCollectionDesignatedApplication;
  contentTranslationAvailability: ContentTranslationAvailabilityNodeConnection;
  contentCollectionLinks: Array<Maybe<ContentLinkNode>>;
  screens: GenericScreenNodeConnection;
  sections: DataDefinedScreenSectionNodeConnection;
  activityGroups: CourseActivityGroupNodeConnection;
  pathwaytopicSet: PathwayTopicNodeConnection;
  contentCollectionLinkNodes: Array<Maybe<ContentCollectionLinkNode>>;
  titleTranslationKey: Scalars['String'];
  subtitleTranslationKey?: Maybe<Scalars['String']>;
};


export type ContentCollectionNodeContentTranslationAvailabilityArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodeScreensArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodeSectionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodeActivityGroupsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodePathwaytopicSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentCollectionNodeConnection = {
  __typename: 'ContentCollectionNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ContentCollectionNodeEdge>>;
};

export type ContentCollectionNodeEdge = {
  __typename: 'ContentCollectionNodeEdge';
  node?: Maybe<ContentCollectionNode>;
  cursor: Scalars['String'];
};

export enum ContentCollectionPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB',
  Dhcs = 'DHCS'
}

export enum ContentCollectionRenderComponent {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL',
  Banner = 'BANNER',
  Tile = 'TILE',
  RecommendedNextStepBanner = 'RECOMMENDED_NEXT_STEP_BANNER',
  CareCard = 'CARE_CARD',
  Grid = 'GRID'
}

export type ContentCollectionUpdateErrorResponse = {
  __typename: 'ContentCollectionUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionUpdateInput = {
  id: Scalars['ID'];
  director?: Maybe<ContentCollectionDirectorNames>;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type ContentCollectionUpdateOutput = InternalToolPermissionDeniedError | ContentCollectionUpdateSuccessResponse | ContentCollectionUpdateErrorResponse;

export type ContentCollectionUpdateSuccessResponse = {
  __typename: 'ContentCollectionUpdateSuccessResponse';
  contentCollection?: Maybe<ContentCollectionNode>;
};

export type ContentLanguageCreateErrorResponse = {
  __typename: 'ContentLanguageCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentLanguageCreateInput = {
  name?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
};

export type ContentLanguageCreateOutput = InternalToolPermissionDeniedError | ContentLanguageCreateSuccessResponse | ContentLanguageCreateErrorResponse;

export type ContentLanguageCreateSuccessResponse = {
  __typename: 'ContentLanguageCreateSuccessResponse';
  contentLanguage?: Maybe<ContentLanguageNode>;
};

export type ContentLanguageNode = Node & {
  __typename: 'ContentLanguageNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  onlyShowTranslatedContent: Scalars['Boolean'];
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
  contentTranslationAvailability: ContentTranslationAvailabilityNodeConnection;
  texttracktranslationSet: TextTrackTranslationNodeConnection;
};


export type ContentLanguageNodeContentTranslationAvailabilityArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentLanguageNodeTexttracktranslationSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentLanguageUpdateErrorResponse = {
  __typename: 'ContentLanguageUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentLanguageUpdateInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
};

export type ContentLanguageUpdateOutput = InternalToolPermissionDeniedError | ContentLanguageUpdateSuccessResponse | ContentLanguageUpdateErrorResponse;

export type ContentLanguageUpdateSuccessResponse = {
  __typename: 'ContentLanguageUpdateSuccessResponse';
  contentLanguage?: Maybe<ContentLanguageNode>;
};

export type ContentLinkNode = ProgramLinkNode | MeditationLinkNode | InternalLinkNode | ExternalLinkNode | CircleTopicLinkNode | CircleSeriesLinkNode | CircleSessionLinkNode | ScreenLinkNode | CourseLinkNode | AssessmentLinkNode;

export type ContentNode = {
  __typename: 'ContentNode';
  id: Scalars['ID'];
  score: Scalars['Float'];
  type: ContentType;
};

export type ContentResponsesNode = {
  __typename: 'ContentResponsesNode';
  id: Scalars['ID'];
  account: MemberNode;
  assessmentFlow?: Maybe<AssessmentFlowNode>;
  assessmentJourney?: Maybe<AssessmentJourneyNode>;
  assessment?: Maybe<AssessmentNode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  timestamp: Scalars['DateTime'];
  content?: Maybe<Scalars['JSONString']>;
  delta?: Maybe<Scalars['JSONString']>;
  careRecommendation: Array<CareRecommendationNode>;
  member?: Maybe<MemberNode>;
  who5Score?: Maybe<Scalars['Int']>;
  phq9Score?: Maybe<Scalars['Int']>;
  phq9SelfharmScore?: Maybe<Scalars['Int']>;
  who5Percentile?: Maybe<Scalars['Int']>;
  latestWho5PercentileAverage?: Maybe<Scalars['Int']>;
};

export type ContentSubmissionError = BaseSurveyError & {
  __typename: 'ContentSubmissionError';
  message: Scalars['String'];
  debug: Scalars['String'];
};

export type ContentTagCategoryCreateErrorResponse = {
  __typename: 'ContentTagCategoryCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCategoryCreateInput = {
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ContentTagCategoryCreateOutput = InternalToolPermissionDeniedError | ContentTagCategoryCreateSuccessResponse | ContentTagCategoryCreateErrorResponse;

export type ContentTagCategoryCreateSuccessResponse = {
  __typename: 'ContentTagCategoryCreateSuccessResponse';
  contentTagCategory?: Maybe<ContentTagCategoryNode>;
};

export type ContentTagCategoryDeleteErrorResponse = {
  __typename: 'ContentTagCategoryDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCategoryDeleteInput = {
  id: Scalars['ID'];
};

export type ContentTagCategoryDeleteOutput = InternalToolPermissionDeniedError | ContentTagCategoryDeleteSuccessResponse | ContentTagCategoryDeleteErrorResponse;

export type ContentTagCategoryDeleteSuccessResponse = {
  __typename: 'ContentTagCategoryDeleteSuccessResponse';
  contentTagCategory?: Maybe<ContentTagCategoryNode>;
};

export type ContentTagCategoryNode = Node & {
  __typename: 'ContentTagCategoryNode';
  uuid: Scalars['UUID'];
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  isActive: Scalars['Boolean'];
  contentTags: ContentTagNodeConnection;
  id: Scalars['ID'];
};


export type ContentTagCategoryNodeContentTagsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentTagCategoryUpdateErrorResponse = {
  __typename: 'ContentTagCategoryUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCategoryUpdateInput = {
  id: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ContentTagCategoryUpdateOutput = InternalToolPermissionDeniedError | ContentTagCategoryUpdateSuccessResponse | ContentTagCategoryUpdateErrorResponse;

export type ContentTagCategoryUpdateSuccessResponse = {
  __typename: 'ContentTagCategoryUpdateSuccessResponse';
  contentTagCategory?: Maybe<ContentTagCategoryNode>;
};

export type ContentTagCreateErrorResponse = {
  __typename: 'ContentTagCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCreateInput = {
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  isActive: Scalars['Boolean'];
  image?: Maybe<Scalars['String']>;
  contentTagCategoryId: Scalars['ID'];
};

export type ContentTagCreateOutput = InternalToolPermissionDeniedError | ContentTagCreateSuccessResponse | ContentTagCreateErrorResponse;

export type ContentTagCreateSuccessResponse = {
  __typename: 'ContentTagCreateSuccessResponse';
  contentTag?: Maybe<ContentTagNode>;
};

export type ContentTagDeleteErrorResponse = {
  __typename: 'ContentTagDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagDeleteInput = {
  id: Scalars['ID'];
};

export type ContentTagDeleteOutput = InternalToolPermissionDeniedError | ContentTagDeleteSuccessResponse | ContentTagDeleteErrorResponse;

export type ContentTagDeleteSuccessResponse = {
  __typename: 'ContentTagDeleteSuccessResponse';
  contentTag?: Maybe<ContentTagNode>;
};

export type ContentTagListScreenNode = ScreenNodeInterface & {
  __typename: 'ContentTagListScreenNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
  uuid: Scalars['UUID'];
};

export type ContentTagNode = Node & {
  __typename: 'ContentTagNode';
  uuid: Scalars['UUID'];
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  isActive: Scalars['Boolean'];
  image?: Maybe<Scalars['String']>;
  category: ContentTagCategoryNode;
  contentTagRelations?: Maybe<ContentTagRelationNodeConnection>;
  id: Scalars['ID'];
};


export type ContentTagNodeContentTagRelationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
};

export type ContentTagNodeConnection = {
  __typename: 'ContentTagNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ContentTagNodeEdge>>;
};

export type ContentTagNodeEdge = {
  __typename: 'ContentTagNodeEdge';
  node?: Maybe<ContentTagNode>;
  cursor: Scalars['String'];
};

export type ContentTagRelatedObject = ProgramNode | MeditationNode | CourseNode;

export type ContentTagRelationCreateErrorResponse = {
  __typename: 'ContentTagRelationCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagRelationCreateInput = {
  objectType: ContentTagRelationObjectType;
  objectId: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  contentTagId: Scalars['ID'];
};

export type ContentTagRelationCreateOutput = InternalToolPermissionDeniedError | ContentTagRelationCreateSuccessResponse | ContentTagRelationCreateErrorResponse;

export type ContentTagRelationCreateSuccessResponse = {
  __typename: 'ContentTagRelationCreateSuccessResponse';
  contentTagRelation?: Maybe<ContentTagRelationNode>;
};

export type ContentTagRelationDeleteErrorResponse = {
  __typename: 'ContentTagRelationDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagRelationDeleteInput = {
  id: Scalars['ID'];
};

export type ContentTagRelationDeleteOutput = InternalToolPermissionDeniedError | ContentTagRelationDeleteSuccessResponse | ContentTagRelationDeleteErrorResponse;

export type ContentTagRelationDeleteSuccessResponse = {
  __typename: 'ContentTagRelationDeleteSuccessResponse';
  contentTagRelation?: Maybe<ContentTagRelationNode>;
};

export type ContentTagRelationNode = Node & {
  __typename: 'ContentTagRelationNode';
  uuid: Scalars['UUID'];
  objectType: ContentTagRelationObjectType;
  objectId: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  contentTag: ContentTagNode;
  id: Scalars['ID'];
  objectName?: Maybe<Scalars['String']>;
  relatedObject?: Maybe<ContentTagRelatedObject>;
};

export type ContentTagRelationNodeConnection = {
  __typename: 'ContentTagRelationNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ContentTagRelationNodeEdge>>;
};

export type ContentTagRelationNodeEdge = {
  __typename: 'ContentTagRelationNodeEdge';
  node?: Maybe<ContentTagRelationNode>;
  cursor: Scalars['String'];
};

export enum ContentTagRelationObjectType {
  Program = 'PROGRAM',
  Meditation = 'MEDITATION',
  Course = 'COURSE'
}

export type ContentTagRelationUpdateErrorResponse = {
  __typename: 'ContentTagRelationUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagRelationUpdateInput = {
  id: Scalars['ID'];
  objectType: ContentTagRelationObjectType;
  objectId: Scalars['String'];
  displayOrder?: Maybe<Scalars['Int']>;
  contentTagId: Scalars['ID'];
};

export type ContentTagRelationUpdateOutput = InternalToolPermissionDeniedError | ContentTagRelationUpdateSuccessResponse | ContentTagRelationUpdateErrorResponse;

export type ContentTagRelationUpdateSuccessResponse = {
  __typename: 'ContentTagRelationUpdateSuccessResponse';
  contentTagRelation?: Maybe<ContentTagRelationNode>;
};

export type ContentTagScreenNode = ScreenNodeInterface & {
  __typename: 'ContentTagScreenNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
  uuid: Scalars['UUID'];
};

export type ContentTagUpdateErrorResponse = {
  __typename: 'ContentTagUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagUpdateInput = {
  id: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  isActive: Scalars['Boolean'];
  image?: Maybe<Scalars['String']>;
  contentTagCategoryId: Scalars['ID'];
};

export type ContentTagUpdateOutput = InternalToolPermissionDeniedError | ContentTagUpdateSuccessResponse | ContentTagUpdateErrorResponse;

export type ContentTagUpdateSuccessResponse = {
  __typename: 'ContentTagUpdateSuccessResponse';
  contentTag?: Maybe<ContentTagNode>;
};

export type ContentTranslationAvailabilityCreateErrorResponse = {
  __typename: 'ContentTranslationAvailabilityCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTranslationAvailabilityCreateInput = {
  availabilityState?: Maybe<Scalars['String']>;
  programUuid: Scalars['UUID'];
  languageId: Scalars['ID'];
};

export type ContentTranslationAvailabilityCreateOutput = InternalToolPermissionDeniedError | ContentTranslationAvailabilityCreateSuccessResponse | ContentTranslationAvailabilityCreateErrorResponse;

export type ContentTranslationAvailabilityCreateSuccessResponse = {
  __typename: 'ContentTranslationAvailabilityCreateSuccessResponse';
  contentTranslationAvailability?: Maybe<ContentTranslationAvailabilityNode>;
};

export type ContentTranslationAvailabilityNode = Node & {
  __typename: 'ContentTranslationAvailabilityNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  program?: Maybe<ProgramNode>;
  language?: Maybe<ContentLanguageNode>;
  availabilityState?: Maybe<Scalars['String']>;
  contentCollection?: Maybe<ContentCollectionNode>;
};

export type ContentTranslationAvailabilityNodeConnection = {
  __typename: 'ContentTranslationAvailabilityNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ContentTranslationAvailabilityNodeEdge>>;
};

export type ContentTranslationAvailabilityNodeEdge = {
  __typename: 'ContentTranslationAvailabilityNodeEdge';
  node?: Maybe<ContentTranslationAvailabilityNode>;
  cursor: Scalars['String'];
};

export type ContentTranslationAvailabilityUpdateErrorResponse = {
  __typename: 'ContentTranslationAvailabilityUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTranslationAvailabilityUpdateInput = {
  id: Scalars['ID'];
  availabilityState?: Maybe<Scalars['String']>;
};

export type ContentTranslationAvailabilityUpdateOutput = InternalToolPermissionDeniedError | ContentTranslationAvailabilityUpdateSuccessResponse | ContentTranslationAvailabilityUpdateErrorResponse;

export type ContentTranslationAvailabilityUpdateSuccessResponse = {
  __typename: 'ContentTranslationAvailabilityUpdateSuccessResponse';
  contentTranslationAvailability?: Maybe<ContentTranslationAvailabilityNode>;
};

export type ContentTranslationNode = {
  __typename: 'ContentTranslationNode';
  translationText: Scalars['String'];
  translationKey: Scalars['String'];
  field: Scalars['String'];
};

export enum ContentType {
  Meditation = 'MEDITATION',
  Program = 'PROGRAM',
  Circle = 'CIRCLE'
}

export type ContentUnitNode = {
  __typename: 'ContentUnitNode';
  contents?: Maybe<Array<ContentNode>>;
  modelMetadata: ModelMetadataNode;
};

export enum ConversationKind {
  Coaching = 'COACHING',
  Therapy = 'THERAPY',
  LiveCoaching = 'LIVE_COACHING'
}

export type ConversationNode = Node & {
  __typename: 'ConversationNode';
  uuid?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  coach?: Maybe<CoachNode>;
  member?: Maybe<MemberNode>;
  active: Scalars['Boolean'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  kind?: Maybe<ConversationKind>;
  messages?: Maybe<MessageNodeConnection>;
  newestMessage?: Maybe<MessageNode>;
  myNewestMessage?: Maybe<MessageNode>;
  isNewMatch?: Maybe<Scalars['Boolean']>;
  isMatchedOverFiveDaysAgo?: Maybe<Scalars['Boolean']>;
  oldMatchNotContacted?: Maybe<Scalars['Boolean']>;
  oldestMessage?: Maybe<MessageNode>;
  provider?: Maybe<CoachNode>;
};


export type ConversationNodeMessagesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
};

export type ConversationNodeConnection = {
  __typename: 'ConversationNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ConversationNodeEdge>>;
};

export type ConversationNodeEdge = {
  __typename: 'ConversationNodeEdge';
  node?: Maybe<ConversationNode>;
  cursor: Scalars['String'];
};

export type CostEstimateNode = {
  __typename: 'CostEstimateNode';
  planType?: Maybe<InsurancePlanType>;
  outOfPocketRemaining?: Maybe<Scalars['Float']>;
  copay?: Maybe<Scalars['Float']>;
  coinsurance?: Maybe<Scalars['Float']>;
  remainingDeductible?: Maybe<Scalars['Float']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  estimatedInsuranceResponsibility?: Maybe<Scalars['Float']>;
  error?: Maybe<IneligibleReason>;
  ineligibleReason?: Maybe<IneligibleReason>;
};

export type CostEstimation = {
  __typename: 'CostEstimation';
  planType?: Maybe<Scalars['String']>;
  outOfPocketRemaining?: Maybe<Scalars['Float']>;
  copay?: Maybe<Scalars['Float']>;
  coinsurance?: Maybe<Scalars['Float']>;
  remainingDeductible?: Maybe<Scalars['Float']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  estimatedInsuranceResponsibility?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
};

export type CountryNode = {
  __typename: 'CountryNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  isoCode: Scalars['String'];
  alias?: Maybe<Array<Scalars['String']>>;
  displayOrder: Scalars['Int'];
};

export type CourseActivityGroupCreateErrorResponse = {
  __typename: 'CourseActivityGroupCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseActivityGroupCreateInput = {
  isOptional: Scalars['Boolean'];
  group: CourseActivityGroupGroup;
  courseSectionId?: Maybe<Scalars['ID']>;
  contentCollectionId?: Maybe<Scalars['ID']>;
};

export type CourseActivityGroupCreateOutput = InternalToolPermissionDeniedError | CourseActivityGroupCreateSuccessResponse | CourseActivityGroupCreateErrorResponse;

export type CourseActivityGroupCreateSuccessResponse = {
  __typename: 'CourseActivityGroupCreateSuccessResponse';
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
};

export type CourseActivityGroupDeleteErrorResponse = {
  __typename: 'CourseActivityGroupDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseActivityGroupDeleteInput = {
  id: Scalars['ID'];
};

export type CourseActivityGroupDeleteOutput = InternalToolPermissionDeniedError | CourseActivityGroupDeleteSuccessResponse | CourseActivityGroupDeleteErrorResponse;

export type CourseActivityGroupDeleteSuccessResponse = {
  __typename: 'CourseActivityGroupDeleteSuccessResponse';
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
};

export enum CourseActivityGroupGroup {
  Reflect = 'REFLECT',
  Learn = 'LEARN',
  Practice = 'PRACTICE',
  Connect = 'CONNECT'
}

export type CourseActivityGroupNode = Node & {
  __typename: 'CourseActivityGroupNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  section: CourseSectionNode;
  index: Scalars['Int'];
  group: CourseActivityGroupGroup;
  collection?: Maybe<ContentCollectionNode>;
  isOptional: Scalars['Boolean'];
  title: Scalars['String'];
  groupType?: Maybe<CourseActivityGroupType>;
  activities: Array<CourseActivityNode>;
  activity: CourseActivityNode;
};


export type CourseActivityGroupNodeActivityArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type CourseActivityGroupNodeConnection = {
  __typename: 'CourseActivityGroupNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<CourseActivityGroupNodeEdge>>;
};

export type CourseActivityGroupNodeEdge = {
  __typename: 'CourseActivityGroupNodeEdge';
  node?: Maybe<CourseActivityGroupNode>;
  cursor: Scalars['String'];
};

export enum CourseActivityGroupType {
  Reflect = 'REFLECT',
  Learn = 'LEARN',
  Practice = 'PRACTICE',
  Connect = 'CONNECT'
}

export type CourseActivityGroupUpdateErrorResponse = {
  __typename: 'CourseActivityGroupUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseActivityGroupUpdateInput = {
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  group: CourseActivityGroupGroup;
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  contentCollectionId: Scalars['ID'];
};

export type CourseActivityGroupUpdateOutput = InternalToolPermissionDeniedError | CourseActivityGroupUpdateSuccessResponse | CourseActivityGroupUpdateErrorResponse;

export type CourseActivityGroupUpdateSuccessResponse = {
  __typename: 'CourseActivityGroupUpdateSuccessResponse';
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
};

export type CourseActivityNode = Node & {
  __typename: 'CourseActivityNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  section: CourseSectionNode;
  activityGroup: CourseActivityGroupNode;
  isCompleted: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  contentCollectionLink: ContentLinkNode;
  nextActivity?: Maybe<CourseActivityNode>;
};

export enum CourseAvailabilityState {
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS',
  Everyone = 'EVERYONE'
}

export type CourseCanNotFinishBeforeStarting = {
  __typename: 'CourseCanNotFinishBeforeStarting';
  courseId?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
};

export type CourseCreateErrorResponse = {
  __typename: 'CourseCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseCreateInput = {
  title: Scalars['String'];
  subtitle: Scalars['String'];
  duration: Scalars['Int'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  courseGraphicHeroId?: Maybe<Scalars['ID']>;
  videoContentId?: Maybe<Scalars['ID']>;
  mediaTypeId?: Maybe<Scalars['ID']>;
};

export type CourseCreateOutput = InternalToolPermissionDeniedError | CourseCreateSuccessResponse | CourseCreateErrorResponse;

export type CourseCreateSuccessResponse = {
  __typename: 'CourseCreateSuccessResponse';
  course?: Maybe<CourseNode>;
};

export type CourseDeleteErrorResponse = {
  __typename: 'CourseDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseDeleteInput = {
  id: Scalars['ID'];
};

export type CourseDeleteOutput = InternalToolPermissionDeniedError | CourseDeleteSuccessResponse | CourseDeleteErrorResponse;

export type CourseDeleteSuccessResponse = {
  __typename: 'CourseDeleteSuccessResponse';
  course?: Maybe<CourseNode>;
};

export type CourseDoesNotExist = {
  __typename: 'CourseDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type CourseGraphicHeroNode = Node & {
  __typename: 'CourseGraphicHeroNode';
  uuid: Scalars['UUID'];
  graphic: ImageNode;
  backgroundColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CourseGuideNode = Node & {
  __typename: 'CourseGuideNode';
  course: CourseNode;
  coach?: Maybe<CoachNode>;
  id: Scalars['ID'];
  provider?: Maybe<CoachNode>;
};

export type CourseGuideNodeConnection = {
  __typename: 'CourseGuideNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<CourseGuideNodeEdge>>;
};

export type CourseGuideNodeEdge = {
  __typename: 'CourseGuideNodeEdge';
  node?: Maybe<CourseGuideNode>;
  cursor: Scalars['String'];
};

export type CourseHeroNode = VideoContentNode | ImageNode | CourseGraphicHeroNode;

export type CourseLinkNode = Node & {
  __typename: 'CourseLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  course: CourseNode;
};

export type CourseNode = Node & {
  __typename: 'CourseNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  description: Scalars['String'];
  duration: Scalars['Int'];
  slug: Scalars['String'];
  hero?: Maybe<CourseHeroNode>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  availabilityState: CourseAvailabilityState;
  sections: Array<CourseSectionNode>;
  outcomes: Array<CourseOutcomeNode>;
  guides: Array<CoachNode>;
  progress: CourseProgressNode;
  guideNodes: Array<CourseGuideNode>;
  progressPercent: Scalars['Int'];
  isNew: Scalars['Boolean'];
};

export type CourseNodeConnection = {
  __typename: 'CourseNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<CourseNodeEdge>>;
};

export type CourseNodeEdge = {
  __typename: 'CourseNodeEdge';
  node?: Maybe<CourseNode>;
  cursor: Scalars['String'];
};

export type CourseOutcomeCreateErrorResponse = {
  __typename: 'CourseOutcomeCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseOutcomeCreateInput = {
  icon?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
};

export type CourseOutcomeCreateOutput = InternalToolPermissionDeniedError | CourseOutcomeCreateSuccessResponse | CourseOutcomeCreateErrorResponse;

export type CourseOutcomeCreateSuccessResponse = {
  __typename: 'CourseOutcomeCreateSuccessResponse';
  courseOutcome?: Maybe<CourseOutcomeNode>;
};

export type CourseOutcomeDeleteErrorResponse = {
  __typename: 'CourseOutcomeDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseOutcomeDeleteInput = {
  id: Scalars['ID'];
};

export type CourseOutcomeDeleteOutput = InternalToolPermissionDeniedError | CourseOutcomeDeleteSuccessResponse | CourseOutcomeDeleteErrorResponse;

export type CourseOutcomeDeleteSuccessResponse = {
  __typename: 'CourseOutcomeDeleteSuccessResponse';
  courseOutcome?: Maybe<CourseOutcomeNode>;
};

export type CourseOutcomeNode = Node & {
  __typename: 'CourseOutcomeNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  text: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  textTranslationKey?: Maybe<Scalars['String']>;
};

export type CourseOutcomeUpdateErrorResponse = {
  __typename: 'CourseOutcomeUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseOutcomeUpdateInput = {
  id: Scalars['ID'];
  icon?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type CourseOutcomeUpdateOutput = InternalToolPermissionDeniedError | CourseOutcomeUpdateSuccessResponse | CourseOutcomeUpdateErrorResponse;

export type CourseOutcomeUpdateSuccessResponse = {
  __typename: 'CourseOutcomeUpdateSuccessResponse';
  courseOutcome?: Maybe<CourseOutcomeNode>;
};

export type CourseProgressMutationInput = {
  courseId: Scalars['ID'];
  sectionId: Scalars['ID'];
  activityGroupId: Scalars['ID'];
  activityId: Scalars['ID'];
  platform?: Maybe<Scalars['String']>;
};

export type CourseProgressMutationOutput = CourseProgressMutationResponse | CourseDoesNotExist | SectionDoesNotExist | ActivityGroupDoesNotExist | ActivityDoesNotExist | CourseCanNotFinishBeforeStarting;

export type CourseProgressMutationResponse = {
  __typename: 'CourseProgressMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CourseProgressNode = {
  __typename: 'CourseProgressNode';
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  total: Scalars['Int'];
  completed: Scalars['Int'];
  remaining: Scalars['Int'];
};

export type CourseSectionCreateErrorResponse = {
  __typename: 'CourseSectionCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseSectionCreateInput = {
  title: Scalars['String'];
  subtitle: Scalars['String'];
  courseId?: Maybe<Scalars['ID']>;
};

export type CourseSectionCreateOutput = InternalToolPermissionDeniedError | CourseSectionCreateSuccessResponse | CourseSectionCreateErrorResponse;

export type CourseSectionCreateSuccessResponse = {
  __typename: 'CourseSectionCreateSuccessResponse';
  courseSection?: Maybe<CourseSectionNode>;
};

export type CourseSectionDeleteErrorResponse = {
  __typename: 'CourseSectionDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseSectionDeleteInput = {
  id: Scalars['ID'];
};

export type CourseSectionDeleteOutput = InternalToolPermissionDeniedError | CourseSectionDeleteSuccessResponse | CourseSectionDeleteErrorResponse;

export type CourseSectionDeleteSuccessResponse = {
  __typename: 'CourseSectionDeleteSuccessResponse';
  courseSection?: Maybe<CourseSectionNode>;
};

export type CourseSectionDoesNotExist = {
  __typename: 'CourseSectionDoesNotExist';
  id?: Maybe<Scalars['ID']>;
};

export type CourseSectionNode = Node & {
  __typename: 'CourseSectionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  course: CourseNode;
  index: Scalars['Int'];
  slug: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  activityGroups: Array<CourseActivityGroupNode>;
};

export type CourseSectionReviewInput = {
  sectionId: Scalars['ID'];
  rating: Scalars['Int'];
  whatYouLikedAboutThisSection?: Maybe<Array<Maybe<Scalars['String']>>>;
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  trustTheCourse?: Maybe<Scalars['Int']>;
};

export type CourseSectionReviewResponse = {
  __typename: 'CourseSectionReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CourseSectionUpdateErrorResponse = {
  __typename: 'CourseSectionUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseSectionUpdateInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
};

export type CourseSectionUpdateOutput = InternalToolPermissionDeniedError | CourseSectionUpdateSuccessResponse | CourseSectionUpdateErrorResponse;

export type CourseSectionUpdateSuccessResponse = {
  __typename: 'CourseSectionUpdateSuccessResponse';
  courseSection?: Maybe<CourseSectionNode>;
};

export type CourseUpdateErrorResponse = {
  __typename: 'CourseUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseUpdateInput = {
  id: Scalars['ID'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  duration: Scalars['Int'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  availabilityState: CourseAvailabilityState;
  mediaTypeId?: Maybe<Scalars['ID']>;
};

export type CourseUpdateOutput = InternalToolPermissionDeniedError | CourseUpdateSuccessResponse | CourseUpdateErrorResponse;

export type CourseUpdateSuccessResponse = {
  __typename: 'CourseUpdateSuccessResponse';
  course?: Maybe<CourseNode>;
};

export type CoursesScreenNode = ScreenNodeInterface & {
  __typename: 'CoursesScreenNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  id: Scalars['ID'];
  slug: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type CptCodeNode = {
  __typename: 'CptCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
};

export type CreateAccountDeletionRequest = {
  __typename: 'CreateAccountDeletionRequest';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateClientBucketInput = {
  companyUuid: Scalars['UUID'];
  notifyAccountUuid: Scalars['UUID'];
  bucketName: Scalars['String'];
  automated: Scalars['Boolean'];
  companyFolder?: Maybe<Scalars['String']>;
};

export type CreateClientBucketResponse = {
  __typename: 'CreateClientBucketResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  clientBucket?: Maybe<ClientBucketNode>;
};

export type CreateCoachingVisitMemberReviewMutation = {
  __typename: 'CreateCoachingVisitMemberReviewMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateConversationMutation = {
  __typename: 'CreateConversationMutation';
  conversation?: Maybe<ConversationNode>;
};

export type CreateCourseGuideMutationErrorResponse = {
  __typename: 'CreateCourseGuideMutationErrorResponse';
  message: Scalars['String'];
};

export type CreateCourseGuideMutationInput = {
  courseId: Scalars['ID'];
  providerUuid: Scalars['UUID'];
};

export type CreateCourseGuideMutationOutput = CreateCourseGuideMutationSuccessResponse | CreateCourseGuideMutationErrorResponse;

export type CreateCourseGuideMutationSuccessResponse = {
  __typename: 'CreateCourseGuideMutationSuccessResponse';
  guide?: Maybe<CourseGuideNode>;
};

export type CreateCourseHeroMutationErrorResponse = {
  __typename: 'CreateCourseHeroMutationErrorResponse';
  message: Scalars['String'];
};

export type CreateCourseHeroMutationInput = {
  courseId: Scalars['ID'];
  videoTitle?: Maybe<Scalars['String']>;
  videoSourceHorizontal?: Maybe<Scalars['String']>;
  videoSourceVertical?: Maybe<Scalars['String']>;
  videoTextTrack?: Maybe<Scalars['String']>;
  videoPoster?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageAltText?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
};

export type CreateCourseHeroMutationOutput = CreateCourseHeroMutationSuccessResponse | CreateCourseHeroMutationErrorResponse;

export type CreateCourseHeroMutationSuccessResponse = {
  __typename: 'CreateCourseHeroMutationSuccessResponse';
  hero?: Maybe<CourseHeroNode>;
};

export type CreateEditCompanyAdditionalBenefitOutput = CreateEditCompanyAdditionalBenefitSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCompanyAdditionalBenefitSuccessResponse = {
  __typename: 'CreateEditCompanyAdditionalBenefitSuccessResponse';
  companyAdditionalBenefit?: Maybe<AllCompanyAdditionalBenefitNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCompanySegmentOutput = CreateEditCompanySegmentSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCompanySegmentSuccessResponse = {
  __typename: 'CreateEditCompanySegmentSuccessResponse';
  companySegment?: Maybe<CompanySegmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCrisisProviderCompanyAssignmentOutput = CreateEditCrisisProviderCompanyAssignmentSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCrisisProviderCompanyAssignmentSuccessResponse = {
  __typename: 'CreateEditCrisisProviderCompanyAssignmentSuccessResponse';
  crisisProviderCompanyAssignment?: Maybe<CrisisProviderCompanyAssignmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCrisisProviderCountryAssignmentOutput = CreateEditCrisisProviderCountryAssignmentSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCrisisProviderCountryAssignmentSuccessResponse = {
  __typename: 'CreateEditCrisisProviderCountryAssignmentSuccessResponse';
  crisisProviderCountryAssignment?: Maybe<CrisisProviderCountryAssignmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCrisisProviderOutput = CreateEditCrisisProviderSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCrisisProviderSuccessResponse = {
  __typename: 'CreateEditCrisisProviderSuccessResponse';
  crisisProvider?: Maybe<CrisisProviderNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEligibilityCheckCoachingVisit = {
  coachingVisitUuid: Scalars['UUID'];
  scheduledTime: Scalars['DateTime'];
  productType?: Maybe<Scalars['String']>;
};

export type CreateEligibilityCheckCoachingVisitForMember = {
  memberUuid: Scalars['UUID'];
  coachingVisitUuid: Scalars['UUID'];
  scheduledTime: Scalars['DateTime'];
  productType?: Maybe<Scalars['String']>;
};

export type CreateEligibilityCheckCoachingVisitResponse = {
  __typename: 'CreateEligibilityCheckCoachingVisitResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  eligibilityCheck?: Maybe<EligibilityCheckNode>;
};

export type CreateEventFormattedResponse = CreateEventResult | ExpectedError;

export type CreateEventMutation = {
  __typename: 'CreateEventMutation';
  /** @deprecated Please use the formatted_response field */
  ok?: Maybe<Scalars['Boolean']>;
  /** @deprecated Please use the formatted_response field */
  uuid?: Maybe<Scalars['UUID']>;
  state?: Maybe<Scalars['String']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  formattedResponse?: Maybe<CreateEventFormattedResponse>;
};

export type CreateEventResult = {
  __typename: 'CreateEventResult';
  ok?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
  state?: Maybe<Scalars['String']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  costEstimation?: Maybe<CostEstimation>;
};

export type CreateMemberPathwayMutationInput = {
  pathwayUuid: Scalars['UUID'];
};

export type CreateMemberPathwayMutationResponse = {
  __typename: 'CreateMemberPathwayMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateNotificationMutation = {
  __typename: 'CreateNotificationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdateEmployerCptRateInput = {
  employerInsurance: Scalars['Int'];
  employerCptRates: Array<Maybe<EmployerCptRateInput>>;
};

export type CreateOrUpdateEmployerCptRateResponse = {
  __typename: 'CreateOrUpdateEmployerCptRateResponse';
  ok: Scalars['Boolean'];
  employerCptRates?: Maybe<Array<Maybe<EmployerCptRate>>>;
};

export type CreateOrUpdateEmployerInsuranceInput = {
  id?: Maybe<Scalars['Int']>;
  useAccumulatorConfiguration: Scalars['Boolean'];
  clientId?: Maybe<Scalars['String']>;
  claimCpid?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  insuranceCompany: Scalars['Int'];
  controlNumber: Scalars['String'];
  renderingProviderType: RenderingProviderType;
  benefitStartDate: Scalars['DateTime'];
  benefitEndDate: Scalars['DateTime'];
};

export type CreateOrUpdateEmployerInsuranceResponse = {
  __typename: 'CreateOrUpdateEmployerInsuranceResponse';
  ok: Scalars['Boolean'];
  employerInsurance?: Maybe<EmployerInsurance>;
};

export type CreateOrUpdateInsuranceCompanyInput = {
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  cpid: Scalars['String'];
};

export type CreateOrUpdateInsuranceCompanyResponse = {
  __typename: 'CreateOrUpdateInsuranceCompanyResponse';
  ok: Scalars['Boolean'];
  insuranceCompany?: Maybe<InsuranceCompanyNode>;
};

export type CreateOrUpdatePayerInformationInput = {
  firstName: Scalars['String'];
  lastNameOne: Scalars['String'];
  lastNameTwo?: Maybe<Scalars['String']>;
  addressOne: Scalars['String'];
  addressTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  emailAddress: Scalars['String'];
};

export type CreateOrUpdateProviderReview = {
  __typename: 'CreateOrUpdateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdatePsychiatristReview = {
  __typename: 'CreateOrUpdatePsychiatristReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateProviderReview = {
  __typename: 'CreateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreatePsychiatryVisitMemberReviewMutation = {
  __typename: 'CreatePsychiatryVisitMemberReviewMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTestEligiblePersonResult = {
  __typename: 'CreateTestEligiblePersonResult';
  eligiblePerson: EligiblePersonNode;
  signUpToken: SignUpTokenDetailsNode;
};

export type CreateTestMemberResult = {
  __typename: 'CreateTestMemberResult';
  member?: Maybe<TestMemberNode>;
};

export type CreateTestPammMatch = {
  __typename: 'CreateTestPammMatch';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTestProviderResult = {
  __typename: 'CreateTestProviderResult';
  provider?: Maybe<TestProviderNode>;
};

export type CreateVisitMutation = {
  __typename: 'CreateVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
};

export type CrisisProviderCompanyAssignmentNode = {
  __typename: 'CrisisProviderCompanyAssignmentNode';
  id: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
  crisisProvider: CrisisProviderNode;
  company: CompanyDropdownNode;
  isActive: Scalars['Boolean'];
};

export type CrisisProviderCountryAssignmentNode = {
  __typename: 'CrisisProviderCountryAssignmentNode';
  id: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
  crisisProvider: CrisisProviderNode;
  country: CountryNode;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CrisisProviderNode = {
  __typename: 'CrisisProviderNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  defaultPhoneNumber?: Maybe<Scalars['String']>;
  companyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  countryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
};

export type DailyPauseCalendarReminder = {
  __typename: 'DailyPauseCalendarReminder';
  googleCalendarUrl: Scalars['String'];
  icsUrl: Scalars['String'];
  eventData: CalendarEventNode;
};

export type DataDefinedScreenNode = ScreenNodeInterface & {
  __typename: 'DataDefinedScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type DataDefinedScreenSectionNode = Node & {
  __typename: 'DataDefinedScreenSectionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  collection: ContentCollectionNode;
  screen: GenericScreenNode;
  slug?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  maxContent: Scalars['Int'];
  minContent?: Maybe<Scalars['Int']>;
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  minimumMobileVersion: Scalars['String'];
  ctaContentLink?: Maybe<ContentCollectionLinkNode>;
  ctaLinkText?: Maybe<Scalars['String']>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  showTitle: Scalars['Boolean'];
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  contentCollectionLinks: Array<ContentLinkNode>;
  ctaLink?: Maybe<ContentLinkNode>;
  ctaLinkTextTranslationKey?: Maybe<Scalars['String']>;
};

export type DataDefinedScreenSectionNodeConnection = {
  __typename: 'DataDefinedScreenSectionNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<DataDefinedScreenSectionNodeEdge>>;
};

export type DataDefinedScreenSectionNodeEdge = {
  __typename: 'DataDefinedScreenSectionNodeEdge';
  node?: Maybe<DataDefinedScreenSectionNode>;
  cursor: Scalars['String'];
};



export type DeleteCalendarProfileMutation = {
  __typename: 'DeleteCalendarProfileMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCompanyAdditionalBenefitOutput = DeleteCompanyAdditionalBenefitSuccessResponse | InternalToolPermissionDeniedError;

export type DeleteCompanyAdditionalBenefitSuccessResponse = {
  __typename: 'DeleteCompanyAdditionalBenefitSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCourseGuideMutationErrorResponse = {
  __typename: 'DeleteCourseGuideMutationErrorResponse';
  message: Scalars['String'];
};

export type DeleteCourseGuideMutationInput = {
  guideId: Scalars['ID'];
};

export type DeleteCourseGuideMutationOutput = DeleteCourseGuideMutationSuccessResponse | DeleteCourseGuideMutationErrorResponse;

export type DeleteCourseGuideMutationSuccessResponse = {
  __typename: 'DeleteCourseGuideMutationSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCourseHeroMutationErrorResponse = {
  __typename: 'DeleteCourseHeroMutationErrorResponse';
  message: Scalars['String'];
};

export type DeleteCourseHeroMutationInput = {
  courseId: Scalars['ID'];
};

export type DeleteCourseHeroMutationOutput = DeleteCourseHeroMutationSuccessResponse | DeleteCourseHeroMutationErrorResponse;

export type DeleteCourseHeroMutationSuccessResponse = {
  __typename: 'DeleteCourseHeroMutationSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteTestMember = {
  __typename: 'DeleteTestMember';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteTestProvider = {
  __typename: 'DeleteTestProvider';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum DeviceCategory {
  Mobile = 'MOBILE',
  Web = 'WEB',
  Dhcs = 'DHCS'
}

export enum DifficultyAgreement {
  StronglyDisagree = 'STRONGLY_DISAGREE',
  Disagree = 'DISAGREE',
  NeitherDisagreeOrAgree = 'NEITHER_DISAGREE_OR_AGREE',
  Agree = 'AGREE',
  StronglyAgree = 'STRONGLY_AGREE'
}

export type DisableHrAdminMutationResult = DisableHrAdminSuccessOutput | UnknownHrAdminError | PermissionDeniedError;

export type DisableHrAdminSuccessOutput = {
  __typename: 'DisableHRAdminSuccessOutput';
  ok?: Maybe<Scalars['Boolean']>;
  hrAdmin?: Maybe<HrAdminNode>;
};

export type DownloadAppMutation = {
  __typename: 'DownloadAppMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DxCodeNode = {
  __typename: 'DxCodeNode';
  code?: Maybe<Scalars['String']>;
  dsm?: Maybe<Scalars['String']>;
  primaryGroup?: Maybe<Scalars['String']>;
  secondaryGroup?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EmriPersonNode = {
  __typename: 'EMRIPersonNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  personType: EmriPersonType;
};

export enum EmriPersonType {
  Human = 'HUMAN',
  Superhero = 'SUPERHERO'
}

export type EditHrAdminRoleMutationResult = EditHrAdminRoleSuccessOutput | InvalidRoleError | UnknownHrAdminError | PermissionDeniedError;

export type EditHrAdminRoleSuccessOutput = {
  __typename: 'EditHRAdminRoleSuccessOutput';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type EligibilityCheckNode = {
  __typename: 'EligibilityCheckNode';
  isEligible: Scalars['Boolean'];
  patientResponsibility: Scalars['Float'];
  error?: Maybe<Scalars['String']>;
  costEstimation: CostEstimateNode;
};

export type EligibilityStatusNode = {
  __typename: 'EligibilityStatusNode';
  isEligible?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
};

export type EligiblePersonNode = {
  __typename: 'EligiblePersonNode';
  company?: Maybe<CompanyDropdownNode>;
  uuid: Scalars['UUID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  ineligible: Scalars['Boolean'];
};

export type EmailRoleInput = {
  email: Scalars['String'];
  role: Scalars['String'];
};

export type EmployerCptRate = {
  __typename: 'EmployerCptRate';
  id?: Maybe<Scalars['Int']>;
  cptCodeType: Scalars['Int'];
  serviceType: ServiceType;
  rate?: Maybe<Scalars['Float']>;
  code: Scalars['String'];
  description: Scalars['String'];
  qualifier: Scalars['String'];
  psychiatryVisitType?: Maybe<Scalars['String']>;
};

export type EmployerCptRateInput = {
  id?: Maybe<Scalars['Int']>;
  cptCodeType: Scalars['Int'];
  rate: Scalars['Float'];
};

export type EmployerInsurance = {
  __typename: 'EmployerInsurance';
  id: Scalars['Int'];
  accumulatorConfiguration?: Maybe<Scalars['Int']>;
  clientId?: Maybe<Scalars['String']>;
  claimCpid?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  insuranceCompany: Scalars['Int'];
  controlNumber: Scalars['String'];
  renderingProviderType: RenderingProviderType;
  benefitStartDate: Scalars['DateTime'];
  benefitEndDate: Scalars['DateTime'];
};

export type EmployerInsuranceNode = {
  __typename: 'EmployerInsuranceNode';
  employerInsuranceId: Scalars['Int'];
  name: Scalars['String'];
  policyNumber?: Maybe<Scalars['String']>;
  insuranceCompany: Scalars['Int'];
  accumulatorConfiguration?: Maybe<Scalars['Int']>;
  companyUuid: Scalars['UUID'];
  clientId?: Maybe<Scalars['String']>;
  claimCpid?: Maybe<Scalars['String']>;
  controlNumber: Scalars['String'];
  renderingProviderType: RenderingProviderType;
  benefitStartDate?: Maybe<Scalars['DateTime']>;
  benefitEndDate?: Maybe<Scalars['DateTime']>;
  therapyCptRatesSet?: Maybe<Scalars['Boolean']>;
};

export type EmployerValidationConfigNode = {
  __typename: 'EmployerValidationConfigNode';
  isValid: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type EncryptionError = BaseError & {
  __typename: 'EncryptionError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export enum EnglishLanguageVisibility {
  EnglishOnly = 'ENGLISH_ONLY',
  NonEnglishOnly = 'NON_ENGLISH_ONLY',
  All = 'ALL'
}

export type ExpectedError = {
  __typename: 'ExpectedError';
  debug?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ExploreCareOptionsScreenNode = ScreenNodeInterface & {
  __typename: 'ExploreCareOptionsScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type ExploreScreenNode = ScreenNodeInterface & {
  __typename: 'ExploreScreenNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
  uuid: Scalars['UUID'];
  topics: Array<ScreenSectionNode>;
  activities?: Maybe<ScreenSectionNode>;
};

export type ExternalLinkNode = Node & {
  __typename: 'ExternalLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  url: Scalars['String'];
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type FeatureInvalidFeedbackChoice = {
  __typename: 'FeatureInvalidFeedbackChoice';
  feedbackChoice?: Maybe<Scalars['String']>;
};

export type FeatureRecordDoesNotExist = {
  __typename: 'FeatureRecordDoesNotExist';
  name?: Maybe<Scalars['String']>;
};

export type FeatureRecordReviewInput = {
  isUseful?: Maybe<Scalars['Boolean']>;
  feedbackText?: Maybe<Scalars['String']>;
  feedbackChoice?: Maybe<Scalars['String']>;
  featureRecordName: Scalars['String'];
};

export type FeatureRecordReviewResponse = {
  __typename: 'FeatureRecordReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FeaturedBenefit = {
  __typename: 'FeaturedBenefit';
  /** @deprecated Use uuid instead */
  id?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  title?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer used. */
  needHelp?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export enum FeelingsAboutTherapyEnum {
  Committed = 'COMMITTED',
  Neutral = 'NEUTRAL',
  Hesitant = 'HESITANT'
}

export type FlushModelCacheResponse = {
  __typename: 'FlushModelCacheResponse';
  ok: Scalars['Boolean'];
  errors?: Maybe<Scalars['String']>;
};

export type ForYouScreenNode = ScreenNodeInterface & {
  __typename: 'ForYouScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
  actionsSection: ScreenSectionNode;
};


export type GenericScreenNode = Node & {
  __typename: 'GenericScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  collections: ContentCollectionNodeConnection;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  webMediaTypes: MediaTypeNodeConnection;
  mobileMediaTypes: MediaTypeNodeConnection;
  sections: DataDefinedScreenSectionNodeConnection;
  screenSections: Array<ScreenSectionNode>;
};


export type GenericScreenNodeCollectionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeWebMediaTypesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeMobileMediaTypesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeSectionsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type GenericScreenNodeConnection = {
  __typename: 'GenericScreenNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<GenericScreenNodeEdge>>;
};

export type GenericScreenNodeEdge = {
  __typename: 'GenericScreenNodeEdge';
  node?: Maybe<GenericScreenNode>;
  cursor: Scalars['String'];
};

export type GetAllReportsAndSectionsResult = GetAllReportsAndSectionsSuccessResult | PermissionDeniedError | LookerReportError;

export type GetAllReportsAndSectionsSuccessResult = {
  __typename: 'GetAllReportsAndSectionsSuccessResult';
  reportsOrSections: Array<Maybe<PossibleReportAndSectionType>>;
};

export type GetMemberCostEstimate = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  policyMemberId: Scalars['String'];
  employerInsuranceId: Scalars['Int'];
};

export type GetOrCreateCoachingVisitVideoSessionMutation = {
  __typename: 'GetOrCreateCoachingVisitVideoSessionMutation';
  videoSession?: Maybe<VideoSessionNode>;
};

export type GroupPracticeNode = {
  __typename: 'GroupPracticeNode';
  uuid: Scalars['UUID'];
  providers?: Maybe<Array<Maybe<CoachNode>>>;
};

export type HrAdminAlreadyExistsError = BaseError & {
  __typename: 'HRAdminAlreadyExistsError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type HrAdminCreateErrorResponse = {
  __typename: 'HRAdminCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminCreateInput = {
  isModernHealthCsm: Scalars['Boolean'];
  roleId: Scalars['ID'];
  userEmail: Scalars['String'];
};

export type HrAdminCreateOutput = InternalToolPermissionDeniedError | HrAdminCreateSuccessResponse | HrAdminCreateErrorResponse;

export type HrAdminCreateSuccessResponse = {
  __typename: 'HRAdminCreateSuccessResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrAdminDeleteErrorResponse = {
  __typename: 'HRAdminDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminDeleteInput = {
  id: Scalars['ID'];
};

export type HrAdminDeleteOutput = InternalToolPermissionDeniedError | HrAdminDeleteSuccessResponse | HrAdminDeleteErrorResponse;

export type HrAdminDeleteSuccessResponse = {
  __typename: 'HRAdminDeleteSuccessResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrAdminNode = Node & {
  __typename: 'HRAdminNode';
  uuid: Scalars['UUID'];
  disabledAt?: Maybe<Scalars['DateTime']>;
  role: HrAdminRoleNode;
  isModernHealthCsm: Scalars['Boolean'];
  id: Scalars['ID'];
  eligiblePersons?: Maybe<Array<Maybe<EligiblePersonNode>>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
};

export type HrAdminOutput = HrAdminResponse | InternalToolPermissionDeniedError;

export enum HrAdminPermission {
  AccountsManage = 'ACCOUNTS_MANAGE',
  AccountsView = 'ACCOUNTS_VIEW',
  InsightsView = 'INSIGHTS_VIEW',
  BenefitsManage = 'BENEFITS_MANAGE',
  BenefitsView = 'BENEFITS_VIEW',
  SegmentsManage = 'SEGMENTS_MANAGE',
  SegmentsView = 'SEGMENTS_VIEW',
  HrisManage = 'HRIS_MANAGE',
  HrisView = 'HRIS_VIEW',
  ResourceView = 'RESOURCE_VIEW'
}

export type HrAdminResponse = {
  __typename: 'HRAdminResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrAdminResult = {
  __typename: 'HRAdminResult';
  results?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type HrAdminRoleCreateErrorResponse = {
  __typename: 'HRAdminRoleCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminRoleCreateInput = {
  permissions: Array<HrAdminPermission>;
  name: Scalars['String'];
  description: Scalars['String'];
  hidden: Scalars['Boolean'];
  displayOrder: Scalars['Int'];
};

export type HrAdminRoleCreateOutput = InternalToolPermissionDeniedError | HrAdminRoleCreateSuccessResponse | HrAdminRoleCreateErrorResponse;

export type HrAdminRoleCreateSuccessResponse = {
  __typename: 'HRAdminRoleCreateSuccessResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminRoleDeleteErrorResponse = {
  __typename: 'HRAdminRoleDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminRoleDeleteInput = {
  id: Scalars['ID'];
};

export type HrAdminRoleDeleteOutput = InternalToolPermissionDeniedError | HrAdminRoleDeleteSuccessResponse | HrAdminRoleDeleteErrorResponse;

export type HrAdminRoleDeleteSuccessResponse = {
  __typename: 'HRAdminRoleDeleteSuccessResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminRoleNode = Node & {
  __typename: 'HRAdminRoleNode';
  uuid: Scalars['UUID'];
  key: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  hidden: Scalars['Boolean'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  permissions: Array<HrAdminPermission>;
};

export type HrAdminRoleOutput = HrAdminRoleResponse | InternalToolPermissionDeniedError;

export type HrAdminRoleResponse = {
  __typename: 'HRAdminRoleResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminRoleUpdateErrorResponse = {
  __typename: 'HRAdminRoleUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminRoleUpdateInput = {
  id: Scalars['ID'];
  permissions: Array<HrAdminPermission>;
  name: Scalars['String'];
  description: Scalars['String'];
  hidden: Scalars['Boolean'];
  displayOrder: Scalars['Int'];
};

export type HrAdminRoleUpdateOutput = InternalToolPermissionDeniedError | HrAdminRoleUpdateSuccessResponse | HrAdminRoleUpdateErrorResponse;

export type HrAdminRoleUpdateSuccessResponse = {
  __typename: 'HRAdminRoleUpdateSuccessResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminUpdateErrorResponse = {
  __typename: 'HRAdminUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminUpdateInput = {
  id: Scalars['ID'];
  isModernHealthCsm: Scalars['Boolean'];
  roleId: Scalars['ID'];
  disabled: Scalars['Boolean'];
};

export type HrAdminUpdateOutput = InternalToolPermissionDeniedError | HrAdminUpdateSuccessResponse | HrAdminUpdateErrorResponse;

export type HrAdminUpdateSuccessResponse = {
  __typename: 'HRAdminUpdateSuccessResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrCompanySegmentInput = {
  uuid?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
};

export type HrCreateEditCompanyAdditionalBenefitMutation = {
  __typename: 'HRCreateEditCompanyAdditionalBenefitMutation';
  companyAdditionalBenefit?: Maybe<CompanyAdditionalBenefitNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrCreateEditCompanySegmentMutation = {
  __typename: 'HRCreateEditCompanySegmentMutation';
  companySegment?: Maybe<CompanySegmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrDeleteCompanyAdditionalBenefitMutation = {
  __typename: 'HRDeleteCompanyAdditionalBenefitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrDeleteCompanySegmentMutation = {
  __typename: 'HRDeleteCompanySegmentMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrisAppInfo = {
  appName: Scalars['String'];
  appUuid: Scalars['UUID'];
};

export type HrisAuthInfo = {
  publicToken: Scalars['String'];
};

export type HrisConnectTokenOutput = HrisConnectTokenResult | PermissionDeniedError | HrisRequestError;

export type HrisConnectTokenResult = {
  __typename: 'HRISConnectTokenResult';
  token?: Maybe<Scalars['String']>;
};

export type HrisConnectionNode = {
  __typename: 'HRISConnectionNode';
  createdTime: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  hrAdmin?: Maybe<HrAdminNode>;
  appName: Scalars['String'];
  appUuid: Scalars['UUID'];
  disabledAt?: Maybe<Scalars['DateTime']>;
};

export type HrisConnectionsOutput = HrisConnectionsResult | PermissionDeniedError | HrisRequestError;

export type HrisConnectionsResult = {
  __typename: 'HRISConnectionsResult';
  connections?: Maybe<Array<Maybe<HrisConnectionNode>>>;
};

export type HrisRequestError = BaseError & {
  __typename: 'HRISRequestError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type HrMessageNode = {
  __typename: 'HRMessageNode';
  uuid: Scalars['UUID'];
  companyUuid: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  contentLinks?: Maybe<Array<Maybe<HrMonitorContentLinkNode>>>;
};

export type HrMessages = {
  __typename: 'HRMessages';
  results?: Maybe<Array<Maybe<HrMessageNode>>>;
};

export type HrMessagesResult = HrMessages | PermissionDeniedError;

export type HrMonitorContentLinkNode = {
  __typename: 'HRMonitorContentLinkNode';
  webValue?: Maybe<Scalars['String']>;
  bannerContent: Scalars['String'];
  bannerCtaText: Scalars['String'];
  accentColor?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  bannerTitle?: Maybe<Scalars['String']>;
  bannerSubtitle?: Maybe<Scalars['String']>;
  bannerImage?: Maybe<Scalars['String']>;
};

export type HealthPlanCompaniesOutput = HealthPlanCompaniesResponse | InternalToolPermissionDeniedError;

export type HealthPlanCompaniesResponse = {
  __typename: 'HealthPlanCompaniesResponse';
  companies?: Maybe<Array<Maybe<CompanyFeatureStatusNode>>>;
};

export type HomeScreenNode = ScreenNodeInterface & {
  __typename: 'HomeScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
  scheduledContent?: Maybe<ScheduledContentNode>;
  featuredSection: ScreenSectionNode;
};

export type ImageNode = Node & {
  __typename: 'ImageNode';
  uuid: Scalars['UUID'];
  url: Scalars['String'];
  altText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type InAppReviewFlowCompletedMutation = {
  __typename: 'InAppReviewFlowCompletedMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum InAppReviewStore {
  AppStore = 'APP_STORE',
  PlayStore = 'PLAY_STORE'
}

export enum IneligibleReason {
  InvalidInput = 'INVALID_INPUT',
  InvalidDateRange = 'INVALID_DATE_RANGE',
  NoCoverage = 'NO_COVERAGE'
}

export type InsuranceCompanyNode = {
  __typename: 'InsuranceCompanyNode';
  id: Scalars['Int'];
  name: Scalars['String'];
  cpid: Scalars['String'];
  supportsMulticlientAccumulator: Scalars['Boolean'];
};

export enum InsurancePlanType {
  Ppo = 'PPO',
  Hdhp = 'HDHP'
}

export enum IntakeFormCompletedOnPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type IntakeFormNode = {
  __typename: 'IntakeFormNode';
  uuid: Scalars['UUID'];
  completedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  providerViewedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<MemberNode>;
  completedOnPlatform?: Maybe<IntakeFormCompletedOnPlatform>;
  exitedAt?: Maybe<Scalars['String']>;
  submitted: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  intakeFormQuestionResponses?: Maybe<Array<Maybe<IntakeFormQuestionResponseNode>>>;
};

export type IntakeFormQuestionResponseInputNode = {
  motivationToSeekCoaching?: Maybe<Scalars['String']>;
  outcomesToAchieveOne?: Maybe<Scalars['String']>;
  outcomesToAchieveTwo?: Maybe<Scalars['String']>;
  outcomesToAchieveThree?: Maybe<Scalars['String']>;
  currentPersonalAndProfessionalLife?: Maybe<Scalars['String']>;
  postSessionsPersonalAndProfessionalLife?: Maybe<Scalars['String']>;
  rankSupportAccountability?: Maybe<Scalars['Int']>;
  rankSupportBrainStorming?: Maybe<Scalars['Int']>;
  rankSupportExploringObstacles?: Maybe<Scalars['Int']>;
  rankSupportInsightIntoPotential?: Maybe<Scalars['Int']>;
  rankSupportVision?: Maybe<Scalars['Int']>;
  rankSupportEncouragement?: Maybe<Scalars['Int']>;
  howAreYouDerivingValue?: Maybe<Scalars['String']>;
  experiencedCoachingBefore?: Maybe<Array<Maybe<Scalars['String']>>>;
  anythingElse?: Maybe<Scalars['String']>;
};

export type IntakeFormQuestionResponseNode = {
  __typename: 'IntakeFormQuestionResponseNode';
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  intakeForm: IntakeFormNode;
  questionName?: Maybe<Scalars['String']>;
  questionResponseContent?: Maybe<Scalars['GenericScalar']>;
};

export type InternalLinkNode = Node & {
  __typename: 'InternalLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  path: Scalars['String'];
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  buttonTextTranslationKey?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  colorScheme?: Maybe<ColorScheme>;
  providerInitials?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  labelText?: Maybe<Scalars['String']>;
  labelTextTranslationKey?: Maybe<Scalars['String']>;
  labelVariant?: Maybe<Scalars['String']>;
  recommended?: Maybe<Scalars['Boolean']>;
  childLinks?: Maybe<Array<Maybe<InternalLinkNode>>>;
  backgroundImage?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  additionalInformationTitle?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Scalars['String']>;
  groupKey?: Maybe<Scalars['String']>;
};

export type InternalToolDeleteOutput = InternalToolDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type InternalToolDeleteSuccessResponse = {
  __typename: 'InternalToolDeleteSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InternalToolPermissionDeniedError = {
  __typename: 'InternalToolPermissionDeniedError';
  message?: Maybe<Scalars['String']>;
};

export type InvalidArgumentError = BaseSurveyError & {
  __typename: 'InvalidArgumentError';
  message: Scalars['String'];
  debug: Scalars['String'];
};

export type InvalidEmailError = BaseError & {
  __typename: 'InvalidEmailError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type InvalidEnvironmentError = {
  __typename: 'InvalidEnvironmentError';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type InvalidRoleError = BaseError & {
  __typename: 'InvalidRoleError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type InviteBulkHrAdminEmailError = {
  __typename: 'InviteBulkHRAdminEmailError';
  errors: Array<Maybe<InviteBulkHrAdminEmailErrorDetail>>;
};

export type InviteBulkHrAdminEmailErrorDetail = {
  __typename: 'InviteBulkHRAdminEmailErrorDetail';
  error: InviteBulkHrAdminEmailErrorOutput;
  email: Scalars['String'];
};

export type InviteBulkHrAdminEmailErrorOutput = InvalidEmailError | HrAdminAlreadyExistsError | UnknownUserError;

export type InviteBulkHrAdminResult = InviteBulkHrAdminSuccessOutput | InviteBulkHrAdminEmailError | InvalidRoleError | PermissionDeniedError;

export type InviteBulkHrAdminSuccessOutput = {
  __typename: 'InviteBulkHRAdminSuccessOutput';
  hrAdmins?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type InviteDependentErrorResponse = {
  __typename: 'InviteDependentErrorResponse';
  message: Scalars['String'];
};

export type InviteDependentInput = {
  platform: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  dateOfBirth: Scalars['String'];
  dependentRelation: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  specialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  anythingElse?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type InviteDependentOutput = InviteDependentSuccessResponse | InviteDependentErrorResponse;

export type InviteDependentSuccessResponse = {
  __typename: 'InviteDependentSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InviteHrAdminMutationResult = InviteHrAdminSuccessOutput | InvalidEmailError | PermissionDeniedError | UnknownUserError;

export type InviteHrAdminSuccessOutput = {
  __typename: 'InviteHRAdminSuccessOutput';
  ok?: Maybe<Scalars['Boolean']>;
  hrAdmin?: Maybe<HrAdminNode>;
};


export type LanguageNode = {
  __typename: 'LanguageNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  code: Scalars['String'];
  nativeName: Scalars['String'];
};

export type LaunchOpsCompanyNode = {
  __typename: 'LaunchOpsCompanyNode';
  name: Scalars['String'];
  ssoEnabled: Scalars['Boolean'];
  ssoOnly?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
  companySegments: Array<CompanySegmentNode>;
};

export type LinkCronofyCalendarMutation = {
  __typename: 'LinkCronofyCalendarMutation';
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type ListHrAdminQueryOutput = UnknownCompanyError | HrAdminResult | PermissionDeniedError;

export type LogHrisConnectionInput = {
  appInfo: HrisAppInfo;
  authInfo: HrisAuthInfo;
};

export type LogHrisConnectionPayload = {
  __typename: 'LogHRISConnectionPayload';
  connection?: Maybe<HrisConnectionNode>;
};

export type LogHrisConnectionResult = HrisRequestError | LogHrisConnectionPayload | PermissionDeniedError | EncryptionError;

export type LookerReportError = BaseError & {
  __typename: 'LookerReportError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type LookerSsoEmbedLink = {
  __typename: 'LookerSsoEmbedLink';
  url?: Maybe<Scalars['String']>;
};

export type LookerSsoEmbedResult = LookerSsoEmbedLink | PermissionDeniedError | UnknownCompanyError | UnknownReportTypeError;

export type ManageCareTeamScreenNode = ScreenNodeInterface & {
  __typename: 'ManageCareTeamScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type MarkCoachingVisitEnd = {
  __typename: 'MarkCoachingVisitEnd';
  ok?: Maybe<Scalars['Boolean']>;
};

export type MarkCoachingVisitStart = {
  __typename: 'MarkCoachingVisitStart';
  ok?: Maybe<Scalars['Boolean']>;
};

export type MatchedProvidersMutation = {
  __typename: 'MatchedProvidersMutation';
  providersMatchedPreferences?: Maybe<Array<Maybe<CoachNode>>>;
  providersDidNotMatchPreferences?: Maybe<Array<Maybe<CoachNode>>>;
  allowsFiltering?: Maybe<Scalars['Boolean']>;
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type MediaTypeCreateErrorResponse = {
  __typename: 'MediaTypeCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type MediaTypeCreateInput = {
  name: Scalars['String'];
  icon: Scalars['String'];
  webScreenId?: Maybe<Scalars['ID']>;
  mobileScreenId?: Maybe<Scalars['ID']>;
};

export type MediaTypeCreateOutput = InternalToolPermissionDeniedError | MediaTypeCreateSuccessResponse | MediaTypeCreateErrorResponse;

export type MediaTypeCreateSuccessResponse = {
  __typename: 'MediaTypeCreateSuccessResponse';
  mediaType?: Maybe<MediaTypeNode>;
};

export type MediaTypeDeleteErrorResponse = {
  __typename: 'MediaTypeDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type MediaTypeDeleteInput = {
  id: Scalars['ID'];
};

export type MediaTypeDeleteOutput = InternalToolPermissionDeniedError | MediaTypeDeleteSuccessResponse | MediaTypeDeleteErrorResponse;

export type MediaTypeDeleteSuccessResponse = {
  __typename: 'MediaTypeDeleteSuccessResponse';
  mediaType?: Maybe<MediaTypeNode>;
};

export type MediaTypeNode = Node & {
  __typename: 'MediaTypeNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  icon: Scalars['String'];
  webScreen?: Maybe<ScreenNode>;
  mobileScreen?: Maybe<ScreenNode>;
  programSet: Array<ProgramNode>;
  videocontentSet: VideoContentNodeConnection;
  scheduledcontentSet: ScheduledContentNodeConnection;
  scheduledcontentlinkSet: Array<ScheduledContentLinkNode>;
  contentcollectionlinkSet: ContentCollectionLinkNodeConnection;
  courseSet: CourseNodeConnection;
  meditationSet: Array<MeditationNode>;
  hrmonitorcontentlinkSet: Array<HrMonitorContentLinkNode>;
  screen?: Maybe<ScreenNode>;
};


export type MediaTypeNodeVideocontentSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeScheduledcontentSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeContentcollectionlinkSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeCourseSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type MediaTypeNodeConnection = {
  __typename: 'MediaTypeNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<MediaTypeNodeEdge>>;
};

export type MediaTypeNodeEdge = {
  __typename: 'MediaTypeNodeEdge';
  node?: Maybe<MediaTypeNode>;
  cursor: Scalars['String'];
};

export type MediaTypeUpdateErrorResponse = {
  __typename: 'MediaTypeUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type MediaTypeUpdateInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  icon: Scalars['String'];
  webScreenId?: Maybe<Scalars['ID']>;
  mobileScreenId?: Maybe<Scalars['ID']>;
};

export type MediaTypeUpdateOutput = InternalToolPermissionDeniedError | MediaTypeUpdateSuccessResponse | MediaTypeUpdateErrorResponse;

export type MediaTypeUpdateSuccessResponse = {
  __typename: 'MediaTypeUpdateSuccessResponse';
  mediaType?: Maybe<MediaTypeNode>;
};

export type MeditationCategoryNode = {
  __typename: 'MeditationCategoryNode';
  displayOrder: Scalars['Int'];
  meditations?: Maybe<Array<Maybe<MeditationNode>>>;
  displayName: Scalars['String'];
};


export type MeditationCategoryNodeMeditationsArgs = {
  languageCode?: Maybe<Scalars['String']>;
};

export type MeditationFinishMutation = {
  __typename: 'MeditationFinishMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export enum MeditationLanguageCode {
  EnUs = 'EN_US',
  Es = 'ES',
  FrCa = 'FR_CA',
  Fr = 'FR',
  Ko = 'KO',
  Ja = 'JA',
  ZhHans = 'ZH_HANS',
  De = 'DE',
  Hi = 'HI',
  Pt = 'PT',
  My = 'MY',
  It = 'IT',
  Pl = 'PL'
}

export type MeditationLinkNode = Node & {
  __typename: 'MeditationLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  meditation: MeditationNode;
};

export type MeditationNode = {
  __typename: 'MeditationNode';
  id: Scalars['Int'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  category: Scalars['String'];
  meditationCategory?: Maybe<MeditationCategoryNode>;
  duration: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  audioFile: Scalars['String'];
  defaultOrdering?: Maybe<Scalars['Int']>;
  languageCode: MeditationLanguageCode;
  slug?: Maybe<Scalars['String']>;
  hideFromIndexQueries?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  messageResources: Array<MessageResourceNode>;
  meditationProgress: Array<MeditationProgressNode>;
  meditationId: Scalars['Int'];
  progress: Array<MeditationProgressNode>;
  audioFileTranslationKey: Scalars['String'];
  nameTranslationKey: Scalars['String'];
  categoryTranslationKey?: Maybe<Scalars['String']>;
  progressPercent: Scalars['Int'];
  isNew: Scalars['Boolean'];
};

export type MeditationProgressNode = {
  __typename: 'MeditationProgressNode';
  id: Scalars['ID'];
  owner: MemberNode;
  meditation?: Maybe<MeditationNode>;
  meditationName?: Maybe<Scalars['String']>;
  pillarWeek?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  progressPercentage?: Maybe<Scalars['Float']>;
};

export type MeditationStartMutation = {
  __typename: 'MeditationStartMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export type MeditationUpdateProgressMutation = {
  __typename: 'MeditationUpdateProgressMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export type MeditationsScreenNode = ScreenNodeInterface & {
  __typename: 'MeditationsScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export enum MemberAvailability {
  Morning = 'Morning',
  Afternoon = 'Afternoon',
  Evening = 'Evening'
}

export enum MemberCarePreferenceFeelingsAboutTherapy {
  Committed = 'COMMITTED',
  Neutral = 'NEUTRAL',
  Hesitant = 'HESITANT'
}

export type MemberCarePreferenceNode = {
  __typename: 'MemberCarePreferenceNode';
  id: Scalars['ID'];
  member: MemberNode;
  specialtiesSelected?: Maybe<Array<Scalars['String']>>;
  otherSpecialtiesFreeform?: Maybe<Scalars['String']>;
  feelingsAboutTherapy?: Maybe<MemberCarePreferenceFeelingsAboutTherapy>;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
};

export type MemberFilterPreferenceNode = {
  __typename: 'MemberFilterPreferenceNode';
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<MemberFilterPreferenceOptionNode>>>;
  title?: Maybe<Scalars['String']>;
};

export type MemberFilterPreferenceOptionNode = {
  __typename: 'MemberFilterPreferenceOptionNode';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MemberInput = {
  birth_date_m?: Maybe<Scalars['Int']>;
  gender_m?: Maybe<Scalars['String']>;
  recommendation_m?: Maybe<Scalars['String']>;
  triage_score_m?: Maybe<Scalars['Float']>;
  modality_preference_m?: Maybe<Scalars['String']>;
  is_downloaded_m?: Maybe<Scalars['Int']>;
  is_dependent_m?: Maybe<Scalars['Int']>;
  first_risk_color_m?: Maybe<Scalars['String']>;
  specialties_selected_01_m?: Maybe<Scalars['String']>;
  specialties_selected_02_m?: Maybe<Scalars['String']>;
  specialties_selected_03_m?: Maybe<Scalars['String']>;
  goal_category_01_m?: Maybe<Scalars['String']>;
  goal_category_02_m?: Maybe<Scalars['String']>;
  goal_category_03_m?: Maybe<Scalars['String']>;
  topic_of_focus_01_m?: Maybe<Scalars['String']>;
  topic_of_focus_02_m?: Maybe<Scalars['String']>;
  topic_of_focus_03_m?: Maybe<Scalars['String']>;
  subtopic_of_focus_01_m?: Maybe<Scalars['String']>;
  subtopic_of_focus_02_m?: Maybe<Scalars['String']>;
  subtopic_of_focus_03_m?: Maybe<Scalars['String']>;
  feelings_about_therapy_m?: Maybe<Scalars['String']>;
  language_preferences_m?: Maybe<Scalars['String']>;
  employment_health_althoughsick_m?: Maybe<Scalars['Float']>;
  employment_health_burnedout_m?: Maybe<Scalars['Float']>;
  employment_health_recommendcompany_m?: Maybe<Scalars['Float']>;
  employment_health_stickness_m?: Maybe<Scalars['Float']>;
  employment_health_score_m?: Maybe<Scalars['Float']>;
  gad2_nervous_m?: Maybe<Scalars['Float']>;
  gad2_worrying_m?: Maybe<Scalars['Float']>;
  gad2_score_m?: Maybe<Scalars['Float']>;
  phq2_feelingdown_m?: Maybe<Scalars['Float']>;
  phq2_littleinterest_m?: Maybe<Scalars['Float']>;
  phq2_score_m?: Maybe<Scalars['Float']>;
  who5_activevigorous_m?: Maybe<Scalars['Float']>;
  who5_calmrelaxed_m?: Maybe<Scalars['Float']>;
  who5_freshrested_m?: Maybe<Scalars['Float']>;
  who5_goodspirits_m?: Maybe<Scalars['Float']>;
  who5_score_m?: Maybe<Scalars['Float']>;
};

export type MemberInsuranceNode = {
  __typename: 'MemberInsuranceNode';
  employerInsuranceId?: Maybe<Scalars['String']>;
  policyMemberId?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  relationshipCode?: Maybe<Scalars['String']>;
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
};

export type MemberNode = {
  __typename: 'MemberNode';
  company?: Maybe<CompanyNode>;
  uuid: Scalars['UUID'];
  avatar?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  defaultVisitDuration: Scalars['Float'];
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  languagePreferences: Array<Scalars['String']>;
  goalInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
  birthDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  joinedAt: Scalars['Date'];
  phoneNumber?: Maybe<Scalars['String']>;
  allowNotifications: Scalars['Boolean'];
  role: AccountRole;
  isTest?: Maybe<Scalars['Boolean']>;
  oldEmailAddress?: Maybe<Scalars['String']>;
  newEmailAddressNotConfirmed?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  onboardingStatus?: Maybe<AccountOnboardingStatus>;
  availability?: Maybe<Array<Scalars['String']>>;
  clevertapId?: Maybe<Scalars['String']>;
  registrationSource?: Maybe<Scalars['String']>;
  insuranceStatus?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferencesNode>;
  careRecommendations: Array<CareRecommendationNode>;
  surveys: Array<Who5SurveyNode>;
  phq9SelfharmScores?: Maybe<Array<Maybe<Phq9SelfharmScoreNode>>>;
  age?: Maybe<Scalars['Int']>;
  parentUuid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  isDependent?: Maybe<Scalars['Boolean']>;
  languagePreference?: Maybe<Scalars['String']>;
  lastActive?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  visitsRemaining?: Maybe<VisitsRemainingNode>;
  psychiatryVisitsCompleted?: Maybe<PsychiatryVisitsCompletedNode>;
  coachAssignments?: Maybe<Array<Maybe<CoachAssignmentNode>>>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']>;
  lastVisitCompletedAt?: Maybe<Scalars['DateTime']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  companyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  crisisProviderCompanyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  crisisProviderCountryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  crisisProviders?: Maybe<Array<Maybe<CrisisProviderNode>>>;
  eligiblePersonEmail?: Maybe<Scalars['String']>;
  isActiveCobraRifMember?: Maybe<Scalars['Boolean']>;
  conversationsWithUnreadMessages?: Maybe<Array<Maybe<ConversationNode>>>;
  intakeForm?: Maybe<IntakeFormNode>;
  therapyAccessShortcut?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer used after feature flag removed */
  phq9Access?: Maybe<Phq9Access>;
  featuredBenefits?: Maybe<Array<Maybe<FeaturedBenefit>>>;
  isEnrolledInAutopayments?: Maybe<Scalars['Boolean']>;
  isCompanyHpiEnabled?: Maybe<Scalars['Boolean']>;
  isCompanyPsychiatryEnabled?: Maybe<Scalars['Boolean']>;
  topicSelectionGroup?: Maybe<TopicSelectionGroupNode>;
  sharedPreferences?: Maybe<Array<Maybe<AccountSharedPreferencesRecordNode>>>;
  isAccountDeletionInProgress?: Maybe<Scalars['Boolean']>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
  contentLanguage?: Maybe<ContentLanguageNode>;
  companySegment?: Maybe<CompanySegmentNode>;
};

export type MemberNonPhiNode = {
  __typename: 'MemberNonPHINode';
  company?: Maybe<CompanyDropdownNode>;
  uuid: Scalars['UUID'];
  avatar?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<AccountLocalTimezone>;
  credentials?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  digitalBio?: Maybe<Scalars['String']>;
  providerSchedulingType?: Maybe<AccountProviderSchedulingType>;
  officeHours: Scalars['JSONString'];
  newClientCapacity?: Maybe<Scalars['Int']>;
  providerType?: Maybe<AccountProviderType>;
  psychiatristSubtype?: Maybe<AccountPsychiatristSubtype>;
  providerInvoicingOnly: Scalars['Boolean'];
  providerSpecialties?: Maybe<Array<Scalars['String']>>;
  therapistModalities?: Maybe<Array<Scalars['String']>>;
  bufferTime: Scalars['Float'];
  lateCancellationThreshold: Scalars['Float'];
  defaultVisitDuration: Scalars['Float'];
  maximumMemberSlots?: Maybe<Scalars['Int']>;
  races: Array<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  languagePreferences: Array<Scalars['String']>;
  licensedStates: Array<Scalars['String']>;
  providerCertifications: Array<ProviderCertificationNode>;
  providers: Array<MemberNode>;
  id: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  scimId?: Maybe<Scalars['String']>;
  scimExternalId?: Maybe<Scalars['String']>;
  scimUsername?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  joinedAt: Scalars['Date'];
  therapyAccessShortcut: Scalars['Boolean'];
  mailingAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  allowNotifications: Scalars['Boolean'];
  role: AccountRole;
  isTest: Scalars['Boolean'];
  isContentReviewer: Scalars['Boolean'];
  deviceToken?: Maybe<Scalars['String']>;
  deviceOs?: Maybe<AccountDeviceOs>;
  oldEmailAddress?: Maybe<Scalars['String']>;
  newEmailAddressNotConfirmed?: Maybe<Scalars['String']>;
  emailConfirmed?: Maybe<Scalars['Boolean']>;
  emailConfirmationToken?: Maybe<Scalars['UUID']>;
  confirmedEmailConfirmationToken?: Maybe<Scalars['UUID']>;
  credentialsStructured?: Maybe<Scalars['String']>;
  introductionStructured?: Maybe<Scalars['String']>;
  scoreBias?: Maybe<Scalars['Float']>;
  onboardingStatus?: Maybe<AccountOnboardingStatus>;
  hasOwnAvatar: Scalars['Boolean'];
  parent?: Maybe<MemberNode>;
  isMarkedMinor: Scalars['Boolean'];
  groupPractice?: Maybe<MemberNode>;
  isSpecificProviderForCompany: Scalars['Boolean'];
  isSpecificProviderOrder: Scalars['Int'];
  providerTaxCountry?: Maybe<CountryNode>;
  availability?: Maybe<Array<Scalars['String']>>;
  zoomUserId?: Maybe<Scalars['String']>;
  isUnregistered: Scalars['Boolean'];
  clevertapId?: Maybe<Scalars['String']>;
  isHyperwalletPayee: Scalars['Boolean'];
  registrationSource?: Maybe<AccountRegistrationSource>;
  insuranceStatus?: Maybe<AccountInsuranceStatus>;
  licensedCountries: Array<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  enrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
  programs: Array<ProgramProgressNode>;
  conversationsAsCoach: ConversationNodeConnection;
  conversationsAsMember: ConversationNodeConnection;
  sentMessages: MessageNodeConnection;
  receivedMessages: MessageNodeConnection;
  accountSet: Array<MemberNode>;
  careNavigationRequests: Array<CareNavigationRequestNode>;
  sharedPreferences: Array<AccountSharedPreferencesRecordNode>;
  notificationPreferences?: Maybe<NotificationPreferencesNode>;
  companysegmentSet: Array<CompanySegmentNode>;
  reviewerReview: Array<ReviewNode>;
  eligiblePerson: Array<EligiblePersonNode>;
  memberAssignments: Array<CoachAssignmentNode>;
  coachAssignments: Array<CoachAssignmentNode>;
  careRecommendations: Array<CareRecommendationNode>;
  matchRequestsFulfilled: Array<ProviderMatchAttemptNode>;
  memberCoachOption: Array<ProviderOptionOffer>;
  coachCoachOption: Array<ProviderOptionOffer>;
  coachingVisits: Array<CoachingVisitNode>;
  memberRating: Array<RatingNode>;
  providerRating: Array<RatingNode>;
  surveys: Array<Who5SurveyNode>;
  meditations: Array<MeditationProgressNode>;
  assessmentflowSet: Array<AssessmentFlowNode>;
  contentresponsesSet: Array<ContentResponsesNode>;
  memberCarePreferences: Array<MemberCarePreferenceNode>;
  topicSelectionGroups: Array<TopicSelectionGroupNode>;
  calendarProfiles: Array<CalendarProfileNode>;
  pathwayProgress: ProviderMemberPathwayNodeConnection;
  pathwayprogressSet: ProviderMemberPathwayNodeConnection;
  pathwayproviderSet: PathwayProviderNodeConnection;
  guides: CourseGuideNodeConnection;
  assessmentjourneySet: Array<AssessmentJourneyNode>;
  scheduledcontentactivitySet: Array<ScheduledContentActivityNode>;
  intakeformSet: Array<IntakeFormNode>;
  email?: Maybe<Scalars['String']>;
};


export type MemberNonPhiNodeConversationsAsCoachArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodeConversationsAsMemberArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodeSentMessagesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type MemberNonPhiNodeReceivedMessagesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type MemberNonPhiNodePathwayProgressArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodePathwayprogressSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodePathwayproviderSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodeGuidesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type MemberNonPhiOutput = MemberNonPhiNode | AccountDoesNotExist;

export type MemberPageNode = {
  __typename: 'MemberPageNode';
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  countFiltered?: Maybe<Scalars['Int']>;
  members?: Maybe<Array<Maybe<MemberNode>>>;
};

export type MemberPathwayNode = Node & {
  __typename: 'MemberPathwayNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pathway: ProviderPathwayNode;
  member: MemberNode;
  company?: Maybe<CompanyDropdownNode>;
  surfacedProvider?: Maybe<MemberNode>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  state: PathwayProgressState;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  currentSessionIndex: Scalars['Int'];
  pathwayTopics: Array<Maybe<PathwayTopicNode>>;
  pathwayProvider: PathwayProviderNode;
  duration: Scalars['Int'];
  completionPercent: Scalars['Int'];
};

export type MemberPreferencesInput = {
  races?: Maybe<Array<Maybe<Scalars['String']>>>;
  showInternationalProviders?: Maybe<Scalars['Boolean']>;
};

export type MemberProfileInput = {
  allowNotifications?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<Array<Maybe<MemberAvailability>>>;
  birthDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clevertapId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  languagePreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<Scalars['String']>;
  oldPassword?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  therapyAccessShortcut?: Maybe<Scalars['Boolean']>;
  zipCode?: Maybe<Scalars['String']>;
  companySegmentUuid?: Maybe<Scalars['String']>;
};

export type MessageActionsNode = {
  __typename: 'MessageActionsNode';
  name: Scalars['String'];
  contentCollectionLinks: Array<Maybe<InternalLinkNode>>;
};

export enum MessageKind {
  Coaching = 'COACHING',
  Therapy = 'THERAPY',
  Group = 'GROUP',
  LiveCoaching = 'LIVE_COACHING'
}

export type MessageNode = Node & {
  __typename: 'MessageNode';
  uuid?: Maybe<Scalars['UUID']>;
  encryptedContent: Scalars['String'];
  sentAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  readAt?: Maybe<Scalars['DateTime']>;
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  conversation?: Maybe<ConversationNode>;
  sender?: Maybe<MemberNode>;
  receiver?: Maybe<MemberNode>;
  kind: MessageKind;
  messageResources: Array<MessageResourceNode>;
  id: Scalars['ID'];
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
};

export type MessageNodeConnection = {
  __typename: 'MessageNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<MessageNodeEdge>>;
};

export type MessageNodeEdge = {
  __typename: 'MessageNodeEdge';
  node?: Maybe<MessageNode>;
  cursor: Scalars['String'];
};

export type MessageResourceInput = {
  uuid?: Maybe<Scalars['UUID']>;
  order?: Maybe<Scalars['Int']>;
  meditationId?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['Int']>;
  companyAdditionalBenefitId?: Maybe<Scalars['Int']>;
};

export type MessageResourceNode = {
  __typename: 'MessageResourceNode';
  uuid?: Maybe<Scalars['UUID']>;
  order: Scalars['Int'];
  program?: Maybe<ProgramNode>;
  meditation?: Maybe<MeditationNode>;
  companyAdditionalBenefit?: Maybe<CompanyAdditionalBenefitNode>;
};


export type ModelMetadataNode = {
  __typename: 'ModelMetadataNode';
  modelName: Scalars['String'];
  modelVersion: Scalars['String'];
};

export type Mutation = {
  __typename: 'Mutation';
  createSAMLPostPage?: Maybe<CreateSamlPostPageResponse>;
  createOrUpdatePayerInformation?: Maybe<CreateOrUpdatePayerInformationResponse>;
  updateAutoPaymentEnrollment?: Maybe<UpdateAutoPaymentEnrollmentResponse>;
  flushModelCache?: Maybe<FlushModelCacheResponse>;
  removeModelKeyFromCache?: Maybe<RemoveModelKeyFromCacheResponse>;
  updateName?: Maybe<UpdateNameResponse>;
  updateMyName?: Maybe<UpdateNameResponse>;
  uploadCompanyCsv?: Maybe<UploadCsvResponse>;
  createClientBucket?: Maybe<CreateClientBucketResponse>;
  updateClientBucket?: Maybe<UpdateClientBucketResponse>;
  overrideTranslation?: Maybe<OverrideTranslationResponseType>;
  addTranslation?: Maybe<AddTranslationResponseType>;
  addTranslationKey?: Maybe<AddTranslationKeyResponseType>;
  addLanguage?: Maybe<AddLanguageResponseType>;
  checkEligibility: CheckEligibilityResponse;
  createEligibilityCheckCoachingVisit?: Maybe<CreateEligibilityCheckCoachingVisitResponse>;
  createEligibilityCheckCoachingVisitForMember?: Maybe<CreateEligibilityCheckCoachingVisitResponse>;
  resetEligibilityForMember?: Maybe<ResetEligibilityForMemberResponse>;
  createOrUpdateInsuranceCompany: CreateOrUpdateInsuranceCompanyResponse;
  createOrUpdateEmployerInsurance: CreateOrUpdateEmployerInsuranceResponse;
  createOrUpdateEmployerCptRates?: Maybe<CreateOrUpdateEmployerCptRateResponse>;
  updateEMRIName?: Maybe<UpdateEmriNameResponse>;
  updateMyEMRIName?: Maybe<UpdateEmriNameResponse>;
  createMemberPathway?: Maybe<CreateMemberPathwayMutationResponse>;
  startMemberPathway?: Maybe<StartMemberPathwayMutationResponse>;
  cancelMemberPathway?: Maybe<CancelMemberPathwayMutationResponse>;
  submitPathwayReview?: Maybe<SubmitPathwayReviewOutput>;
  submitPathwayAssessment?: Maybe<SubmitPathwayAssessmentMutationOutput>;
  acceptContracts?: Maybe<AcceptContractsMutation>;
  createHrAdminRole?: Maybe<HrAdminRoleCreateOutput>;
  updateHrAdminRole?: Maybe<HrAdminRoleUpdateOutput>;
  deleteHrAdminRole?: Maybe<HrAdminRoleDeleteOutput>;
  createHrAdmin?: Maybe<HrAdminCreateOutput>;
  updateHrAdmin?: Maybe<HrAdminUpdateOutput>;
  deleteHrAdmin?: Maybe<HrAdminDeleteOutput>;
  disableHrAdmin?: Maybe<DisableHrAdminMutationResult>;
  inviteHrAdmin?: Maybe<InviteHrAdminMutationResult>;
  inviteBulkHrAdmins?: Maybe<InviteBulkHrAdminResult>;
  editHrAdminRole?: Maybe<EditHrAdminRoleMutationResult>;
  logHrisConnection?: Maybe<LogHrisConnectionResult>;
  hrCreateEditCompanyAdditionalBenefit?: Maybe<HrCreateEditCompanyAdditionalBenefitMutation>;
  hrDeleteCompanyAdditionalBenefit?: Maybe<HrDeleteCompanyAdditionalBenefitMutation>;
  hrCreateEditCompanySegment?: Maybe<HrCreateEditCompanySegmentMutation>;
  hrDeleteCompanySegment?: Maybe<HrDeleteCompanySegmentMutation>;
  newMessage?: Maybe<NewMessageMutation>;
  newBulkMessage?: Maybe<NewBulkMessageMutation>;
  addNote?: Maybe<AddNoteMutation>;
  updateMessage?: Maybe<UpdateMessageMutation>;
  createContentTag?: Maybe<ContentTagCreateOutput>;
  updateContentTag?: Maybe<ContentTagUpdateOutput>;
  deleteContentTag?: Maybe<ContentTagDeleteOutput>;
  createContentTagCategory?: Maybe<ContentTagCategoryCreateOutput>;
  updateContentTagCategory?: Maybe<ContentTagCategoryUpdateOutput>;
  deleteContentTagCategory?: Maybe<ContentTagCategoryDeleteOutput>;
  createContentTagRelation?: Maybe<ContentTagRelationCreateOutput>;
  updateContentTagRelation?: Maybe<ContentTagRelationUpdateOutput>;
  deleteContentTagRelation?: Maybe<ContentTagRelationDeleteOutput>;
  linkCronofyCalendar?: Maybe<LinkCronofyCalendarMutation>;
  updateAvailableHours?: Maybe<UpdateAvailableHoursMutation>;
  updateCalendar?: Maybe<UpdateCalendarMutation>;
  createEvent?: Maybe<CreateEventMutation>;
  cancelEvent?: Maybe<CancelEventMutation>;
  rescheduleEvent?: Maybe<RescheduleEventMutation>;
  recordPresenceChange?: Maybe<RecordPresenceChangeMutation>;
  deleteCalendarProfile?: Maybe<DeleteCalendarProfileMutation>;
  sendMemberEmailReminder?: Maybe<SendMemberEmailReminderMutation>;
  sendMemberExtendTherapyEmailReminder?: Maybe<SendMemberExtendTherapyEmailReminderMutation>;
  createVisit?: Maybe<CreateVisitMutation>;
  createProviderReview?: Maybe<CreateProviderReview>;
  updateVisit?: Maybe<UpdateVisitMutation>;
  updateProviderReview?: Maybe<UpdateProviderReview>;
  createOrUpdateProviderReview?: Maybe<CreateOrUpdateProviderReview>;
  createOrUpdatePsychiatristReview?: Maybe<CreateOrUpdatePsychiatristReview>;
  chooseProvider?: Maybe<ChooseProviderMutation>;
  requestManualProviderMatch?: Maybe<RequestManualProviderMatchMutation>;
  matchedProviders?: Maybe<MatchedProvidersMutation>;
  timeToCareLabels?: Maybe<TimeToCareLabelMutation>;
  submitCancelledSessionReview?: Maybe<CancelledSessionReviewOutput>;
  submitCourseSectionReview?: Maybe<SubmitCourseSectionReviewOutput>;
  validatePendingCoachingVisit?: Maybe<ValidatePendingCoachingVisitMutation>;
  createContentCollection?: Maybe<ContentCollectionCreateOutput>;
  updateContentCollection?: Maybe<ContentCollectionUpdateOutput>;
  deleteContentCollection?: Maybe<ContentCollectionDeleteOutput>;
  createContentCollectionLink?: Maybe<ContentCollectionLinkCreateOutput>;
  updateContentCollectionLink?: Maybe<ContentCollectionLinkUpdateOutput>;
  deleteContentCollectionLink?: Maybe<ContentCollectionLinkDeleteOutput>;
  createScreen?: Maybe<ScreenCreateOutput>;
  updateScreen?: Maybe<ScreenUpdateOutput>;
  deleteScreen?: Maybe<ScreenDeleteOutput>;
  createScreenSection?: Maybe<ScreenSectionCreateOutput>;
  updateScreenSection?: Maybe<ScreenSectionUpdateOutput>;
  deleteScreenSection?: Maybe<ScreenSectionDeleteOutput>;
  createCourse?: Maybe<CourseCreateOutput>;
  updateCourse?: Maybe<CourseUpdateOutput>;
  deleteCourse?: Maybe<CourseDeleteOutput>;
  createContentTranslationAvailability?: Maybe<ContentTranslationAvailabilityCreateOutput>;
  updateContentTranslationAvailability?: Maybe<ContentTranslationAvailabilityUpdateOutput>;
  createCourseSection?: Maybe<CourseSectionCreateOutput>;
  updateCourseSection?: Maybe<CourseSectionUpdateOutput>;
  deleteCourseSection?: Maybe<CourseSectionDeleteOutput>;
  createCourseActivityGroup?: Maybe<CourseActivityGroupCreateOutput>;
  updateCourseActivityGroup?: Maybe<CourseActivityGroupUpdateOutput>;
  deleteCourseActivityGroup?: Maybe<CourseActivityGroupDeleteOutput>;
  createCourseHero?: Maybe<CreateCourseHeroMutationOutput>;
  updateCourseHero?: Maybe<UpdateCourseHeroMutationOutput>;
  deleteCourseHero?: Maybe<DeleteCourseHeroMutationOutput>;
  createCourseOutcome?: Maybe<CourseOutcomeCreateOutput>;
  updateCourseOutcome?: Maybe<CourseOutcomeUpdateOutput>;
  deleteCourseOutcome?: Maybe<CourseOutcomeDeleteOutput>;
  createCourseGuide?: Maybe<CreateCourseGuideMutationOutput>;
  deleteCourseGuide?: Maybe<DeleteCourseGuideMutationOutput>;
  createVideoContent?: Maybe<VideoContentCreateOutput>;
  updateVideoContent?: Maybe<VideoContentUpdateOutput>;
  deleteVideoContent?: Maybe<VideoContentDeleteOutput>;
  createTextTrackTranslation?: Maybe<TextTrackTranslationCreateOutput>;
  updateTextTrackTranslation?: Maybe<TextTrackTranslationUpdateOutput>;
  deleteTextTrackTranslation?: Maybe<TextTrackTranslationDeleteOutput>;
  createMediaType?: Maybe<MediaTypeCreateOutput>;
  updateMediaType?: Maybe<MediaTypeUpdateOutput>;
  deleteMediaType?: Maybe<MediaTypeDeleteOutput>;
  createContentLanguage?: Maybe<ContentLanguageCreateOutput>;
  updateContentLanguage?: Maybe<ContentLanguageUpdateOutput>;
  syncUuids?: Maybe<AllContentUuidsOutput>;
  startProgram?: Maybe<ProgramStartMutation>;
  finishProgram?: Maybe<ProgramFinishMutation>;
  startPage?: Maybe<PageStartMutation>;
  finishPage?: Maybe<PageFinishMutation>;
  updatePageProgress?: Maybe<PageUpdateMultimediaProgress>;
  recordScheduledContentActivity?: Maybe<RecordScheduledContentActivityMutation>;
  rateScheduledContent?: Maybe<RateScheduledContentMutation>;
  reviewProgram?: Maybe<ReviewProgramMutation>;
  startCourseActivity?: Maybe<CourseProgressMutationOutput>;
  finishCourseActivity?: Maybe<CourseProgressMutationOutput>;
  startMeditation?: Maybe<MeditationStartMutation>;
  finishMeditation?: Maybe<MeditationFinishMutation>;
  updateMeditationProgress?: Maybe<MeditationUpdateProgressMutation>;
  submitModularizedAssessments?: Maybe<SubmitModularizedAssessmentsResult>;
  submitAssessments?: Maybe<SubmitAssessmentsMutation>;
  addMemberCarePreference?: Maybe<AddMemberCarePreferenceMutation>;
  selectTopicsOfFocus?: Maybe<SelectTopicsOfFocusMutation>;
  addSymptomsExperienced?: Maybe<AddSymptomsExperiencedMutation>;
  selectPrimaryFocus?: Maybe<SelectPrimaryFocusMutation>;
  changeAccountTopics?: Maybe<ChangeAccountTopicsOutput>;
  addCareNavigationRequest?: Maybe<AddCareNavigationRequestMutation>;
  phoneSupportUpdateMemberEmail?: Maybe<PhoneSupportUpdateMemberEmailOutput>;
  phoneSupportGenerateOtp?: Maybe<PhoneSupportGenerateOtpOutput>;
  createEditCompanySegment?: Maybe<CreateEditCompanySegmentOutput>;
  deleteCompanySegment?: Maybe<InternalToolDeleteOutput>;
  createEditCompanyAdditionalBenefit?: Maybe<CreateEditCompanyAdditionalBenefitOutput>;
  deleteCompanyAdditionalBenefit?: Maybe<DeleteCompanyAdditionalBenefitOutput>;
  createEditCrisisProvider?: Maybe<CreateEditCrisisProviderOutput>;
  createEditCrisisProviderCompanyAssignment?: Maybe<CreateEditCrisisProviderCompanyAssignmentOutput>;
  createEditCrisisProviderCountryAssignment?: Maybe<CreateEditCrisisProviderCountryAssignmentOutput>;
  deleteCrisisProvider?: Maybe<InternalToolDeleteOutput>;
  deleteCrisisProviderCompanyAssignment?: Maybe<InternalToolDeleteOutput>;
  deleteCrisisProviderCountryAssignment?: Maybe<InternalToolDeleteOutput>;
  addUpdateCompanyFeature?: Maybe<AddUpdateCompanyFeatureMutation>;
  updateMemberProfile?: Maybe<UpdateMemberProfileMutation>;
  addCoach?: Maybe<AddCoachMutation>;
  removeCoach?: Maybe<RemoveCoachMutation>;
  updateCoachingVisit?: Maybe<UpdateCoachingVisitMutation>;
  confirmVisitWithoutPayment?: Maybe<ConfirmVisitWithoutPaymentMutation>;
  createNotification?: Maybe<CreateNotificationMutation>;
  createConversation?: Maybe<CreateConversationMutation>;
  updateConversation?: Maybe<UpdateConversationMutation>;
  updateAccountSharedPreferences?: Maybe<UpdateAccountSharedPreferencesMutation>;
  /** @deprecated Please use CoachingVisitNode.zoomUrl instead */
  getVideoSession?: Maybe<GetOrCreateCoachingVisitVideoSessionMutation>;
  markCoachingVisitStart?: Maybe<MarkCoachingVisitStart>;
  markCoachingVisitEnd?: Maybe<MarkCoachingVisitEnd>;
  saveContentResponses?: Maybe<SaveContentResponsesMutation>;
  saveNewClientCapacity?: Maybe<SaveNewClientCapacityMutation>;
  saveRating?: Maybe<SaveRatingMutation>;
  createCoachingVisitMemberReview?: Maybe<CreateCoachingVisitMemberReviewMutation>;
  createPsychiatryVisitMemberReview?: Maybe<CreatePsychiatryVisitMemberReviewMutation>;
  submitNps?: Maybe<SubmitNpsMutation>;
  submitFeatureReview?: Maybe<SubmitFeatureRecordReviewOutput>;
  inAppReviewFlowCompleted?: Maybe<InAppReviewFlowCompletedMutation>;
  startCareRecommendation?: Maybe<StartCareRecommendationMutation>;
  recommendCare?: Maybe<RecommendCareMutation>;
  acceptCareRecommendation?: Maybe<AcceptCareRecommendationMutation>;
  selectModality?: Maybe<SelectModalityMutation>;
  selectDifficulty?: Maybe<SelectDifficultyMutation>;
  startAssessmentJourney?: Maybe<StartAssessmentJourneyResult>;
  submitAssessmentResponseForJourney?: Maybe<SubmitAssessmentResponseOutput>;
  startAssessmentFlow?: Maybe<StartAssessmentFlowMutation>;
  updateIntakeForm?: Maybe<UpdateIntakeFormMutation>;
  bypassAssessments?: Maybe<BypassAssessmentsMutation>;
  inviteDependent?: Maybe<InviteDependentOutput>;
  createTestMember?: Maybe<CreateTestMemberResult>;
  createTestEligiblePerson?: Maybe<CreateTestEligiblePersonResult>;
  resetTestAccountPassword?: Maybe<ResetTestAccountPasswordResult>;
  deleteTestMember?: Maybe<DeleteTestMember>;
  createTestProvider?: Maybe<CreateTestProviderResult>;
  deleteTestProvider?: Maybe<DeleteTestProvider>;
  createTestPammMatch?: Maybe<CreateTestPammMatch>;
  completeTestPammInitialEvaluation?: Maybe<CompleteTestPammInitialEvaluation>;
  downloadApp?: Maybe<DownloadAppMutation>;
  updateNotificationPreferences?: Maybe<UpdateNotificationPreferencesMutation>;
  createAccountDeletionRequest?: Maybe<CreateAccountDeletionRequest>;
  circleAdminUpdateSeries?: Maybe<CircleAdminUpdateSeriesMutationResponse>;
  circleAdminCreateSeries?: Maybe<CircleAdminCreateSeriesMutationResponse>;
  circleAdminUpdateTopic?: Maybe<CircleAdminUpdateTopicMutationResponse>;
  circleAdminCreateTopic?: Maybe<CircleAdminCreateTopicMutationResponse>;
  circleAdminCreateSession?: Maybe<CircleAdminCreateSessionMutationResponse>;
  circleAdminUpdateSession?: Maybe<CircleAdminUpdateSessionMutationResponse>;
  circleAdminCreateFacilitator?: Maybe<CircleAdminCreateFacilitatorMutationResponse>;
  circleAdminUpdateFacilitator?: Maybe<CircleAdminUpdateFacilitatorMutationResponse>;
  circleAdminCreateFeaturedItem?: Maybe<CircleAdminCreateFeaturedItemMutationResponse>;
  circleAdminDeleteFeaturedItem?: Maybe<CircleAdminDeleteFeaturedItemMutationResponse>;
  circleCreateUnauthenticatedRsvp?: Maybe<CircleCreateUnauthenticatedRsvpMutationResponse>;
  circleCreateUnauthenticatedCompanyRsvp?: Maybe<CircleCreateUnauthenticatedCompanyRsvpMutationResponse>;
  circleCancelUnauthenticatedRsvp: CircleCancelUnauthenticatedRsvpMutationResponse;
  circleAdminCreateMultipleChoiceQuestion?: Maybe<CircleAdminCreateMultipleChoiceQuestionMutationResponse>;
  circleAdminCreateSegmentedScaleQuestion?: Maybe<CircleAdminCreateSegmentedScaleQuestionMutationResponse>;
  circleAdminCreateFreeResponseQuestion?: Maybe<CircleAdminCreateFreeResponseQuestionMutationResponse>;
  circleAdminCreateShortResponseQuestion?: Maybe<CircleAdminCreateShortResponseQuestionMutationResponse>;
  circleAdminCreateBooleanQuestion?: Maybe<CircleAdminCreateBooleanQuestionMutationResponse>;
  circleAdminCreateRsvpQuestionTopic?: Maybe<CircleAdminCreateRsvpQuestionTopicMutationResponse>;
  circleAdminDeleteRsvpQuestionTopic?: Maybe<CircleAdminDeleteRsvpQuestionTopicMutationResponse>;
  circleAdminCreateOnDemandTopic?: Maybe<CircleAdminCreateOnDemandTopicMutationResponse>;
  circleAdminUpdateOnDemandTopic?: Maybe<CircleAdminUpdateOnDemandTopicMutationResponse>;
  circleCreateAuthenticatedRsvp?: Maybe<CircleCreateAuthenticatedRsvpMutationResponse>;
  circleCancelAuthenticatedRsvp: CircleCancelAuthenticatedRsvpMutationResponse;
  circleCreateItemFeedback: CircleCreateItemFeedbackMutationResponse;
  circleAdminRetryFailedScheduledTasks: CircleRetryFailedScheduledTasksMutationResponse;
  circleUserViewedOnDemandTopic: CircleUserViewedOnDemandTopicMutationResponse;
};


export type MutationCreateSamlPostPageArgs = {
  productUuid: Scalars['UUID'];
};


export type MutationCreateOrUpdatePayerInformationArgs = {
  payerInformation: CreateOrUpdatePayerInformationInput;
};


export type MutationRemoveModelKeyFromCacheArgs = {
  modelName: Scalars['String'];
};


export type MutationUpdateNameArgs = {
  updateNameInput?: Maybe<UpdateNameInput>;
};


export type MutationUpdateMyNameArgs = {
  newName: Scalars['String'];
};


export type MutationUploadCompanyCsvArgs = {
  companyUuid: Scalars['UUID'];
  file: Scalars['Upload'];
};


export type MutationCreateClientBucketArgs = {
  input: CreateClientBucketInput;
};


export type MutationUpdateClientBucketArgs = {
  input: UpdateClientBucketInput;
};


export type MutationOverrideTranslationArgs = {
  languageCode: Scalars['String'];
  translationKey: Scalars['String'];
  overrideText: Scalars['String'];
};


export type MutationAddTranslationArgs = {
  languageCode: Scalars['String'];
  translationKey: Scalars['String'];
  translatedText: Scalars['String'];
};


export type MutationAddTranslationKeyArgs = {
  key: Scalars['String'];
  defaultTranslation: Scalars['String'];
};


export type MutationAddLanguageArgs = {
  code: Scalars['String'];
  name: Scalars['String'];
  nativeName: Scalars['String'];
};


export type MutationCheckEligibilityArgs = {
  input: CheckEligibilityInput;
};


export type MutationCreateEligibilityCheckCoachingVisitArgs = {
  input: CreateEligibilityCheckCoachingVisit;
};


export type MutationCreateEligibilityCheckCoachingVisitForMemberArgs = {
  input: CreateEligibilityCheckCoachingVisitForMember;
};


export type MutationResetEligibilityForMemberArgs = {
  input: ResetEligibilityForMember;
};


export type MutationCreateOrUpdateInsuranceCompanyArgs = {
  input: CreateOrUpdateInsuranceCompanyInput;
};


export type MutationCreateOrUpdateEmployerInsuranceArgs = {
  input: CreateOrUpdateEmployerInsuranceInput;
};


export type MutationCreateOrUpdateEmployerCptRatesArgs = {
  input: CreateOrUpdateEmployerCptRateInput;
};


export type MutationUpdateEmriNameArgs = {
  updateEMRINameInput?: Maybe<UpdateEmriNameInput>;
};


export type MutationUpdateMyEmriNameArgs = {
  newName: Scalars['String'];
};


export type MutationCreateMemberPathwayArgs = {
  createMemberPathwayMutationInput: CreateMemberPathwayMutationInput;
};


export type MutationStartMemberPathwayArgs = {
  startMemberPathwayMutationInput: StartMemberPathwayMutationInput;
};


export type MutationCancelMemberPathwayArgs = {
  cancelMemberPathwayMutationInput: CancelMemberPathwayMutationInput;
};


export type MutationSubmitPathwayReviewArgs = {
  pathwayReview: PathwayReviewInput;
};


export type MutationSubmitPathwayAssessmentArgs = {
  data: SubmitPathwayAssessmentMutationInput;
};


export type MutationAcceptContractsArgs = {
  versionIds: Array<Maybe<Scalars['String']>>;
};


export type MutationCreateHrAdminRoleArgs = {
  hrAdminRole: HrAdminRoleCreateInput;
};


export type MutationUpdateHrAdminRoleArgs = {
  hrAdminRole: HrAdminRoleUpdateInput;
};


export type MutationDeleteHrAdminRoleArgs = {
  hrAdminRole: HrAdminRoleDeleteInput;
};


export type MutationCreateHrAdminArgs = {
  hrAdmin: HrAdminCreateInput;
};


export type MutationUpdateHrAdminArgs = {
  hrAdmin: HrAdminUpdateInput;
};


export type MutationDeleteHrAdminArgs = {
  hrAdmin: HrAdminDeleteInput;
};


export type MutationDisableHrAdminArgs = {
  hrAdminUuid: Scalars['UUID'];
};


export type MutationInviteHrAdminArgs = {
  email: Scalars['String'];
};


export type MutationInviteBulkHrAdminsArgs = {
  emails: Array<Maybe<EmailRoleInput>>;
};


export type MutationEditHrAdminRoleArgs = {
  hrAdminUuid: Scalars['UUID'];
  role: Scalars['String'];
};


export type MutationLogHrisConnectionArgs = {
  connection: LogHrisConnectionInput;
};


export type MutationHrCreateEditCompanyAdditionalBenefitArgs = {
  availableForDependents: Scalars['Boolean'];
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  link: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  startDate?: Maybe<Scalars['Date']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtopicOfFocus?: Maybe<Scalars['UUID']>;
  title: Scalars['String'];
  topicOfFocus?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationHrDeleteCompanyAdditionalBenefitArgs = {
  uuid: Scalars['UUID'];
};


export type MutationHrCreateEditCompanySegmentArgs = {
  companySegment: HrCompanySegmentInput;
};


export type MutationHrDeleteCompanySegmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationNewMessageArgs = {
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  clientsUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  encryptedContent: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  messageResources?: Maybe<Array<Maybe<MessageResourceInput>>>;
  messageUuid?: Maybe<Scalars['UUID']>;
  senderUuid: Scalars['UUID'];
};


export type MutationNewBulkMessageArgs = {
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  clientsUuids: Array<Maybe<Scalars['UUID']>>;
  encryptedContent: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  messageResources?: Maybe<Array<Maybe<MessageResourceInput>>>;
  messageUuid?: Maybe<Scalars['UUID']>;
  senderUuid: Scalars['UUID'];
};


export type MutationAddNoteArgs = {
  coachAssignmentUuid: Scalars['UUID'];
  coachUuid: Scalars['UUID'];
  encryptedContent: Scalars['String'];
};


export type MutationUpdateMessageArgs = {
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encryptedContent?: Maybe<Scalars['String']>;
  messageUuid: Scalars['UUID'];
  readAt?: Maybe<Scalars['DateTime']>;
};


export type MutationCreateContentTagArgs = {
  contentTag: ContentTagCreateInput;
};


export type MutationUpdateContentTagArgs = {
  contentTag: ContentTagUpdateInput;
};


export type MutationDeleteContentTagArgs = {
  contentTag: ContentTagDeleteInput;
};


export type MutationCreateContentTagCategoryArgs = {
  contentTagCategory: ContentTagCategoryCreateInput;
};


export type MutationUpdateContentTagCategoryArgs = {
  contentTagCategory: ContentTagCategoryUpdateInput;
};


export type MutationDeleteContentTagCategoryArgs = {
  contentTagCategory: ContentTagCategoryDeleteInput;
};


export type MutationCreateContentTagRelationArgs = {
  contentTagRelation: ContentTagRelationCreateInput;
};


export type MutationUpdateContentTagRelationArgs = {
  contentTagRelation: ContentTagRelationUpdateInput;
};


export type MutationDeleteContentTagRelationArgs = {
  contentTagRelation: ContentTagRelationDeleteInput;
};


export type MutationLinkCronofyCalendarArgs = {
  code: Scalars['String'];
  redirectUri?: Maybe<Scalars['String']>;
};


export type MutationUpdateAvailableHoursArgs = {
  availableHours?: Maybe<Array<Maybe<AvailableHourInput>>>;
};


export type MutationUpdateCalendarArgs = {
  isActive: Scalars['Boolean'];
  isTarget: Scalars['Boolean'];
  uuid: Scalars['UUID'];
};


export type MutationCreateEventArgs = {
  coach?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
  member?: Maybe<Scalars['UUID']>;
  start: Scalars['DateTime'];
  summary?: Maybe<Scalars['String']>;
};


export type MutationCancelEventArgs = {
  enqueueVisitCancelledEmailEvent?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
};


export type MutationRescheduleEventArgs = {
  newStart: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type MutationRecordPresenceChangeArgs = {
  coachUuid?: Maybe<Scalars['UUID']>;
  eventDatetime?: Maybe<Scalars['DateTime']>;
  onProviderDashboard?: Maybe<Scalars['Boolean']>;
  onlineForLiveCoaching?: Maybe<Scalars['Boolean']>;
  onlineForMyClients?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteCalendarProfileArgs = {
  id?: Maybe<Scalars['Int']>;
  profileId: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationSendMemberEmailReminderArgs = {
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
};


export type MutationSendMemberExtendTherapyEmailReminderArgs = {
  memberUuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachAssignmentUuid: Scalars['UUID'];
  cptCode?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  primaryDiagnosisCode?: Maybe<Scalars['String']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  secondaryDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationCreateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationUpdateVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  cptCode?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  primaryDiagnosisCode?: Maybe<Scalars['String']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  secondaryDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationUpdateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationCreateOrUpdateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationCreateOrUpdatePsychiatristReviewArgs = {
  clientIsInterestedInPursuingPammServices: Scalars['Boolean'];
  clientNotInterestedInPammReason?: Maybe<Scalars['String']>;
  coachingVisitUuid: Scalars['UUID'];
  pammIsClinicallyIndicatedForTheClient: Scalars['Boolean'];
};


export type MutationChooseProviderArgs = {
  providerUuid: Scalars['UUID'];
  uuid: Scalars['UUID'];
};


export type MutationRequestManualProviderMatchArgs = {
  preferences: Scalars['JSONString'];
  uuid: Scalars['UUID'];
};


export type MutationMatchedProvidersArgs = {
  careRecommendationUuid: Scalars['UUID'];
  pagination?: Maybe<PaginationInput>;
  preferences?: Maybe<MemberPreferencesInput>;
  providerTypeOverride?: Maybe<Scalars['String']>;
};


export type MutationTimeToCareLabelsArgs = {
  providersList: ProviderListInput;
};


export type MutationSubmitCancelledSessionReviewArgs = {
  cancelledSessionReview: CancelledSessionReviewInput;
};


export type MutationSubmitCourseSectionReviewArgs = {
  courseSectionReview: CourseSectionReviewInput;
};


export type MutationValidatePendingCoachingVisitArgs = {
  coachingVisitUuid: Scalars['UUID'];
};


export type MutationCreateContentCollectionArgs = {
  contentCollection: ContentCollectionCreateInput;
};


export type MutationUpdateContentCollectionArgs = {
  contentCollection: ContentCollectionUpdateInput;
};


export type MutationDeleteContentCollectionArgs = {
  contentCollection: ContentCollectionDeleteInput;
};


export type MutationCreateContentCollectionLinkArgs = {
  contentCollectionLink: ContentCollectionLinkCreateInput;
};


export type MutationUpdateContentCollectionLinkArgs = {
  contentCollectionLink: ContentCollectionLinkUpdateInput;
};


export type MutationDeleteContentCollectionLinkArgs = {
  contentCollectionLink: ContentCollectionLinkDeleteInput;
};


export type MutationCreateScreenArgs = {
  screen: ScreenCreateInput;
};


export type MutationUpdateScreenArgs = {
  screen: ScreenUpdateInput;
};


export type MutationDeleteScreenArgs = {
  screen: ScreenDeleteInput;
};


export type MutationCreateScreenSectionArgs = {
  screenSection: ScreenSectionCreateInput;
};


export type MutationUpdateScreenSectionArgs = {
  screenSection: ScreenSectionUpdateInput;
};


export type MutationDeleteScreenSectionArgs = {
  screenSection: ScreenSectionDeleteInput;
};


export type MutationCreateCourseArgs = {
  course: CourseCreateInput;
};


export type MutationUpdateCourseArgs = {
  course: CourseUpdateInput;
};


export type MutationDeleteCourseArgs = {
  course: CourseDeleteInput;
};


export type MutationCreateContentTranslationAvailabilityArgs = {
  contentTranslationAvailability: ContentTranslationAvailabilityCreateInput;
};


export type MutationUpdateContentTranslationAvailabilityArgs = {
  contentTranslationAvailability: ContentTranslationAvailabilityUpdateInput;
};


export type MutationCreateCourseSectionArgs = {
  courseSection: CourseSectionCreateInput;
};


export type MutationUpdateCourseSectionArgs = {
  courseSection: CourseSectionUpdateInput;
};


export type MutationDeleteCourseSectionArgs = {
  courseSection: CourseSectionDeleteInput;
};


export type MutationCreateCourseActivityGroupArgs = {
  courseActivityGroup: CourseActivityGroupCreateInput;
};


export type MutationUpdateCourseActivityGroupArgs = {
  courseActivityGroup: CourseActivityGroupUpdateInput;
};


export type MutationDeleteCourseActivityGroupArgs = {
  courseActivityGroup: CourseActivityGroupDeleteInput;
};


export type MutationCreateCourseHeroArgs = {
  createCourseHeroInput: CreateCourseHeroMutationInput;
};


export type MutationUpdateCourseHeroArgs = {
  updateCourseHeroInput: UpdateCourseHeroMutationInput;
};


export type MutationDeleteCourseHeroArgs = {
  deleteCourseHeroInput: DeleteCourseHeroMutationInput;
};


export type MutationCreateCourseOutcomeArgs = {
  courseOutcome: CourseOutcomeCreateInput;
};


export type MutationUpdateCourseOutcomeArgs = {
  courseOutcome: CourseOutcomeUpdateInput;
};


export type MutationDeleteCourseOutcomeArgs = {
  courseOutcome: CourseOutcomeDeleteInput;
};


export type MutationCreateCourseGuideArgs = {
  courseGuideInput: CreateCourseGuideMutationInput;
};


export type MutationDeleteCourseGuideArgs = {
  courseGuideInput: DeleteCourseGuideMutationInput;
};


export type MutationCreateVideoContentArgs = {
  videoContent: VideoContentCreateInput;
};


export type MutationUpdateVideoContentArgs = {
  videoContent: VideoContentUpdateInput;
};


export type MutationDeleteVideoContentArgs = {
  videoContent: VideoContentDeleteInput;
};


export type MutationCreateTextTrackTranslationArgs = {
  textTrackTranslation: TextTrackTranslationCreateInput;
};


export type MutationUpdateTextTrackTranslationArgs = {
  textTrackTranslation: TextTrackTranslationUpdateInput;
};


export type MutationDeleteTextTrackTranslationArgs = {
  textTrackTranslation: TextTrackTranslationDeleteInput;
};


export type MutationCreateMediaTypeArgs = {
  mediaType: MediaTypeCreateInput;
};


export type MutationUpdateMediaTypeArgs = {
  mediaType: MediaTypeUpdateInput;
};


export type MutationDeleteMediaTypeArgs = {
  mediaType: MediaTypeDeleteInput;
};


export type MutationCreateContentLanguageArgs = {
  contentLanguage: ContentLanguageCreateInput;
};


export type MutationUpdateContentLanguageArgs = {
  contentLanguage: ContentLanguageUpdateInput;
};


export type MutationSyncUuidsArgs = {
  uuidSpecifications: Array<Maybe<UuidSpecificationInput>>;
};


export type MutationStartProgramArgs = {
  programName?: Maybe<Scalars['String']>;
  programUuid?: Maybe<Scalars['UUID']>;
};


export type MutationFinishProgramArgs = {
  programName?: Maybe<Scalars['String']>;
  programUuid?: Maybe<Scalars['UUID']>;
};


export type MutationStartPageArgs = {
  pageName?: Maybe<Scalars['String']>;
  pageUuid?: Maybe<Scalars['UUID']>;
  programName?: Maybe<Scalars['String']>;
};


export type MutationFinishPageArgs = {
  input?: Maybe<Scalars['JSONString']>;
  pageName?: Maybe<Scalars['String']>;
  pageUuid?: Maybe<Scalars['UUID']>;
  programName?: Maybe<Scalars['String']>;
};


export type MutationUpdatePageProgressArgs = {
  multimediaProgressPercentage: Scalars['Float'];
  pageUuid: Scalars['UUID'];
};


export type MutationRecordScheduledContentActivityArgs = {
  activityType: ScheduledContentActivityType;
  scheduledContentUuid: Scalars['UUID'];
};


export type MutationRateScheduledContentArgs = {
  rating: ScheduledContentFeedbackRatingType;
  review?: Maybe<Scalars['String']>;
  scheduledContentUuid: Scalars['UUID'];
};


export type MutationReviewProgramArgs = {
  dislikedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  likedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  programUuid: Scalars['UUID'];
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};


export type MutationStartCourseActivityArgs = {
  startCourseActivityInput: CourseProgressMutationInput;
};


export type MutationFinishCourseActivityArgs = {
  finishCourseActivityInput: CourseProgressMutationInput;
};


export type MutationStartMeditationArgs = {
  meditationName?: Maybe<Scalars['String']>;
  meditationUuid?: Maybe<Scalars['UUID']>;
};


export type MutationFinishMeditationArgs = {
  meditationName?: Maybe<Scalars['String']>;
  meditationUuid?: Maybe<Scalars['UUID']>;
};


export type MutationUpdateMeditationProgressArgs = {
  meditationUuid: Scalars['UUID'];
  progressPercentage: Scalars['Float'];
};


export type MutationSubmitModularizedAssessmentsArgs = {
  input: SubmitModularizedAssessmentInput;
};


export type MutationSubmitAssessmentsArgs = {
  assessmentFlowUuid?: Maybe<Scalars['UUID']>;
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  content: Scalars['JSONString'];
};


export type MutationAddMemberCarePreferenceArgs = {
  feelingsAboutTherapy?: Maybe<FeelingsAboutTherapyEnum>;
  otherSpecialtiesFreeform?: Maybe<Scalars['String']>;
  specialtiesSelected?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationSelectTopicsOfFocusArgs = {
  careRecommendationUuid: Scalars['UUID'];
  topicSelections?: Maybe<Array<Maybe<TopicInput>>>;
};


export type MutationAddSymptomsExperiencedArgs = {
  subtopicSelectionUuid: Scalars['UUID'];
  subtopicSymptoms?: Maybe<SubtopicSymptomsInput>;
  symptomsExperienced?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationSelectPrimaryFocusArgs = {
  subtopicSelectionUuid: Scalars['UUID'];
};


export type MutationChangeAccountTopicsArgs = {
  args: ChangeTopicsInput;
};


export type MutationAddCareNavigationRequestArgs = {
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPreference: CareNavigationRequestContactPreference;
  inAppConsent?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  platform?: Maybe<DeviceCategory>;
  source?: Maybe<CareNavigationRequestSource>;
  subtopicsOfFocus?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  topic?: Maybe<CareNavigationRequestTopic>;
  updatePhone?: Maybe<Scalars['Boolean']>;
};


export type MutationPhoneSupportUpdateMemberEmailArgs = {
  memberUuid: Scalars['UUID'];
  newEmail: Scalars['String'];
};


export type MutationPhoneSupportGenerateOtpArgs = {
  uuid: Scalars['UUID'];
};


export type MutationCreateEditCompanySegmentArgs = {
  companySegment: CompanySegmentInput;
};


export type MutationDeleteCompanySegmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationCreateEditCompanyAdditionalBenefitArgs = {
  availableForDependents: Scalars['Boolean'];
  companies?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  isModernHealthAddOn: Scalars['Boolean'];
  link: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  startDate?: Maybe<Scalars['Date']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtopicOfFocus?: Maybe<Scalars['UUID']>;
  title: Scalars['String'];
  topicOfFocus?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationDeleteCompanyAdditionalBenefitArgs = {
  uuid: Scalars['UUID'];
};


export type MutationCreateEditCrisisProviderArgs = {
  defaultPhoneNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateEditCrisisProviderCompanyAssignmentArgs = {
  companyUuid: Scalars['UUID'];
  crisisProviderUuid: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateEditCrisisProviderCountryAssignmentArgs = {
  countryId: Scalars['Int'];
  crisisProviderUuid: Scalars['UUID'];
  phoneNumber?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationDeleteCrisisProviderArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteCrisisProviderCompanyAssignmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteCrisisProviderCountryAssignmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationAddUpdateCompanyFeatureArgs = {
  activate?: Maybe<Scalars['Boolean']>;
  companyUuid: Scalars['UUID'];
  featureName: Scalars['String'];
  featureType?: Maybe<Scalars['String']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
};


export type MutationUpdateMemberProfileArgs = {
  memberProfile: MemberProfileInput;
};


export type MutationAddCoachArgs = {
  coachUuid: Scalars['String'];
};


export type MutationRemoveCoachArgs = {
  coachUuid: Scalars['String'];
};


export type MutationUpdateCoachingVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  reviews?: Maybe<Array<Maybe<ReviewInputNode>>>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationConfirmVisitWithoutPaymentArgs = {
  coachingVisitUuid: Scalars['UUID'];
};


export type MutationCreateNotificationArgs = {
  type: Scalars['String'];
  receiverId: Scalars['UUID'];
  senderAction: Scalars['String'];
  senderId: Scalars['UUID'];
  senderType: Scalars['String'];
};


export type MutationCreateConversationArgs = {
  coachUuid: Scalars['UUID'];
  kind?: Maybe<ConversationKind>;
};


export type MutationUpdateConversationArgs = {
  active?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<ConversationKind>;
  uuid: Scalars['UUID'];
};


export type MutationUpdateAccountSharedPreferencesArgs = {
  key: Scalars['String'];
  value: Scalars['String'];
};


export type MutationGetVideoSessionArgs = {
  uuid: Scalars['UUID'];
};


export type MutationMarkCoachingVisitStartArgs = {
  uuid: Scalars['UUID'];
};


export type MutationMarkCoachingVisitEndArgs = {
  uuid: Scalars['UUID'];
};


export type MutationSaveContentResponsesArgs = {
  content: Scalars['JSONString'];
};


export type MutationSaveNewClientCapacityArgs = {
  providerSchedulingType?: Maybe<Scalars['String']>;
  updatedNewClientCapacity?: Maybe<Scalars['Int']>;
};


export type MutationSaveRatingArgs = {
  coachingVisitUuid: Scalars['UUID'];
  contentType?: Maybe<RatingContentTypeEnum>;
  feedbackText?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationCreateCoachingVisitMemberReviewArgs = {
  abilityToHelpMe?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  exitedAt?: Maybe<Scalars['String']>;
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatYouLikedAboutYourCoach?: Maybe<Array<Maybe<Scalars['String']>>>;
  workedOnAgreedUponGoals?: Maybe<Scalars['Int']>;
};


export type MutationCreatePsychiatryVisitMemberReviewArgs = {
  abilityToHelpMe?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  exitedAt?: Maybe<Scalars['String']>;
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  understandingOfTreatmentPlan?: Maybe<Scalars['Int']>;
  understoodRecommendations?: Maybe<Scalars['String']>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatYouLiked?: Maybe<Array<Maybe<Scalars['String']>>>;
  willContinueWorking?: Maybe<Scalars['Boolean']>;
};


export type MutationSubmitNpsArgs = {
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
  feedbackText?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};


export type MutationSubmitFeatureReviewArgs = {
  featureReview: FeatureRecordReviewInput;
};


export type MutationInAppReviewFlowCompletedArgs = {
  store: InAppReviewStore;
};


export type MutationStartCareRecommendationArgs = {
  onboarding?: Maybe<Scalars['Boolean']>;
};


export type MutationRecommendCareArgs = {
  modalityPreference?: Maybe<CareRecommendationModality>;
  uuid: Scalars['UUID'];
};


export type MutationAcceptCareRecommendationArgs = {
  outcome?: Maybe<CareOption>;
  uuid: Scalars['UUID'];
};


export type MutationSelectModalityArgs = {
  modalityPreference?: Maybe<CareRecommendationModality>;
  uuid: Scalars['UUID'];
};


export type MutationSelectDifficultyArgs = {
  difficultyAgreement: DifficultyAgreement;
  uuid: Scalars['UUID'];
};


export type MutationStartAssessmentJourneyArgs = {
  input: StartAssessmentJourneyInput;
};


export type MutationSubmitAssessmentResponseForJourneyArgs = {
  input: SubmitAssessmentResultInput;
};


export type MutationStartAssessmentFlowArgs = {
  associatedVisitUuid?: Maybe<Scalars['UUID']>;
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  flowType?: Maybe<Scalars['String']>;
};


export type MutationUpdateIntakeFormArgs = {
  exitedAt?: Maybe<Scalars['String']>;
  formInput?: Maybe<IntakeFormQuestionResponseInputNode>;
  intakeFormUuid: Scalars['UUID'];
  submitted?: Maybe<Scalars['Boolean']>;
};


export type MutationBypassAssessmentsArgs = {
  careRecommendationUuid: Scalars['UUID'];
};


export type MutationInviteDependentArgs = {
  inviteDependent: InviteDependentInput;
};


export type MutationCreateTestMemberArgs = {
  companyUuid: Scalars['UUID'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isHrAdmin?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateTestEligiblePersonArgs = {
  companyUuid: Scalars['UUID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationResetTestAccountPasswordArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteTestMemberArgs = {
  uuid: Scalars['UUID'];
};


export type MutationCreateTestProviderArgs = {
  companyUuid: Scalars['UUID'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newClientCapacity?: Maybe<Scalars['Int']>;
  password: Scalars['String'];
  providerSchedulingType: Scalars['String'];
  providerType: Scalars['String'];
};


export type MutationDeleteTestProviderArgs = {
  uuid: Scalars['UUID'];
};


export type MutationCreateTestPammMatchArgs = {
  coachUuid: Scalars['UUID'];
  createTestSessions?: Maybe<Scalars['Boolean']>;
  initialEvaluationStart: Scalars['DateTime'];
  memberUuid: Scalars['UUID'];
};


export type MutationCompleteTestPammInitialEvaluationArgs = {
  coachUuid: Scalars['UUID'];
  memberUuid: Scalars['UUID'];
};


export type MutationUpdateNotificationPreferencesArgs = {
  notificationPreferences: NotificationPreferencesInput;
};


export type MutationCircleAdminUpdateSeriesArgs = {
  seriesId: Scalars['ID'];
  data: CircleUpdateSeriesDataInput;
};


export type MutationCircleAdminCreateSeriesArgs = {
  data: CircleCreateSeriesDataInput;
};


export type MutationCircleAdminUpdateTopicArgs = {
  topicId: Scalars['ID'];
  data: CircleUpdateTopicDataInput;
};


export type MutationCircleAdminCreateTopicArgs = {
  data: CircleCreateTopicDataInput;
};


export type MutationCircleAdminCreateSessionArgs = {
  data: CircleCreateSessionDataInput;
};


export type MutationCircleAdminUpdateSessionArgs = {
  sessionId: Scalars['ID'];
  data: CircleUpdateSessionDataInput;
};


export type MutationCircleAdminCreateFacilitatorArgs = {
  data: CircleCreateFacilitatorDataInput;
};


export type MutationCircleAdminUpdateFacilitatorArgs = {
  facilitatorId: Scalars['ID'];
  data: CircleUpdateFacilitatorDataInput;
};


export type MutationCircleAdminCreateFeaturedItemArgs = {
  data: CircleCreateFeaturedItemDataInput;
};


export type MutationCircleAdminDeleteFeaturedItemArgs = {
  featuredItemId: Scalars['ID'];
};


export type MutationCircleCreateUnauthenticatedRsvpArgs = {
  data: CircleCreateUnauthenticatedRsvpDataInput;
};


export type MutationCircleCreateUnauthenticatedCompanyRsvpArgs = {
  data: CircleCreateUnauthenticatedCompanyRsvpDataInput;
};


export type MutationCircleCancelUnauthenticatedRsvpArgs = {
  rsvpId: Scalars['ID'];
  rsvpEditToken: Scalars['String'];
};


export type MutationCircleAdminCreateMultipleChoiceQuestionArgs = {
  data: CircleCreateMultipleChoiceQuestionDataInput;
};


export type MutationCircleAdminCreateSegmentedScaleQuestionArgs = {
  data: CircleCreateSegmentedScaleQuestionDataInput;
};


export type MutationCircleAdminCreateFreeResponseQuestionArgs = {
  data: CircleCreateFreeResponseQuestionDataInput;
};


export type MutationCircleAdminCreateShortResponseQuestionArgs = {
  data: CircleCreateShortResponseQuestionDataInput;
};


export type MutationCircleAdminCreateBooleanQuestionArgs = {
  data: CircleCreateBooleanQuestionDataInput;
};


export type MutationCircleAdminCreateRsvpQuestionTopicArgs = {
  data: CircleAdminCreateRsvpQuestionTopicDataInput;
};


export type MutationCircleAdminDeleteRsvpQuestionTopicArgs = {
  rsvpQuestionTopicId: Scalars['ID'];
};


export type MutationCircleAdminCreateOnDemandTopicArgs = {
  data: CircleCreateOnDemandDataInput;
};


export type MutationCircleAdminUpdateOnDemandTopicArgs = {
  onDemandTopicId: Scalars['ID'];
  data: CircleUpdateOnDemandTopicDataInput;
};


export type MutationCircleCreateAuthenticatedRsvpArgs = {
  data: CircleCreateAuthenticatedRsvpDataInput;
};


export type MutationCircleCancelAuthenticatedRsvpArgs = {
  rsvpId: Scalars['ID'];
};


export type MutationCircleCreateItemFeedbackArgs = {
  data: CircleCreateItemFeedbackInput;
};


export type MutationCircleAdminRetryFailedScheduledTasksArgs = {
  scheduledTaskIds: Array<Scalars['ID']>;
};


export type MutationCircleUserViewedOnDemandTopicArgs = {
  onDemandTopicId: Scalars['ID'];
};

export type NewBulkMessageMutation = {
  __typename: 'NewBulkMessageMutation';
  messagesList?: Maybe<Array<Maybe<MessageNode>>>;
};

export type NewMessageMutation = {
  __typename: 'NewMessageMutation';
  message?: Maybe<MessageNode>;
  messagesList?: Maybe<Array<Maybe<MessageNode>>>;
};

export type Node = {
  id: Scalars['ID'];
};

export type NoteNode = {
  __typename: 'NoteNode';
  createdAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  encryptedContent: Scalars['String'];
  coachAssignment: CoachAssignmentNode;
};

export type NotificationPreferencesInput = {
  chatNotifications?: Maybe<Scalars['Boolean']>;
  courseReminders?: Maybe<Scalars['Boolean']>;
  wellBeingReminders?: Maybe<Scalars['Boolean']>;
  dailyPauseRemindersEmail?: Maybe<Scalars['Boolean']>;
  dailyPauseRemindersPush?: Maybe<Scalars['Boolean']>;
};

export type NotificationPreferencesNode = {
  __typename: 'NotificationPreferencesNode';
  chatNotifications: Scalars['Boolean'];
  courseReminders: Scalars['Boolean'];
  wellBeingReminders: Scalars['Boolean'];
  dailyPauseRemindersEmail: Scalars['Boolean'];
  dailyPauseRemindersPush: Scalars['Boolean'];
};

export type OverrideTranslationResponseType = {
  __typename: 'OverrideTranslationResponseType';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  translation?: Maybe<TranslationNode>;
};

export enum PageContentHorizontalAlignment {
  Start = 'START',
  Center = 'CENTER'
}

export enum PageContentVerticalAlignment {
  Top = 'TOP',
  Middle = 'MIDDLE'
}

export type PageFinishMutation = {
  __typename: 'PageFinishMutation';
  pageProgress?: Maybe<PageProgressNode>;
  error?: Maybe<Scalars['String']>;
};

export enum PageFirstBackgroundImagePosition {
  BottomLeft = 'BOTTOM_LEFT',
  BottomCenter = 'BOTTOM_CENTER',
  BottomRight = 'BOTTOM_RIGHT'
}

export enum PageImageSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE'
}

export type PageInfo = {
  __typename: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export type PageNode = {
  __typename: 'PageNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  number: Scalars['Int'];
  type: Scalars['String'];
  name: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imagePosition?: Maybe<Scalars['String']>;
  imageSize?: Maybe<PageImageSize>;
  backgroundColor?: Maybe<Scalars['String']>;
  firstBackgroundImageUrl?: Maybe<Scalars['String']>;
  firstBackgroundImagePosition?: Maybe<PageFirstBackgroundImagePosition>;
  secondBackgroundImageUrl?: Maybe<Scalars['String']>;
  secondBackgroundImagePosition?: Maybe<PageSecondBackgroundImagePosition>;
  textColor?: Maybe<Scalars['String']>;
  contentVerticalAlignment: PageContentVerticalAlignment;
  contentHorizontalAlignment: PageContentHorizontalAlignment;
  answerOptions?: Maybe<Scalars['JSONString']>;
  multiselectConfig?: Maybe<Scalars['JSONString']>;
  audioFile?: Maybe<Scalars['String']>;
  videoContent?: Maybe<VideoContentNode>;
  program: ProgramNode;
  pageProgress: Array<PageProgressNode>;
  translationKey?: Maybe<Scalars['String']>;
};

export type PageProgressNode = {
  __typename: 'PageProgressNode';
  id: Scalars['ID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  startedAt: Scalars['DateTime'];
  completedAt?: Maybe<Scalars['DateTime']>;
  multimediaProgressPercentage?: Maybe<Scalars['Float']>;
  input: Scalars['JSONString'];
  page?: Maybe<PageNode>;
  programProgress: ProgramProgressNode;
};

export enum PageSecondBackgroundImagePosition {
  BottomLeft = 'BOTTOM_LEFT',
  BottomCenter = 'BOTTOM_CENTER',
  BottomRight = 'BOTTOM_RIGHT'
}

export type PageStartMutation = {
  __typename: 'PageStartMutation';
  pageProgress?: Maybe<PageProgressNode>;
  error?: Maybe<Scalars['String']>;
};

export type PageUpdateMultimediaProgress = {
  __typename: 'PageUpdateMultimediaProgress';
  pageProgress?: Maybe<PageProgressNode>;
};

export type PaginationInput = {
  pageNumber?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type PathwayAssessmentInvalid = {
  __typename: 'PathwayAssessmentInvalid';
  message?: Maybe<Scalars['String']>;
};

export type PathwayAssessmentSubmitted = {
  __typename: 'PathwayAssessmentSubmitted';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum PathwayAvailabilityState {
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS',
  Everyone = 'EVERYONE'
}

export type PathwayDoesNotExist = {
  __typename: 'PathwayDoesNotExist';
  uuid?: Maybe<Scalars['UUID']>;
};

export type PathwayNode = Node & {
  __typename: 'PathwayNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  description: Scalars['String'];
  sessionCount: Scalars['Int'];
  metadata: Scalars['GenericScalar'];
  assessment: AssessmentNode;
  assessmentSessionOrdering: Array<Scalars['Int']>;
  availabilityState: PathwayAvailabilityState;
  slug: Scalars['String'];
  pathwayprogressSet: ProviderMemberPathwayNodeConnection;
  topics: PathwayTopicNodeConnection;
  providers: PathwayProviderNodeConnection;
  memberPathway?: Maybe<MemberPathwayNode>;
  careActions?: Maybe<Array<Maybe<ContentLinkNode>>>;
};


export type PathwayNodePathwayprogressSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PathwayNodeTopicsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PathwayNodeProvidersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum PathwayProgressState {
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED'
}

export type PathwayProviderNode = Node & {
  __typename: 'PathwayProviderNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pathway: ProviderPathwayNode;
  provider: CoachNode;
  biography: Scalars['String'];
  active: Scalars['Boolean'];
  featured: Scalars['Boolean'];
  featuredAvatar?: Maybe<Scalars['String']>;
};

export type PathwayProviderNodeConnection = {
  __typename: 'PathwayProviderNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<PathwayProviderNodeEdge>>;
};

export type PathwayProviderNodeEdge = {
  __typename: 'PathwayProviderNodeEdge';
  node?: Maybe<PathwayProviderNode>;
  cursor: Scalars['String'];
};

export type PathwayReviewInput = {
  pathwayUuid: Scalars['UUID'];
  rating: Scalars['Int'];
  whatYouLikedAboutPathway?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  confidenceInIncorporatingSkills?: Maybe<Scalars['Int']>;
  confidenceInSkillsLearned?: Maybe<Scalars['Int']>;
  likelyToRecommend?: Maybe<Scalars['Int']>;
  feedbackText?: Maybe<Scalars['String']>;
};

export type PathwaySessionNode = {
  __typename: 'PathwaySessionNode';
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  state: PathwaySessionState;
  coachingVisit?: Maybe<CoachingVisitNode>;
};

export enum PathwaySessionState {
  Unscheduled = 'UNSCHEDULED',
  Scheduled = 'SCHEDULED',
  Joinable = 'JOINABLE',
  Completed = 'COMPLETED',
  Locked = 'LOCKED'
}

export type PathwayTopicGoalNode = {
  __typename: 'PathwayTopicGoalNode';
  title: Scalars['String'];
  icon: Scalars['String'];
};

export type PathwayTopicNode = Node & {
  __typename: 'PathwayTopicNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pathway: ProviderPathwayNode;
  title: Scalars['String'];
  subtitle: Scalars['String'];
  goals: Array<Maybe<PathwayTopicGoalNode>>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  contentCollection?: Maybe<ContentCollectionNode>;
  sessionDetail?: Maybe<PathwaySessionNode>;
  recommendedActivities?: Maybe<Array<Maybe<ContentLinkNode>>>;
  assessmentActivity?: Maybe<AssessmentActivityNode>;
};

export type PathwayTopicNodeConnection = {
  __typename: 'PathwayTopicNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<PathwayTopicNodeEdge>>;
};

export type PathwayTopicNodeEdge = {
  __typename: 'PathwayTopicNodeEdge';
  node?: Maybe<PathwayTopicNode>;
  cursor: Scalars['String'];
};

export type PayerInformationNode = {
  __typename: 'PayerInformationNode';
  accountUuid?: Maybe<Scalars['UUID']>;
  firstName: Scalars['String'];
  lastNameOne: Scalars['String'];
  lastNameTwo?: Maybe<Scalars['String']>;
  addressOne: Scalars['String'];
  addressTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  emailAddress: Scalars['String'];
  enrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
};

export type PaymentInfoForVisitNode = {
  __typename: 'PaymentInfoForVisitNode';
  chargeAmount: Scalars['Float'];
};

export type PaymentRequestNode = {
  __typename: 'PaymentRequestNode';
  accountUuid: Scalars['UUID'];
  productUuid: Scalars['UUID'];
  chargeAmount: Scalars['Float'];
  eligibilityReferenceUuid: Scalars['UUID'];
  status: PaymentRequestStatus;
  isFullyPaid: Scalars['Boolean'];
  timeOfService: Scalars['DateTime'];
  transactions?: Maybe<Array<Maybe<TransactionNode>>>;
};

export enum PaymentRequestStatus {
  PendingPayment = 'PENDING_PAYMENT',
  PendingRefund = 'PENDING_REFUND',
  PendingAutopay = 'PENDING_AUTOPAY',
  Cancelled = 'CANCELLED',
  FullyPaid = 'FULLY_PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  FullyRefunded = 'FULLY_REFUNDED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  FullChargeback = 'FULL_CHARGEBACK',
  PartialChargeback = 'PARTIAL_CHARGEBACK'
}

export type PermissionDeniedError = BaseError & {
  __typename: 'PermissionDeniedError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type PersonNode = {
  __typename: 'PersonNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  personType: PersonType;
};

export enum PersonType {
  Human = 'HUMAN',
  Superhero = 'SUPERHERO'
}

export type PhoneSupportBenefitsNode = {
  __typename: 'PhoneSupportBenefitsNode';
  hasHpiCoverage?: Maybe<Scalars['Boolean']>;
  hasPammCoverage?: Maybe<Scalars['Boolean']>;
  hasDependentAccess?: Maybe<Scalars['Boolean']>;
  hasCareNavigationAccess?: Maybe<Scalars['Boolean']>;
  hasPathwaysAccess?: Maybe<Scalars['Boolean']>;
};

export type PhoneSupportCobraEligibilityPeriod = {
  __typename: 'PhoneSupportCobraEligibilityPeriod';
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type PhoneSupportCompanyNode = {
  __typename: 'PhoneSupportCompanyNode';
  uuid?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  companyCode?: Maybe<Scalars['String']>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
  ssoEnabled?: Maybe<Scalars['Boolean']>;
  currentContractPeriod?: Maybe<PhoneSupportContractPeriod>;
};

export type PhoneSupportContractPeriod = {
  __typename: 'PhoneSupportContractPeriod';
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type PhoneSupportCrisisProviderNode = {
  __typename: 'PhoneSupportCrisisProviderNode';
  companyPhoneNumber?: Maybe<Scalars['String']>;
  countryPhoneNumber?: Maybe<Scalars['String']>;
};

export type PhoneSupportDependentInfoNode = {
  __typename: 'PhoneSupportDependentInfoNode';
  crisisProvider?: Maybe<PhoneSupportCrisisProviderNode>;
  providerMatch?: Maybe<PhoneSupportProviderMatchNode>;
  careRecommendation?: Maybe<Scalars['String']>;
  wellBeingScore?: Maybe<Scalars['String']>;
  coveredCoachingVisits?: Maybe<Scalars['Int']>;
  coveredTherapyVisits?: Maybe<Scalars['Int']>;
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
  benefits?: Maybe<PhoneSupportBenefitsNode>;
};

export type PhoneSupportDependentInfoOutput = PhoneSupportDependentInfoSuccessResponse | InternalToolPermissionDeniedError;

export type PhoneSupportDependentInfoSuccessResponse = {
  __typename: 'PhoneSupportDependentInfoSuccessResponse';
  info?: Maybe<PhoneSupportDependentInfoNode>;
};

export type PhoneSupportDependentSearchResultNode = {
  __typename: 'PhoneSupportDependentSearchResultNode';
  uuid?: Maybe<Scalars['UUID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type PhoneSupportGenerateOtpOutput = PhoneSupportGenerateOtpSuccessResponse | InternalToolPermissionDeniedError;

export type PhoneSupportGenerateOtpSuccessResponse = {
  __typename: 'PhoneSupportGenerateOTPSuccessResponse';
  otp?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PhoneSupportMemberInfoNode = {
  __typename: 'PhoneSupportMemberInfoNode';
  crisisProvider?: Maybe<PhoneSupportCrisisProviderNode>;
  providerMatch?: Maybe<PhoneSupportProviderMatchNode>;
  careRecommendation?: Maybe<Scalars['String']>;
  wellBeingScore?: Maybe<Scalars['String']>;
  coveredCoachingVisits?: Maybe<Scalars['Int']>;
  coveredTherapyVisits?: Maybe<Scalars['Int']>;
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
  benefits?: Maybe<PhoneSupportBenefitsNode>;
};

export type PhoneSupportMemberInfoOutput = PhoneSupportMemberInfoSuccessResponse | InternalToolPermissionDeniedError;

export type PhoneSupportMemberInfoSuccessResponse = {
  __typename: 'PhoneSupportMemberInfoSuccessResponse';
  info?: Maybe<PhoneSupportMemberInfoNode>;
};

export type PhoneSupportMemberNode = {
  __typename: 'PhoneSupportMemberNode';
  uuid?: Maybe<Scalars['UUID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type PhoneSupportMemberSearchOutput = PhoneSupportMemberSearchSuccessResponse | InternalToolPermissionDeniedError;

export type PhoneSupportMemberSearchResultNode = {
  __typename: 'PhoneSupportMemberSearchResultNode';
  uuid?: Maybe<Scalars['UUID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  eligible?: Maybe<Scalars['Boolean']>;
  registered?: Maybe<Scalars['Boolean']>;
  cobraEligibilityPeriod?: Maybe<PhoneSupportCobraEligibilityPeriod>;
  member?: Maybe<PhoneSupportMemberNode>;
};

export type PhoneSupportMemberSearchSuccessResponse = {
  __typename: 'PhoneSupportMemberSearchSuccessResponse';
  eligiblePersons?: Maybe<Array<Maybe<PhoneSupportMemberSearchResultNode>>>;
  dependents?: Maybe<Array<Maybe<PhoneSupportDependentSearchResultNode>>>;
  company?: Maybe<PhoneSupportCompanyNode>;
};

export type PhoneSupportProviderMatchNode = {
  __typename: 'PhoneSupportProviderMatchNode';
  therapists?: Maybe<Array<Maybe<Scalars['String']>>>;
  coaches?: Maybe<Array<Maybe<Scalars['String']>>>;
  mentalHealthCoaches?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PhoneSupportUpdateMemberEmailOutput = PhoneSupportUpdateMemberEmailSuccessResponse | InternalToolPermissionDeniedError;

export type PhoneSupportUpdateMemberEmailSuccessResponse = {
  __typename: 'PhoneSupportUpdateMemberEmailSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type Phq9Access = {
  __typename: 'Phq9Access';
  lastAccess?: Maybe<Scalars['DateTime']>;
  phq9SelfHarmScore?: Maybe<Scalars['Int']>;
  showTakeOverScreen?: Maybe<Scalars['Boolean']>;
};

export type Phq9SelfharmScoreNode = Node & {
  __typename: 'Phq9SelfharmScoreNode';
  id: Scalars['ID'];
  assessmentFlowId?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type PossibleReportAndSectionType = AvailableReportType | UnavailableReportType | AvailableSectionType | UnavailableSectionType;

export type PossibleReportType = AvailableReportType | UnavailableReportType;

export enum ProductType {
  Therapy = 'THERAPY',
  PsychiatryInitialEvaluation = 'PSYCHIATRY_INITIAL_EVALUATION',
  PsychiatryFollowUp = 'PSYCHIATRY_FOLLOW_UP'
}

export enum ProgramAvailabilityState {
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS',
  Everyone = 'EVERYONE'
}

export type ProgramFinishMutation = {
  __typename: 'ProgramFinishMutation';
  programProgress?: Maybe<ProgramProgressNode>;
};

export type ProgramLinkNode = Node & {
  __typename: 'ProgramLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  program: ProgramNode;
};

export type ProgramNode = {
  __typename: 'ProgramNode';
  id: Scalars['Int'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  internalName: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSONString']>;
  isProgramBuilder: Scalars['Boolean'];
  duration?: Maybe<Scalars['Int']>;
  defaultOrdering?: Maybe<Scalars['Int']>;
  showRatings?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  hideFromIndexQueries?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  availabilityState: ProgramAvailabilityState;
  nextProgram?: Maybe<ProgramNode>;
  lockedBy?: Maybe<ProgramNode>;
  contentTranslationAvailability: ContentTranslationAvailabilityNodeConnection;
  pages: Array<PageNode>;
  programProgress: Array<ProgramProgressNode>;
  messageResources: Array<MessageResourceNode>;
  programId: Scalars['Int'];
  nameTranslationKey: Scalars['String'];
  categoryTranslationKey: Scalars['String'];
  sourceStrings?: Maybe<Array<Maybe<ContentTranslationNode>>>;
  progressPercent: Scalars['Int'];
  isNew: Scalars['Boolean'];
};


export type ProgramNodeContentTranslationAvailabilityArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ProgramProgressNode = {
  __typename: 'ProgramProgressNode';
  id: Scalars['ID'];
  owner: MemberNode;
  program?: Maybe<ProgramNode>;
  activated: Scalars['Boolean'];
  activatedAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  pageProgress: Array<PageProgressNode>;
};

export type ProgramStartMutation = {
  __typename: 'ProgramStartMutation';
  programProgress?: Maybe<ProgramProgressNode>;
};

export type ProgramsScreenNode = ScreenNodeInterface & {
  __typename: 'ProgramsScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type ProviderCertificationNode = {
  __typename: 'ProviderCertificationNode';
  uuid: Scalars['UUID'];
  provider: MemberNode;
  certification: CertificationNode;
};

export type ProviderCoachingVisitNode = Node & {
  __typename: 'ProviderCoachingVisitNode';
  uuid: Scalars['UUID'];
  coachAssignment?: Maybe<CoachAssignmentNode>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  actualDuration?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  isTherapy: Scalars['Boolean'];
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isPsychiatryInitialEvaluation?: Maybe<Scalars['Boolean']>;
  visitInfo?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  state: CoachingVisitState;
  modalityType: CoachingVisitModalityType;
  videoService?: Maybe<Scalars['String']>;
  providerVideoStartTime?: Maybe<Scalars['DateTime']>;
  providerVideoEndTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  videoSessionUrl?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['String']>;
  isPathway?: Maybe<Scalars['Boolean']>;
  previousProviderReview?: Maybe<CoachingVisitProviderReviewNode>;
  visitType?: Maybe<Scalars['String']>;
};

export type ProviderCoachingVisitNodeConnection = {
  __typename: 'ProviderCoachingVisitNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ProviderCoachingVisitNodeEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
  edgeCount?: Maybe<Scalars['Int']>;
};

export type ProviderCoachingVisitNodeEdge = {
  __typename: 'ProviderCoachingVisitNodeEdge';
  node?: Maybe<ProviderCoachingVisitNode>;
  cursor: Scalars['String'];
};

export type ProviderLabelNode = {
  __typename: 'ProviderLabelNode';
  providerUuid?: Maybe<Scalars['UUID']>;
  providerLabel?: Maybe<Scalars['String']>;
};

export type ProviderListInput = {
  providerUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

export type ProviderMatchAttemptNode = {
  __typename: 'ProviderMatchAttemptNode';
  uuid: Scalars['UUID'];
  careRecommendation?: Maybe<CareRecommendationNode>;
  startedAt: Scalars['DateTime'];
  recommendedAt?: Maybe<Scalars['DateTime']>;
  chosenAt?: Maybe<Scalars['DateTime']>;
  manualRequestAt?: Maybe<Scalars['DateTime']>;
  manualMatchCompletedAt?: Maybe<Scalars['DateTime']>;
  providerType: ProviderMatchAttemptProviderType;
  chosenOffer?: Maybe<ProviderOptionOffer>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  state: ProviderMatchAttemptState;
  providerOptionOffers: Array<ProviderOptionOffer>;
};

export enum ProviderMatchAttemptProviderType {
  Coach = 'COACH',
  Therapist = 'THERAPIST',
  Psychiatrist = 'PSYCHIATRIST'
}

export enum ProviderMatchAttemptState {
  Started = 'STARTED',
  Recommended = 'RECOMMENDED',
  Chosen = 'CHOSEN',
  ManualRequest = 'MANUAL_REQUEST',
  ManualMatchCompleted = 'MANUAL_MATCH_COMPLETED'
}

export type ProviderMemberPathwayNode = Node & {
  __typename: 'ProviderMemberPathwayNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pathway: ProviderPathwayNode;
  member: MemberNode;
  company?: Maybe<CompanyDropdownNode>;
  surfacedProvider?: Maybe<MemberNode>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  state: PathwayProgressState;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  currentSessionIndex: Scalars['Int'];
  pathwayTopics: Array<Maybe<PathwayTopicNode>>;
  pathwayProvider: PathwayProviderNode;
  duration: Scalars['Int'];
  completionPercent: Scalars['Int'];
};

export type ProviderMemberPathwayNodeConnection = {
  __typename: 'ProviderMemberPathwayNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ProviderMemberPathwayNodeEdge>>;
};

export type ProviderMemberPathwayNodeEdge = {
  __typename: 'ProviderMemberPathwayNodeEdge';
  node?: Maybe<ProviderMemberPathwayNode>;
  cursor: Scalars['String'];
};

export type ProviderOptionOffer = {
  __typename: 'ProviderOptionOffer';
  uuid: Scalars['UUID'];
  member: MemberNode;
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
  order: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  provider?: Maybe<CoachNode>;
};

export type ProviderPathwayNode = Node & {
  __typename: 'ProviderPathwayNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  title: Scalars['String'];
  subtitle: Scalars['String'];
  description: Scalars['String'];
  sessionCount: Scalars['Int'];
  metadata: Scalars['JSONString'];
  assessment: AssessmentNode;
  assessmentSessionOrdering: Array<Scalars['Int']>;
  availabilityState: PathwayAvailabilityState;
  slug: Scalars['String'];
  pathwayprogressSet: ProviderMemberPathwayNodeConnection;
  topics: PathwayTopicNodeConnection;
  providers: PathwayProviderNodeConnection;
  memberPathway?: Maybe<ProviderMemberPathwayNode>;
};


export type ProviderPathwayNodePathwayprogressSetArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProviderPathwayNodeTopicsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProviderPathwayNodeProvidersArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PsychiatryVisitsCompletedNode = {
  __typename: 'PsychiatryVisitsCompletedNode';
  initialEvaluationVisitsCompleted?: Maybe<Scalars['Int']>;
  followUpVisitsCompleted?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename: 'Query';
  getPayerInformation?: Maybe<PayerInformationNode>;
  getVisitTransactionsForAccounts?: Maybe<Array<Maybe<PaymentRequestNode>>>;
  getPaymentInfoForVisit?: Maybe<PaymentInfoForVisitNode>;
  getVisitCost?: Maybe<PaymentInfoForVisitNode>;
  getContentUnit?: Maybe<ContentUnitNode>;
  getBenefitUnit?: Maybe<BenefitUnitNode>;
  getCoachMemberMatchingUnit?: Maybe<CoachMemberMatchingUnitNode>;
  getTreatmentCycle?: Maybe<TreatmentCycleNode>;
  getPeople?: Maybe<Array<Maybe<PersonNode>>>;
  getClientFilesByCompanyUuid?: Maybe<Array<Maybe<ClientFileNode>>>;
  getAllClientFiles?: Maybe<Array<Maybe<ClientFileNode>>>;
  getClientFileDetails?: Maybe<ClientFileEventDetailsNode>;
  getClientBuckets?: Maybe<Array<Maybe<ClientBucketNode>>>;
  getTranslations: Array<TranslationNode>;
  getTranslationKeys: Array<TranslationKeyNode>;
  getTranslationKey?: Maybe<TranslationKeyNode>;
  getLanguages: Array<LanguageNode>;
  getMemberInsurance?: Maybe<MemberInsuranceNode>;
  getCptCodes?: Maybe<Array<Maybe<CptCodeNode>>>;
  getCptCodesByServiceType?: Maybe<Array<Maybe<CptCodeNode>>>;
  getDxCodes?: Maybe<Array<Maybe<DxCodeNode>>>;
  getRelationshipCodes?: Maybe<Array<Maybe<RelationshipCodeNode>>>;
  getVisitRates?: Maybe<Array<Maybe<VisitRateNode>>>;
  getEmployerInsurances?: Maybe<Array<Maybe<EmployerInsuranceNode>>>;
  getEmployerInsurancesHistorical?: Maybe<Array<Maybe<EmployerInsuranceNode>>>;
  getEligibilityForMember?: Maybe<Scalars['Boolean']>;
  getMyEligibilityStatus?: Maybe<Scalars['Boolean']>;
  getMyEligibilityStatusInfo?: Maybe<EligibilityStatusNode>;
  getMemberCostEstimate?: Maybe<CostEstimateNode>;
  validateEmployerConfig?: Maybe<EmployerValidationConfigNode>;
  getInsuranceCompanies?: Maybe<Array<Maybe<InsuranceCompanyNode>>>;
  getEmployerCptRates?: Maybe<Array<Maybe<EmployerCptRate>>>;
  getEMRIPeople?: Maybe<Array<Maybe<EmriPersonNode>>>;
  searchGlobalResults?: Maybe<SearchGlobalResultsResponse>;
  pathway?: Maybe<PathwayNode>;
  pathwayByAssignment?: Maybe<PathwayNode>;
  pathways?: Maybe<Array<Maybe<PathwayNode>>>;
  featuredPathwayProviders?: Maybe<Array<Maybe<PathwayProviderNode>>>;
  conversations?: Maybe<ConversationNodeConnection>;
  conversation?: Maybe<ConversationNode>;
  messages?: Maybe<MessageNodeConnection>;
  allContentTagCategories?: Maybe<AllContentTagCategoryOutput>;
  allContentTags?: Maybe<AllContentTagsOutput>;
  allContentTagRelations?: Maybe<AllContentTagRelationsOutput>;
  contentTagListScreen?: Maybe<ContentTagListScreenNode>;
  contentTagScreenBySlug?: Maybe<ContentTagScreenNode>;
  exploreScreen?: Maybe<ExploreScreenNode>;
  recommendedScreen?: Maybe<RecommendedScreenNode>;
  availableHours?: Maybe<Array<Maybe<AvailableHourNode>>>;
  calendarAuthLink?: Maybe<CalendarAuthLinkNode>;
  calendarProfiles?: Maybe<Array<Maybe<CalendarProfileNode>>>;
  coachAvailability?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  providerAvailability?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  clients?: Maybe<ClientSummaryNodeConnection>;
  companies?: Maybe<Array<Maybe<CompanyDropdownNode>>>;
  myClients?: Maybe<MemberPageNode>;
  hasCalendarSetup?: Maybe<Scalars['Boolean']>;
  providerCoachingVisits?: Maybe<ProviderCoachingVisitNodeConnection>;
  providerIntakeForms?: Maybe<Array<Maybe<IntakeFormNode>>>;
  providerIntakeForm?: Maybe<IntakeFormNode>;
  coachingVisitClaimable?: Maybe<CoachingVisitClaimable>;
  coachingVisitToReport?: Maybe<Array<Maybe<CoachingVisitNode>>>;
  providerMessagingActions?: Maybe<Array<Maybe<MessageActionsNode>>>;
  providerAvailabilityForProvider?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  pathwayByProviderAssignment?: Maybe<ProviderPathwayNode>;
  allScheduledContent?: Maybe<AllScheduledContentOutput>;
  allHeroes?: Maybe<AllCourseHeroesOutput>;
  allGuides?: Maybe<AllCourseGuidesOutput>;
  allProviders?: Maybe<AllProvidersOutput>;
  allVideoContent?: Maybe<AllVideoContentOutput>;
  allContentTranslationAvailabilities?: Maybe<AllContentTranslationAvailabilitiesOutput>;
  allScreens?: Maybe<AllScreensOutput>;
  allMediaTypes?: Maybe<AllMediaTypesOutput>;
  allContentLanguages?: Maybe<AllContentLanguagesOutput>;
  courses?: Maybe<Array<Maybe<CourseNode>>>;
  course?: Maybe<CourseNode>;
  courseBySlug?: Maybe<CourseNode>;
  courseSection?: Maybe<CourseSectionNode>;
  courseSectionBySlug?: Maybe<CourseSectionNode>;
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
  program?: Maybe<ProgramNode>;
  programBySlug?: Maybe<ProgramNode>;
  screens?: Maybe<Array<Maybe<ScreenNode>>>;
  screenBySlug?: Maybe<ScreenNode>;
  homeScreen?: Maybe<HomeScreenNode>;
  forYouScreen?: Maybe<ForYouScreenNode>;
  resourcesScreen?: Maybe<ResourcesScreenNode>;
  programsScreen?: Maybe<ProgramsScreenNode>;
  coursesScreen?: Maybe<CoursesScreenNode>;
  meditationsScreen?: Maybe<MeditationsScreenNode>;
  wellbeingReportScreen?: Maybe<WellbeingReportScreenNode>;
  manageCareTeamScreen?: Maybe<ManageCareTeamScreenNode>;
  exploreCareOptionsScreen?: Maybe<ExploreCareOptionsScreenNode>;
  wellbeingReportMonitoringMessage?: Maybe<WellbeingReportMonitoringMessageResult>;
  contentCollection?: Maybe<ContentCollectionNode>;
  contentCollections?: Maybe<Array<Maybe<ContentCollectionNode>>>;
  programs?: Maybe<Array<Maybe<ProgramNode>>>;
  programProgress?: Maybe<Array<Maybe<ProgramProgressNode>>>;
  pageProgress?: Maybe<Array<Maybe<PageProgressNode>>>;
  pages?: Maybe<Array<Maybe<PageNode>>>;
  scheduledContentActivity?: Maybe<ScheduledContentActivitySummaryNode>;
  scheduledContent?: Maybe<ScheduledContentNode>;
  completedScheduledContent?: Maybe<ScheduledContentConnection>;
  textTrackTranslations?: Maybe<Array<Maybe<TextTrackTranslationNode>>>;
  translations?: Maybe<Array<Maybe<ContentTranslationNode>>>;
  dailyPauseCalendarReminder?: Maybe<DailyPauseCalendarReminder>;
  memberFeaturedPrograms?: Maybe<Array<Maybe<ProgramNode>>>;
  assessment?: Maybe<AssessmentNode>;
  assessments?: Maybe<Array<Maybe<AssessmentNode>>>;
  assessmentQuestion?: Maybe<AssessmentQuestionNode>;
  meditation?: Maybe<MeditationNode>;
  meditationBySlug?: Maybe<MeditationNode>;
  meditations?: Maybe<Array<Maybe<MeditationNode>>>;
  meditationCategories?: Maybe<Array<Maybe<MeditationCategoryNode>>>;
  meditationProgress?: Maybe<Array<Maybe<MeditationProgressNode>>>;
  memberFeaturedMeditations?: Maybe<Array<Maybe<MeditationNode>>>;
  allHrAdminRoles?: Maybe<AllHrAdminRolesOutput>;
  hrAdminRole?: Maybe<HrAdminRoleOutput>;
  allHrAdmins?: Maybe<AllHrAdminsOutput>;
  hrAdmin?: Maybe<HrAdminOutput>;
  hrCompanyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  retrieveConnectToken?: Maybe<HrisConnectTokenOutput>;
  listHrisConnections?: Maybe<HrisConnectionsOutput>;
  listHrAdmins?: Maybe<ListHrAdminQueryOutput>;
  listHrAdminRoles: Array<HrAdminRoleNode>;
  myHrAdmin?: Maybe<HrAdminNode>;
  hrMessages?: Maybe<HrMessagesResult>;
  isHrAdmin?: Maybe<Scalars['Boolean']>;
  lookerSsoEmbed?: Maybe<LookerSsoEmbedResult>;
  getAllReportsAndSections?: Maybe<GetAllReportsAndSectionsResult>;
  topicsOfFocus?: Maybe<Array<Maybe<TopicOfFocusNode>>>;
  topicSelectionGroups?: Maybe<Array<Maybe<TopicSelectionGroupNode>>>;
  memberCarePreferences?: Maybe<Array<Maybe<MemberCarePreferenceNode>>>;
  crisisProviderCompanyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  crisisProviderCountryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  crisisProviders?: Maybe<Array<Maybe<CrisisProviderNode>>>;
  companyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  lastCareNavigationRequest?: Maybe<CareNavigationRequestNode>;
  getCancelledSessionReview?: Maybe<CancelledSessionReviewResponse>;
  phoneSupportMemberSearch?: Maybe<PhoneSupportMemberSearchOutput>;
  phoneSupportMemberInfo?: Maybe<PhoneSupportMemberInfoOutput>;
  phoneSupportDependentInfo?: Maybe<PhoneSupportDependentInfoOutput>;
  companySegments?: Maybe<CompanySegmentsOutput>;
  companiesWithSegments?: Maybe<CompaniesWithSegmentsOutput>;
  allCompanyAdditionalBenefits?: Maybe<AllCompanyAdditionalBenefitOutput>;
  allCompanies?: Maybe<AllCompaniesOutput>;
  healthPlanCompanies?: Maybe<HealthPlanCompaniesOutput>;
  companyFeatures?: Maybe<AllCompanyFeaturesOutput>;
  allTimezones?: Maybe<Array<Maybe<TimezoneNode>>>;
  coachAssignments?: Maybe<Array<Maybe<CoachAssignmentNode>>>;
  coachingVisits?: Maybe<Array<Maybe<CoachingVisitNode>>>;
  lastInvoicedCoachingVisit?: Maybe<CoachingVisitNode>;
  contentResponses?: Maybe<ContentResponsesNode>;
  me?: Maybe<MemberNode>;
  member?: Maybe<MemberNode>;
  memberNonPhi?: Maybe<MemberNonPhiOutput>;
  coachingVisit?: Maybe<CoachingVisitNode>;
  groupPractice?: Maybe<GroupPracticeNode>;
  shouldShowNpsQuestion?: Maybe<Scalars['Boolean']>;
  shouldShowInAppReviewFlow?: Maybe<Scalars['Boolean']>;
  memberFilterPreferences?: Maybe<Array<Maybe<MemberFilterPreferenceNode>>>;
  intakeForm?: Maybe<IntakeFormNode>;
  wellBeingReport?: Maybe<WellBeingReportNode>;
  memberReportableSessionsCount?: Maybe<Scalars['Int']>;
  assessmentOverview?: Maybe<Array<Maybe<AssessmentOverviewNode>>>;
  assessmentDetail?: Maybe<AssessmentDetailNode>;
  company: CompanyOutput;
  /** Query all Series */
  adminCircleSeriesCollection: CircleSeriesCollection;
  /** Query all question definitions */
  circleAdminRsvpQuestionDefinitions: CircleAdminRsvpQuestionDefinitionsResponse;
  /** Returns a collection of FeaturedItem objects */
  circleAdminFeaturedItemCollection: CircleAdminFeaturedItemCollectionResponse;
  /** Query all facilitators */
  circleAdminFacilitatorCollection: CircleAdminFacilitatorCollectionResponse;
  circleAdminSessionRegistrantCollection: CircleSessionRegistrantCollectionResponse;
  /** Query all available series the platform offers */
  circleSeriesCollection: CircleSeriesCollection;
  /** Query a specific series by uuid */
  circleSeries?: Maybe<CircleSeriesNode>;
  /** Query a specific series by slug */
  circleSeriesBySlug?: Maybe<CircleSeriesNode>;
  /** Query a specific facilitator by id */
  circleFacilitator?: Maybe<CircleFacilitatorNode>;
  /** Returns Topics can be filtered by seriesId or by languageCode */
  circleTopicConnection: CircleTopicConnection;
  /** Query a specific topic by uuid */
  circleTopic?: Maybe<CircleTopicNode>;
  /** Query a specific topic by slug */
  circleTopicBySlug?: Maybe<CircleTopicNode>;
  /**
   * Returns sessions for a given circle between from and to.
   * If from is not provided, now() is used.
   */
  circleSessionConnection: CircleSessionConnection;
  circleSession?: Maybe<CircleSessionNode>;
  /**
   * Returns a collection of featured items
   * or null if no items should be featured.
   */
  circleFeaturedCollection: CircleFeaturedCollection;
  /**
   * Returns a list of available calendar links
   * for an RSVP
   */
  circleCalendarLinksByRsvp?: Maybe<CircleCalendarLinksByRsvpQueryResponse>;
  circleRsvps?: Maybe<CircleRsvpsQueryResponse>;
  /** Query a specific Rsvp by id */
  circleRsvp?: Maybe<CircleRsvpQueryResponse>;
  circleSessionsByDateTime: CircleSessionsByDateTimeResponse;
  circleOnDemandConnection: CircleOnDemandConnectionQueryResponse;
  circleOnDemandBySlug: CircleOnDemandBySlugQueryResponse;
  /** Query an OnDemandTopic by id */
  circleAdminOnDemandById: CircleAdminOnDemandTopicQueryResponse;
  /** Query Scheduled Tasks by taskState */
  circleAdminScheduledTasksConnection: CircleAdminScheduledTaskConnectionResponse;
};


export type QueryGetVisitTransactionsForAccountsArgs = {
  accountUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
};


export type QueryGetPaymentInfoForVisitArgs = {
  visitUuid: Scalars['UUID'];
};


export type QueryGetVisitCostArgs = {
  visitUuid: Scalars['UUID'];
  accountUuid: Scalars['UUID'];
};


export type QueryGetContentUnitArgs = {
  userId: Scalars['ID'];
  modelName: Scalars['String'];
  userFeatures: UserFeatureInput;
  filterContentType?: Maybe<Array<Maybe<ContentType>>>;
};


export type QueryGetBenefitUnitArgs = {
  userId: Scalars['ID'];
  modelName: Scalars['String'];
  userFocusFeatures: UserFocusFeatureInput;
  benefitFeatures: BenefitFeatureInput;
};


export type QueryGetCoachMemberMatchingUnitArgs = {
  modelName: Scalars['String'];
  memberFeatures?: Maybe<MemberInput>;
  coachGlobalUuids?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetTreatmentCycleArgs = {
  treatmentStartedAt?: Maybe<Scalars['String']>;
  treatmentType: Scalars['String'];
  activityTimestamp: Scalars['String'];
  activityDates?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetClientFilesByCompanyUuidArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetClientFileDetailsArgs = {
  clientFileId: Scalars['Int'];
};


export type QueryGetTranslationsArgs = {
  languageCode: Scalars['String'];
  collectionName?: Maybe<Scalars['String']>;
};


export type QueryGetTranslationKeyArgs = {
  translationKey: Scalars['String'];
};


export type QueryGetCptCodesArgs = {
  companyUuid?: Maybe<Scalars['UUID']>;
  serviceType?: Maybe<ServiceType>;
};


export type QueryGetCptCodesByServiceTypeArgs = {
  serviceType?: Maybe<ServiceType>;
};


export type QueryGetEmployerInsurancesArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetEmployerInsurancesHistoricalArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetEligibilityForMemberArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryGetMemberCostEstimateArgs = {
  getMemberCostEstimate: GetMemberCostEstimate;
};


export type QueryValidateEmployerConfigArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetEmployerCptRatesArgs = {
  employerInsuranceId: Scalars['Int'];
};


export type QuerySearchGlobalResultsArgs = {
  searchText?: Maybe<Scalars['String']>;
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryPathwayArgs = {
  pathwayUuid: Scalars['UUID'];
  platform: ContentCollectionPlatform;
};


export type QueryPathwayByAssignmentArgs = {
  providerAssignmentUuid: Scalars['UUID'];
  platform: ContentCollectionPlatform;
};


export type QueryPathwaysArgs = {
  platform: ContentCollectionPlatform;
};


export type QueryFeaturedPathwayProvidersArgs = {
  pathwayUuid: Scalars['UUID'];
};


export type QueryConversationsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  active?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  memberName?: Maybe<Scalars['String']>;
  memberEmail?: Maybe<Scalars['String']>;
  memberCompany?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryConversationArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMessagesArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryContentTagListScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryContentTagScreenBySlugArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryExploreScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryRecommendedScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCalendarAuthLinkArgs = {
  redirectUri?: Maybe<Scalars['String']>;
};


export type QueryCalendarProfilesArgs = {
  sync?: Maybe<Scalars['Boolean']>;
};


export type QueryCoachAvailabilityArgs = {
  coach: Scalars['UUID'];
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
};


export type QueryProviderAvailabilityArgs = {
  providerUuid: Scalars['UUID'];
  memberUuid?: Maybe<Scalars['UUID']>;
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
};


export type QueryClientsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  appInstalled?: Maybe<Scalars['Boolean']>;
  coachHasSentMessage?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['String']>;
  isMatched?: Maybe<Scalars['Boolean']>;
  lastInteraction?: Maybe<Scalars['DateTime']>;
  lastVisit?: Maybe<Scalars['DateTime']>;
  lastWho5Date?: Maybe<Scalars['String']>;
  matchDate?: Maybe<Scalars['DateTime']>;
  memberEmail?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  nextVisit?: Maybe<Scalars['DateTime']>;
  visitsCovered?: Maybe<Scalars['Int']>;
  companies?: Maybe<Scalars['String']>;
  hasRemainingSessions?: Maybe<Scalars['Boolean']>;
  hasUpcomingBooking?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  matchStatus?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryMyClientsArgs = {
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  matched?: Maybe<Scalars['Boolean']>;
  activeAfter?: Maybe<Scalars['DateTime']>;
  loggedInAfter?: Maybe<Scalars['DateTime']>;
  newMatches?: Maybe<Scalars['Boolean']>;
};


export type QueryHasCalendarSetupArgs = {
  coach: Scalars['UUID'];
};


export type QueryProviderCoachingVisitsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  scheduledTimeBefore?: Maybe<Scalars['DateTime']>;
  scheduledTimeAfter?: Maybe<Scalars['DateTime']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryProviderIntakeFormArgs = {
  intakeFormUuid: Scalars['UUID'];
};


export type QueryCoachingVisitClaimableArgs = {
  memberUuid: Scalars['UUID'];
  state: Scalars['String'];
  scheduledTime: Scalars['DateTime'];
};


export type QueryCoachingVisitToReportArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryProviderMessagingActionsArgs = {
  platform: ContentCollectionPlatform;
  assignmentUuid: Scalars['UUID'];
};


export type QueryProviderAvailabilityForProviderArgs = {
  providerUuid: Scalars['UUID'];
  memberUuid?: Maybe<Scalars['UUID']>;
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
};


export type QueryPathwayByProviderAssignmentArgs = {
  assignmentUuid: Scalars['UUID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCoursesArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseBySlugArgs = {
  slug: Scalars['String'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseSectionArgs = {
  id: Scalars['ID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseSectionBySlugArgs = {
  slug: Scalars['String'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseActivityGroupArgs = {
  id: Scalars['ID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryProgramArgs = {
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryProgramBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryScreensArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryScreenBySlugArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  slug: Scalars['String'];
};


export type QueryHomeScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryForYouScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryResourcesScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryProgramsScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCoursesScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryMeditationsScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryWellbeingReportScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryManageCareTeamScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryExploreCareOptionsScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryContentCollectionArgs = {
  uuid?: Maybe<Scalars['UUID']>;
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryContentCollectionsArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryProgramsArgs = {
  includeHidden?: Maybe<Scalars['Boolean']>;
};


export type QueryScheduledContentArgs = {
  contentType?: Maybe<ScheduledContentType>;
  forTime?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryCompletedScheduledContentArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryMemberFeaturedProgramsArgs = {
  uuid: Scalars['UUID'];
};


export type QueryAssessmentArgs = {
  name?: Maybe<Scalars['String']>;
};


export type QueryMeditationArgs = {
  uuid?: Maybe<Scalars['UUID']>;
  languageCode?: Maybe<Scalars['String']>;
};


export type QueryMeditationBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
};


export type QueryMeditationsArgs = {
  languageCode?: Maybe<Scalars['String']>;
};


export type QueryMemberFeaturedMeditationsArgs = {
  uuid: Scalars['UUID'];
};


export type QueryHrAdminRoleArgs = {
  id: Scalars['ID'];
};


export type QueryAllHrAdminsArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryHrAdminArgs = {
  id: Scalars['ID'];
};


export type QueryListHrAdminsArgs = {
  companyUuid: Scalars['UUID'];
  showDisabled?: Maybe<Scalars['Boolean']>;
};


export type QueryHrMessagesArgs = {
  includeSeen?: Maybe<Scalars['Boolean']>;
};


export type QueryLookerSsoEmbedArgs = {
  reportType?: Maybe<ReportTypeEnum>;
  embedDomain?: Maybe<Scalars['String']>;
};


export type QueryGetAllReportsAndSectionsArgs = {
  embedDomain?: Maybe<Scalars['String']>;
};


export type QueryCrisisProvidersArgs = {
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryLastCareNavigationRequestArgs = {
  topic?: Maybe<Scalars['String']>;
};


export type QueryPhoneSupportMemberSearchArgs = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
};


export type QueryPhoneSupportMemberInfoArgs = {
  eligiblePersonUuid: Scalars['UUID'];
};


export type QueryPhoneSupportDependentInfoArgs = {
  accountUuid: Scalars['UUID'];
};


export type QueryCompanyFeaturesArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryCoachAssignmentsArgs = {
  coachAssignmentUuid?: Maybe<Scalars['String']>;
  coachUuid?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};


export type QueryMemberArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMemberNonPhiArgs = {
  uuid: Scalars['UUID'];
};


export type QueryCoachingVisitArgs = {
  uuid: Scalars['UUID'];
};


export type QueryShouldShowNpsQuestionArgs = {
  coachingVisitUuid: Scalars['UUID'];
};


export type QueryShouldShowInAppReviewFlowArgs = {
  store: InAppReviewStore;
  npsScore?: Maybe<Scalars['Int']>;
};


export type QueryIntakeFormArgs = {
  coachAssignmentUuid?: Maybe<Scalars['UUID']>;
  intakeFormUuid?: Maybe<Scalars['UUID']>;
};


export type QueryMemberReportableSessionsCountArgs = {
  coachUuid: Scalars['UUID'];
  memberUuid: Scalars['UUID'];
};


export type QueryAssessmentOverviewArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryAssessmentDetailArgs = {
  assessmentFlowUuid: Scalars['UUID'];
  assessmentType: Scalars['String'];
};


export type QueryCompanyArgs = {
  uuid: Scalars['UUID'];
};


export type QueryCircleAdminSessionRegistrantCollectionArgs = {
  sessionId: Scalars['ID'];
};


export type QueryCircleSeriesArgs = {
  id: Scalars['ID'];
};


export type QueryCircleSeriesBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCircleFacilitatorArgs = {
  id: Scalars['ID'];
};


export type QueryCircleTopicConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  seriesId?: Maybe<Scalars['ID']>;
  filterByLanguageCodes?: Maybe<Array<Scalars['String']>>;
};


export type QueryCircleTopicArgs = {
  id: Scalars['ID'];
};


export type QueryCircleTopicBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCircleSessionConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  topicId: Scalars['ID'];
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
};


export type QueryCircleSessionArgs = {
  id: Scalars['ID'];
};


export type QueryCircleCalendarLinksByRsvpArgs = {
  rsvpId: Scalars['ID'];
};


export type QueryCircleRsvpsArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
};


export type QueryCircleRsvpArgs = {
  id: Scalars['ID'];
};


export type QueryCircleSessionsByDateTimeArgs = {
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCircleOnDemandConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filterByLanguageCodes?: Maybe<Array<Scalars['String']>>;
};


export type QueryCircleOnDemandBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCircleAdminOnDemandByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCircleAdminScheduledTasksConnectionArgs = {
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskState: Scalars['String'];
};

export type RateScheduledContentMutation = {
  __typename: 'RateScheduledContentMutation';
  scheduledContentFeedback?: Maybe<ScheduledContentFeedbackNode>;
};

export enum RatingContentTypeEnum {
  Visit = 'VISIT',
  Program = 'PROGRAM',
  Meditation = 'MEDITATION'
}

export type RatingNode = {
  __typename: 'RatingNode';
  createdAt: Scalars['DateTime'];
  coachingVisit: CoachingVisitNode;
  rating: Scalars['Int'];
  reasons: Array<Maybe<Scalars['String']>>;
  feedbackText?: Maybe<Scalars['String']>;
};

export type RecommendCareMutation = {
  __typename: 'RecommendCareMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type RecommendedScreenNode = ScreenNodeInterface & {
  __typename: 'RecommendedScreenNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
  uuid: Scalars['UUID'];
};

export type RecordPresenceChangeMutation = {
  __typename: 'RecordPresenceChangeMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordScheduledContentActivityMutation = {
  __typename: 'RecordScheduledContentActivityMutation';
  activitySummary?: Maybe<ScheduledContentActivitySummaryNode>;
};

export type RelationshipCodeNode = {
  __typename: 'RelationshipCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RemoveCoachMutation = {
  __typename: 'RemoveCoachMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveModelKeyFromCacheResponse = {
  __typename: 'RemoveModelKeyFromCacheResponse';
  ok: Scalars['Boolean'];
  modelName: Scalars['String'];
  errors?: Maybe<Scalars['String']>;
};

export enum RenderingProviderType {
  None = 'NONE',
  SameAsBilling = 'SAME_AS_BILLING',
  Provider = 'PROVIDER'
}

export type ReportDataPoint = {
  __typename: 'ReportDataPoint';
  x: Scalars['String'];
  y: Scalars['Float'];
};

export type ReportMetadata = {
  __typename: 'ReportMetadata';
  title: Scalars['String'];
  labelX: Scalars['String'];
  labelY: Scalars['String'];
  xAxisLabels: Array<Scalars['String']>;
  yAxisLabels: Array<Scalars['Float']>;
  minY: Scalars['Float'];
  maxY: Scalars['Float'];
  extra?: Maybe<Scalars['JSONString']>;
};

export enum ReportTypeEnum {
  BenefitSnapshot = 'BENEFIT_SNAPSHOT',
  EngagementAndRegistration = 'ENGAGEMENT_AND_REGISTRATION',
  HealthAndWellbeingOverview = 'HEALTH_AND_WELLBEING_OVERVIEW',
  HealthAndWellbeingPillarsOfWellbeing = 'HEALTH_AND_WELLBEING_PILLARS_OF_WELLBEING',
  HealthAndWellbeingAreasOfInterest = 'HEALTH_AND_WELLBEING_AREAS_OF_INTEREST',
  UtilizationOneOnOneCare = 'UTILIZATION_ONE_ON_ONE_CARE',
  UtilizationCircles = 'UTILIZATION_CIRCLES',
  UtilizationDigitalContent = 'UTILIZATION_DIGITAL_CONTENT',
  InternalBenchmarkingDash = 'INTERNAL_BENCHMARKING_DASH',
  InternalQbrDash = 'INTERNAL_QBR_DASH',
  InternalOutcome = 'INTERNAL_OUTCOME',
  InternalEfFilterFieldCheck = 'INTERNAL_EF_FILTER_FIELD_CHECK',
  InternalExtendedCare = 'INTERNAL_EXTENDED_CARE',
  InternalPsychiatry = 'INTERNAL_PSYCHIATRY'
}

export type RequestManualProviderMatchMutation = {
  __typename: 'RequestManualProviderMatchMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type RescheduleEventMutation = {
  __typename: 'RescheduleEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ResetEligibilityForMember = {
  memberUuid: Scalars['UUID'];
};

export type ResetEligibilityForMemberResponse = {
  __typename: 'ResetEligibilityForMemberResponse';
  ok: Scalars['Boolean'];
};

export type ResetTestAccountPasswordResult = {
  __typename: 'ResetTestAccountPasswordResult';
  uidb64: Scalars['String'];
  role: Scalars['String'];
  token: Scalars['String'];
  url: Scalars['String'];
};

export type ResourcesScreenNode = ScreenNodeInterface & {
  __typename: 'ResourcesScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type ReviewInputNode = {
  reviewId?: Maybe<Scalars['Int']>;
  rating: Scalars['Int'];
  reason: Scalars['String'];
  feedbackText?: Maybe<Scalars['String']>;
};

export type ReviewNode = {
  __typename: 'ReviewNode';
  rating: Scalars['Int'];
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  reviewer: MemberNode;
  targetType: Scalars['String'];
  targetId: Scalars['Int'];
  reason: Scalars['String'];
  feedbackText?: Maybe<Scalars['String']>;
  coachingVisitProviderReviews?: Maybe<CoachingVisitProviderReviewNode>;
  reviewId: Scalars['Int'];
};

export type ReviewProgramMutation = {
  __typename: 'ReviewProgramMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SaveContentResponsesMutation = {
  __typename: 'SaveContentResponsesMutation';
  updatedContentResponses?: Maybe<ContentResponsesNode>;
};

export type SaveNewClientCapacityMutation = {
  __typename: 'SaveNewClientCapacityMutation';
  newClientCapacity?: Maybe<Scalars['Int']>;
  providerSchedulingType?: Maybe<Scalars['String']>;
};

export type SaveRatingMutation = {
  __typename: 'SaveRatingMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum ScheduledContentActivityActivityType {
  Viewed = 'VIEWED',
  CtaClicked = 'CTA_CLICKED',
  Completed = 'COMPLETED',
  Liked = 'LIKED',
  Disliked = 'DISLIKED'
}

export type ScheduledContentActivityNode = {
  __typename: 'ScheduledContentActivityNode';
  scheduledContent: ScheduledContentNode;
  activityType: ScheduledContentActivityActivityType;
  timestamp: Scalars['DateTime'];
};

export type ScheduledContentActivitySummaryNode = {
  __typename: 'ScheduledContentActivitySummaryNode';
  myActivity?: Maybe<Array<Maybe<ScheduledContentActivityNode>>>;
  viewedCount?: Maybe<Scalars['Int']>;
  ctaClickedCount?: Maybe<Scalars['Int']>;
  completedCount?: Maybe<Scalars['Int']>;
  likedCount?: Maybe<Scalars['Int']>;
  dislikedCount?: Maybe<Scalars['Int']>;
  myStreakTracking: Array<ScheduledContentStreakTrackingNode>;
  dayStreakCount: Scalars['Int'];
  weekStreakCount: Scalars['Int'];
};


export type ScheduledContentActivitySummaryNodeMyStreakTrackingArgs = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export enum ScheduledContentActivityType {
  Viewed = 'VIEWED',
  CtaClicked = 'CTA_CLICKED',
  Completed = 'COMPLETED',
  Liked = 'LIKED',
  Disliked = 'DISLIKED'
}

export type ScheduledContentConnection = {
  __typename: 'ScheduledContentConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ScheduledContentEdge>>;
};

export enum ScheduledContentContentType {
  DailyPause = 'DAILY_PAUSE'
}

export type ScheduledContentEdge = {
  __typename: 'ScheduledContentEdge';
  node?: Maybe<ScheduledContentNode>;
  cursor: Scalars['String'];
};

export type ScheduledContentFeedbackNode = {
  __typename: 'ScheduledContentFeedbackNode';
  rating: ScheduledContentFeedbackRatingType;
  review?: Maybe<Scalars['String']>;
  scheduledContent: ScheduledContentNode;
};

export enum ScheduledContentFeedbackRatingType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type ScheduledContentLinkNode = {
  __typename: 'ScheduledContentLinkNode';
  uuid: Scalars['UUID'];
  index: Scalars['Int'];
  mobileValue: Scalars['String'];
  webValue?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  scheduledContent: ScheduledContentNode;
  isCta: Scalars['Boolean'];
  linkType: ContentCollectionLinkLinkType;
};

export type ScheduledContentNode = Node & {
  __typename: 'ScheduledContentNode';
  uuid: Scalars['UUID'];
  contentType: ScheduledContentContentType;
  startTime: Scalars['DateTime'];
  bannerImage?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  accentColor?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  scheduledContentLinks: Array<ScheduledContentLinkNode>;
  id: Scalars['ID'];
  myActivity?: Maybe<Array<Maybe<ScheduledContentActivityNode>>>;
  feedback?: Maybe<ScheduledContentFeedbackNode>;
  isCompleted: Scalars['Boolean'];
  duration?: Maybe<Scalars['Int']>;
  bannerTitle: Scalars['String'];
  bannerCtaText: Scalars['String'];
  bannerContent: Scalars['String'];
  fullContent: Scalars['String'];
  linkHeader?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
};

export type ScheduledContentNodeConnection = {
  __typename: 'ScheduledContentNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<ScheduledContentNodeEdge>>;
};

export type ScheduledContentNodeEdge = {
  __typename: 'ScheduledContentNodeEdge';
  node?: Maybe<ScheduledContentNode>;
  cursor: Scalars['String'];
};

export type ScheduledContentStreakTrackingNode = {
  __typename: 'ScheduledContentStreakTrackingNode';
  date: Scalars['Date'];
};

export enum ScheduledContentType {
  DailyPause = 'DAILY_PAUSE'
}

export type ScreenCreateErrorResponse = {
  __typename: 'ScreenCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenCreateInput = {
  name: Scalars['String'];
  platform: ScreenPlatform;
};

export type ScreenCreateOutput = InternalToolPermissionDeniedError | ScreenCreateSuccessResponse | ScreenCreateErrorResponse;

export type ScreenCreateSuccessResponse = {
  __typename: 'ScreenCreateSuccessResponse';
  screen?: Maybe<GenericScreenNode>;
};

export type ScreenDeleteErrorResponse = {
  __typename: 'ScreenDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenDeleteInput = {
  id: Scalars['ID'];
};

export type ScreenDeleteOutput = InternalToolPermissionDeniedError | ScreenDeleteSuccessResponse | ScreenDeleteErrorResponse;

export type ScreenDeleteSuccessResponse = {
  __typename: 'ScreenDeleteSuccessResponse';
  screen?: Maybe<GenericScreenNode>;
};

export type ScreenLinkNode = Node & {
  __typename: 'ScreenLinkNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  index?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
  mobileValue?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  banner?: Maybe<ContentBannerNode>;
  screen: ScreenNode;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type ScreenNode = DataDefinedScreenNode | RecommendedScreenNode | HomeScreenNode | ForYouScreenNode | ResourcesScreenNode | CoursesScreenNode | ProgramsScreenNode | MeditationsScreenNode | WellbeingReportScreenNode | ContentTagListScreenNode | ContentTagScreenNode | ExploreScreenNode | ManageCareTeamScreenNode | ExploreCareOptionsScreenNode;

export type ScreenNodeInterface = {
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export enum ScreenPlatform {
  Web = 'WEB',
  Mobile = 'MOBILE',
  Dhcs = 'DHCS'
}

export type ScreenSectionCreateErrorResponse = {
  __typename: 'ScreenSectionCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenSectionCreateInput = {
  ctaLinkText?: Maybe<Scalars['String']>;
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  screenId: Scalars['ID'];
  collectionId: Scalars['ID'];
  ctaLinkId?: Maybe<Scalars['ID']>;
  minContent?: Maybe<Scalars['Int']>;
  maxContent?: Maybe<Scalars['Int']>;
  minimumMobileVersion?: Maybe<Scalars['String']>;
  showTitle?: Maybe<Scalars['Boolean']>;
};

export type ScreenSectionCreateOutput = InternalToolPermissionDeniedError | ScreenSectionCreateSuccessResponse | ScreenSectionCreateErrorResponse;

export type ScreenSectionCreateSuccessResponse = {
  __typename: 'ScreenSectionCreateSuccessResponse';
  screenSection?: Maybe<DataDefinedScreenSectionNode>;
};

export type ScreenSectionDeleteErrorResponse = {
  __typename: 'ScreenSectionDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenSectionDeleteInput = {
  id: Scalars['ID'];
};

export type ScreenSectionDeleteOutput = InternalToolPermissionDeniedError | ScreenSectionDeleteSuccessResponse | ScreenSectionDeleteErrorResponse;

export type ScreenSectionDeleteSuccessResponse = {
  __typename: 'ScreenSectionDeleteSuccessResponse';
  screenSection?: Maybe<DataDefinedScreenSectionNode>;
};

export type ScreenSectionNode = Node & {
  __typename: 'ScreenSectionNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  title: Scalars['String'];
  collection?: Maybe<ContentCollectionNode>;
  titleTranslationKey: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  contentCollectionLinks: Array<ContentLinkNode>;
  ctaLink?: Maybe<ContentLinkNode>;
  ctaContentLink?: Maybe<ContentCollectionLinkNode>;
  ctaLinkText?: Maybe<Scalars['String']>;
  ctaLinkTextTranslationKey?: Maybe<Scalars['String']>;
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  slug?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  minimumMobileVersion: Scalars['String'];
  minContent: Scalars['Int'];
  maxContent?: Maybe<Scalars['Int']>;
};

export type ScreenSectionUpdateErrorResponse = {
  __typename: 'ScreenSectionUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenSectionUpdateInput = {
  id: Scalars['ID'];
  ctaLinkText?: Maybe<Scalars['String']>;
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  maxContent: Scalars['Int'];
  minContent?: Maybe<Scalars['Int']>;
  minimumMobileVersion: Scalars['String'];
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  collectionId: Scalars['ID'];
  ctaLinkId?: Maybe<Scalars['ID']>;
  showTitle?: Maybe<Scalars['Boolean']>;
};

export type ScreenSectionUpdateOutput = InternalToolPermissionDeniedError | ScreenSectionUpdateSuccessResponse | ScreenSectionUpdateErrorResponse;

export type ScreenSectionUpdateSuccessResponse = {
  __typename: 'ScreenSectionUpdateSuccessResponse';
  screenSection?: Maybe<DataDefinedScreenSectionNode>;
};

export type ScreenUpdateErrorResponse = {
  __typename: 'ScreenUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenUpdateInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
};

export type ScreenUpdateOutput = InternalToolPermissionDeniedError | ScreenUpdateSuccessResponse | ScreenUpdateErrorResponse;

export type ScreenUpdateSuccessResponse = {
  __typename: 'ScreenUpdateSuccessResponse';
  screen?: Maybe<GenericScreenNode>;
};

export type SearchGlobalResultsResponse = SearchResponseResults | SearchResponseEmptyResults;

export type SearchResponseEmptyResults = {
  __typename: 'SearchResponseEmptyResults';
  searchText: Scalars['String'];
  otherResults: Array<ScreenSectionNode>;
};

export type SearchResponseResults = {
  __typename: 'SearchResponseResults';
  searchText: Scalars['String'];
  results: Array<ScreenSectionNode>;
};

export type SectionDoesNotExist = {
  __typename: 'SectionDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type SelectDifficultyMutation = {
  __typename: 'SelectDifficultyMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SelectModalityMutation = {
  __typename: 'SelectModalityMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SelectPrimaryFocusMutation = {
  __typename: 'SelectPrimaryFocusMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SelectTopicsOfFocusMutation = {
  __typename: 'SelectTopicsOfFocusMutation';
  topicSelections?: Maybe<Array<Maybe<TopicSelectionNode>>>;
};

export type SendMemberEmailReminderMutation = {
  __typename: 'SendMemberEmailReminderMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendMemberExtendTherapyEmailReminderMutation = {
  __typename: 'SendMemberExtendTherapyEmailReminderMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ServerSideAssessmentError = BaseSurveyError & {
  __typename: 'ServerSideAssessmentError';
  message: Scalars['String'];
  debug: Scalars['String'];
};

export enum ServiceType {
  Therapy = 'THERAPY',
  Psychiatry = 'PSYCHIATRY'
}

export type SignUpTokenDetailsNode = {
  __typename: 'SignUpTokenDetailsNode';
  token: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

export type StartAssessmentFlowMutation = {
  __typename: 'StartAssessmentFlowMutation';
  assessmentFlow: AssessmentFlowNode;
  nextAssessments: Array<Maybe<AssessmentKey>>;
};

export type StartAssessmentJourneyInput = {
  journeyConfigKeyUuid: Scalars['UUID'];
  metadata?: Maybe<StartAssessmentJourneyMetadata>;
};

export type StartAssessmentJourneyMetadata = {
  creationSource?: Maybe<AssessmentJourneyCreationSource>;
};

export type StartAssessmentJourneyResult = SuccessfulAssessmentJourneyCreationPayload | InvalidArgumentError;

export type StartCareRecommendationMutation = {
  __typename: 'StartCareRecommendationMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type StartMemberPathwayMutationInput = {
  pathwayUuid: Scalars['UUID'];
};

export type StartMemberPathwayMutationResponse = {
  __typename: 'StartMemberPathwayMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubmitAssessmentResponseOutput = SuccessfulJourneySubmissionPayload | InvalidArgumentError | ContentSubmissionError | ServerSideAssessmentError;

export type SubmitAssessmentResultInput = {
  assessmentJourneyUuid: Scalars['UUID'];
  content: Scalars['JSONString'];
};

export type SubmitAssessmentsMutation = {
  __typename: 'SubmitAssessmentsMutation';
  assessment?: Maybe<AssessmentNode>;
  createdContentResponses?: Maybe<Array<Maybe<ContentResponsesNode>>>;
  score?: Maybe<Scalars['Int']>;
};

export type SubmitCourseSectionReviewOutput = CourseSectionReviewResponse | CourseSectionDoesNotExist;

export type SubmitFeatureRecordReviewOutput = FeatureRecordReviewResponse | FeatureRecordDoesNotExist | FeatureInvalidFeedbackChoice;

export type SubmitModularizedAssessmentInput = {
  content: Scalars['JSONString'];
  assessmentFlowUuid: Scalars['UUID'];
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
};

export type SubmitModularizedAssessmentsResult = SuccessfulSubmissionPayload | InvalidArgumentError | ContentSubmissionError;

export type SubmitNpsMutation = {
  __typename: 'SubmitNpsMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubmitPathwayAssessmentMutationInput = {
  pathwayUuid: Scalars['UUID'];
  answers: Scalars['JSONString'];
};

export type SubmitPathwayAssessmentMutationOutput = PathwayAssessmentSubmitted | PathwayDoesNotExist | PathwayAssessmentInvalid;

export type SubmitPathwayReviewOutput = SubmitPathwayReviewResponse | PathwayDoesNotExist;

export type SubmitPathwayReviewResponse = {
  __typename: 'SubmitPathwayReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubtopicOfFocusDoesNotExist = {
  __typename: 'SubtopicOfFocusDoesNotExist';
  uuid?: Maybe<Scalars['UUID']>;
};

export type SubtopicOfFocusInput = {
  subtopicId: Scalars['ID'];
  isPrimarySubtopic: Scalars['Boolean'];
};

export type SubtopicOfFocusNode = {
  __typename: 'SubtopicOfFocusNode';
  topicOfFocus: TopicOfFocusNode;
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  nameDe?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  symptoms: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isClinical: Scalars['Boolean'];
  subtopicSymptoms: Array<SubtopicOfFocusSymptomNode>;
};

export type SubtopicOfFocusSymptomNode = {
  __typename: 'SubtopicOfFocusSymptomNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  nameDe?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  displayOrder: Scalars['Int'];
};

export type SubtopicSelectionNode = {
  __typename: 'SubtopicSelectionNode';
  subtopicOfFocus: SubtopicOfFocusNode;
  topicSelection: TopicSelectionNode;
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  symptomsExperienced: Array<Scalars['String']>;
};

export type SubtopicSymptomsInput = {
  symptomsUuids: Array<Maybe<Scalars['UUID']>>;
};

export type SuccessfulAssessmentJourneyCreationPayload = {
  __typename: 'SuccessfulAssessmentJourneyCreationPayload';
  assessmentJourney: AssessmentJourneyNode;
  nextAssessments: Array<Maybe<AssessmentKey>>;
};

export type SuccessfulJourneySubmissionPayload = {
  __typename: 'SuccessfulJourneySubmissionPayload';
  submittedAssessment: AssessmentNode;
  nextAssessments: Array<Maybe<AssessmentKey>>;
};

export type SuccessfulSubmissionPayload = {
  __typename: 'SuccessfulSubmissionPayload';
  submittedAssessment: AssessmentNode;
  createdContentResponses: Array<ContentResponsesNode>;
  nextAssessments: Array<Maybe<AssessmentKey>>;
};

export type SyncUuidsSuccessResponse = {
  __typename: 'SyncUuidsSuccessResponse';
  ok: Scalars['Boolean'];
};

export type TestMemberNode = {
  __typename: 'TestMemberNode';
  company?: Maybe<CompanyDropdownNode>;
  uuid: Scalars['UUID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type TestProviderNode = {
  __typename: 'TestProviderNode';
  company?: Maybe<CompanyDropdownNode>;
  uuid: Scalars['UUID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationCreateErrorResponse = {
  __typename: 'TextTrackTranslationCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationCreateInput = {
  contentLanguage?: Maybe<Scalars['String']>;
  textTrack: Scalars['String'];
  label: Scalars['String'];
  videoContentUuid?: Maybe<Scalars['ID']>;
};

export type TextTrackTranslationCreateOutput = InternalToolPermissionDeniedError | TextTrackTranslationCreateSuccessResponse | TextTrackTranslationCreateErrorResponse;

export type TextTrackTranslationCreateSuccessResponse = {
  __typename: 'TextTrackTranslationCreateSuccessResponse';
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
};

export type TextTrackTranslationDeleteErrorResponse = {
  __typename: 'TextTrackTranslationDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationDeleteInput = {
  id: Scalars['ID'];
};

export type TextTrackTranslationDeleteOutput = InternalToolPermissionDeniedError | TextTrackTranslationDeleteSuccessResponse | TextTrackTranslationDeleteErrorResponse;

export type TextTrackTranslationDeleteSuccessResponse = {
  __typename: 'TextTrackTranslationDeleteSuccessResponse';
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
};

export type TextTrackTranslationNode = Node & {
  __typename: 'TextTrackTranslationNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  videoContent: VideoContentNode;
  textTrack: Scalars['String'];
  label: Scalars['String'];
  contentLanguage?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationNodeConnection = {
  __typename: 'TextTrackTranslationNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<TextTrackTranslationNodeEdge>>;
};

export type TextTrackTranslationNodeEdge = {
  __typename: 'TextTrackTranslationNodeEdge';
  node?: Maybe<TextTrackTranslationNode>;
  cursor: Scalars['String'];
};

export type TextTrackTranslationUpdateErrorResponse = {
  __typename: 'TextTrackTranslationUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationUpdateInput = {
  id: Scalars['ID'];
  contentLanguage?: Maybe<Scalars['String']>;
  textTrack: Scalars['String'];
  label: Scalars['String'];
};

export type TextTrackTranslationUpdateOutput = InternalToolPermissionDeniedError | TextTrackTranslationUpdateSuccessResponse | TextTrackTranslationUpdateErrorResponse;

export type TextTrackTranslationUpdateSuccessResponse = {
  __typename: 'TextTrackTranslationUpdateSuccessResponse';
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
};

export type TimeToCareLabelMutation = {
  __typename: 'TimeToCareLabelMutation';
  providersWithTtcLabels?: Maybe<Array<Maybe<ProviderLabelNode>>>;
};

export type TimezoneNode = {
  __typename: 'TimezoneNode';
  properName: Scalars['String'];
  commonName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  utcOffset: Scalars['Float'];
  utcOffsetFormatted: Scalars['String'];
  locality?: Maybe<Scalars['String']>;
};

export type TopicInput = {
  topicUuid: Scalars['UUID'];
  subtopicUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

export type TopicOfFocusNode = {
  __typename: 'TopicOfFocusNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  nameDe?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  image: Scalars['String'];
  benefitColor?: Maybe<Scalars['String']>;
  benefitImage?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  benefits: Array<CompanyAdditionalBenefitNode>;
  subtopicsOfFocus: Array<SubtopicOfFocusNode>;
};

export type TopicSelectionGroupNode = {
  __typename: 'TopicSelectionGroupNode';
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  selectionType?: Maybe<TopicSelectionGroupSelectionType>;
  subtopicSelections: Array<SubtopicSelectionNode>;
  hasAtLeastOneClinicalSubtopicOfFocus?: Maybe<Scalars['Boolean']>;
};

export enum TopicSelectionGroupSelectionType {
  ProfileSettings = 'PROFILE_SETTINGS',
  OnboardingFlow = 'ONBOARDING_FLOW',
  DjangoAdminPage = 'DJANGO_ADMIN_PAGE',
  ChangeProvider = 'CHANGE_PROVIDER',
  AddProvider = 'ADD_PROVIDER',
  WellbeingReport = 'WELLBEING_REPORT'
}

export type TopicSelectionNode = {
  __typename: 'TopicSelectionNode';
  topicOfFocus: TopicOfFocusNode;
  careRecommendation?: Maybe<CareRecommendationNode>;
  uuid: Scalars['UUID'];
  subtopicSelections: Array<SubtopicSelectionNode>;
};

export type TopicSelectionTypeInvalid = {
  __typename: 'TopicSelectionTypeInvalid';
  message?: Maybe<Scalars['String']>;
};

export type TransactionNode = {
  __typename: 'TransactionNode';
  id: Scalars['Int'];
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  responsibleParty: TransactionResponsibleParty;
  source: TransactionSource;
  type: TransactionType;
};

export enum TransactionResponsibleParty {
  Insurance = 'INSURANCE',
  Ops = 'OPS',
  Payer = 'PAYER',
  User = 'USER'
}

export enum TransactionSource {
  Instamed = 'INSTAMED',
  PaymentChargedEvent = 'PAYMENT_CHARGED_EVENT',
  Insurance = 'INSURANCE'
}

export enum TransactionType {
  Authorization = 'AUTHORIZATION',
  Charge = 'CHARGE',
  Chargeback = 'CHARGEBACK',
  Payment = 'PAYMENT',
  PaymentDeclined = 'PAYMENT_DECLINED',
  PaymentVoided = 'PAYMENT_VOIDED',
  PendingRefund = 'PENDING_REFUND',
  Refund = 'REFUND',
  RefundDeclined = 'REFUND_DECLINED',
  RefundVoided = 'REFUND_VOIDED'
}

export type TranslationCollectionNode = {
  __typename: 'TranslationCollectionNode';
  uuid: Scalars['UUID'];
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationNode>>;
};

export type TranslationKeyNode = {
  __typename: 'TranslationKeyNode';
  uuid: Scalars['UUID'];
  key: Scalars['String'];
  defaultTranslation: Scalars['String'];
  translations?: Maybe<Array<TranslationNode>>;
};

export type TranslationNode = {
  __typename: 'TranslationNode';
  uuid: Scalars['UUID'];
  language: LanguageNode;
  collections: Array<TranslationCollectionNode>;
  translationKey: TranslationKeyNode;
  translatedText: Scalars['String'];
};

export type TreatmentCycleNode = {
  __typename: 'TreatmentCycleNode';
  treatmentState: TreatmentState;
};

export enum TreatmentState {
  Started = 'STARTED',
  Mid = 'MID',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED'
}


export type UnavailableReportType = {
  __typename: 'UnavailableReportType';
  reportOrSectionEnum: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  mainMessage: Scalars['String'];
  subMessage?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
};

export type UnavailableSectionType = {
  __typename: 'UnavailableSectionType';
  reportOrSectionEnum: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  mainMessage: Scalars['String'];
  subMessage?: Maybe<Scalars['String']>;
};

export type UnknownCompanyError = BaseError & {
  __typename: 'UnknownCompanyError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UnknownHrAdminError = BaseError & {
  __typename: 'UnknownHRAdminError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UnknownReportTypeError = BaseError & {
  __typename: 'UnknownReportTypeError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UnknownUserError = BaseError & {
  __typename: 'UnknownUserError';
  message?: Maybe<Scalars['String']>;
  debug?: Maybe<Scalars['String']>;
};

export type UpdateAccountSharedPreferencesMutation = {
  __typename: 'UpdateAccountSharedPreferencesMutation';
  sharedPreferencesRecord?: Maybe<AccountSharedPreferencesRecordNode>;
};

export type UpdateAvailableHoursMutation = {
  __typename: 'UpdateAvailableHoursMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCalendarMutation = {
  __typename: 'UpdateCalendarMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateClientBucketInput = {
  id: Scalars['Int'];
  notifyAccountUuid?: Maybe<Scalars['UUID']>;
  bucketName?: Maybe<Scalars['String']>;
  automated?: Maybe<Scalars['Boolean']>;
  companyFolder?: Maybe<Scalars['String']>;
};

export type UpdateClientBucketResponse = {
  __typename: 'UpdateClientBucketResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  clientBucket?: Maybe<ClientBucketNode>;
};

export type UpdateCoachingVisitMutation = {
  __typename: 'UpdateCoachingVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateConversationMutation = {
  __typename: 'UpdateConversationMutation';
  conversation?: Maybe<ConversationNode>;
};

export type UpdateCourseHeroMutationErrorResponse = {
  __typename: 'UpdateCourseHeroMutationErrorResponse';
  message: Scalars['String'];
};

export type UpdateCourseHeroMutationInput = {
  courseId: Scalars['ID'];
  videoTitle?: Maybe<Scalars['String']>;
  videoSourceHorizontal?: Maybe<Scalars['String']>;
  videoSourceVertical?: Maybe<Scalars['String']>;
  videoTextTrack?: Maybe<Scalars['String']>;
  videoPoster?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageAltText?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
};

export type UpdateCourseHeroMutationOutput = UpdateCourseHeroMutationSuccessResponse | UpdateCourseHeroMutationErrorResponse;

export type UpdateCourseHeroMutationSuccessResponse = {
  __typename: 'UpdateCourseHeroMutationSuccessResponse';
  hero?: Maybe<CourseHeroNode>;
};

export type UpdateEmriNameInput = {
  personUuid: Scalars['UUID'];
  newName: Scalars['String'];
};

export type UpdateEmriNameResponse = {
  __typename: 'UpdateEMRINameResponse';
  ok: Scalars['Boolean'];
  newPerson?: Maybe<EmriPersonNode>;
};

export type UpdateIntakeFormMutation = {
  __typename: 'UpdateIntakeFormMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateMemberProfileMutation = {
  __typename: 'UpdateMemberProfileMutation';
  member?: Maybe<MemberNode>;
};

export type UpdateMessageMutation = {
  __typename: 'UpdateMessageMutation';
  ok?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<MessageNode>;
};

export type UpdateNameInput = {
  personUuid: Scalars['UUID'];
  newName: Scalars['String'];
};

export type UpdateNameResponse = {
  __typename: 'UpdateNameResponse';
  ok: Scalars['Boolean'];
  newPerson?: Maybe<PersonNode>;
};

export type UpdateNotificationPreferencesMutation = {
  __typename: 'UpdateNotificationPreferencesMutation';
  notificationPreferences?: Maybe<NotificationPreferencesNode>;
};

export type UpdateProviderReview = {
  __typename: 'UpdateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateVisitMutation = {
  __typename: 'UpdateVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};


export type UploadCsvResponse = {
  __typename: 'UploadCsvResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type UserFeatureInput = {
  subtopicsOfFocus: Array<SubtopicOfFocusInput>;
};

export type UserFocusFeatureInput = {
  subtopicsOfFocus: Array<UserSubtopicOfFocusInput>;
};

export type UserSubtopicOfFocusInput = {
  subtopicId: Scalars['ID'];
  topicId: Scalars['ID'];
  isPrimarySubtopic: Scalars['Boolean'];
};

export type UuidSpecificationInput = {
  uuid: Scalars['UUID'];
  objectType: Scalars['String'];
  naturalKey: Scalars['String'];
};

export type ValidatePendingCoachingVisitMutation = {
  __typename: 'ValidatePendingCoachingVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
  sessionState?: Maybe<Scalars['String']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  costEstimation?: Maybe<CostEstimation>;
};

export type VideoContentCreateErrorResponse = {
  __typename: 'VideoContentCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type VideoContentCreateInput = {
  textTrack?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  sourceHorizontal: Scalars['String'];
  sourceVertical: Scalars['String'];
  poster?: Maybe<Scalars['String']>;
};

export type VideoContentCreateOutput = InternalToolPermissionDeniedError | VideoContentCreateSuccessResponse | VideoContentCreateErrorResponse;

export type VideoContentCreateSuccessResponse = {
  __typename: 'VideoContentCreateSuccessResponse';
  videoContent?: Maybe<VideoContentNode>;
};

export type VideoContentDeleteErrorResponse = {
  __typename: 'VideoContentDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type VideoContentDeleteInput = {
  id: Scalars['ID'];
};

export type VideoContentDeleteOutput = InternalToolPermissionDeniedError | VideoContentDeleteSuccessResponse | VideoContentDeleteErrorResponse;

export type VideoContentDeleteSuccessResponse = {
  __typename: 'VideoContentDeleteSuccessResponse';
  videoContent?: Maybe<VideoContentNode>;
};

export type VideoContentNode = Node & {
  __typename: 'VideoContentNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  title: Scalars['String'];
  sourceHorizontal: Scalars['String'];
  sourceVertical: Scalars['String'];
  poster?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  textTrack?: Maybe<Scalars['String']>;
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
  mediaType?: Maybe<MediaTypeNode>;
};

export type VideoContentNodeConnection = {
  __typename: 'VideoContentNodeConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<VideoContentNodeEdge>>;
};

export type VideoContentNodeEdge = {
  __typename: 'VideoContentNodeEdge';
  node?: Maybe<VideoContentNode>;
  cursor: Scalars['String'];
};

export type VideoContentUpdateErrorResponse = {
  __typename: 'VideoContentUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type VideoContentUpdateInput = {
  id: Scalars['ID'];
  textTrack?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  sourceHorizontal: Scalars['String'];
  sourceVertical: Scalars['String'];
  poster?: Maybe<Scalars['String']>;
};

export type VideoContentUpdateOutput = InternalToolPermissionDeniedError | VideoContentUpdateSuccessResponse | VideoContentUpdateErrorResponse;

export type VideoContentUpdateSuccessResponse = {
  __typename: 'VideoContentUpdateSuccessResponse';
  videoContent?: Maybe<VideoContentNode>;
};

export type VideoSessionNode = {
  __typename: 'VideoSessionNode';
  sessionId?: Maybe<Scalars['String']>;
  sessionToken?: Maybe<Scalars['String']>;
  apiKey?: Maybe<Scalars['String']>;
  coachingVisit?: Maybe<CoachingVisitNode>;
};

export type VisitRateNode = {
  __typename: 'VisitRateNode';
  productType: ProductType;
  rate: Scalars['Float'];
};

export type VisitsRemainingNode = {
  __typename: 'VisitsRemainingNode';
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
};

export type WellBeingReportNode = {
  __typename: 'WellBeingReportNode';
  metadata: ReportMetadata;
  data: Array<ReportDataPoint>;
};

export enum WellbeingReportMessages {
  EncourageAssessmentRetakeMessage = 'ENCOURAGE_ASSESSMENT_RETAKE_MESSAGE'
}

export type WellbeingReportMonitoringMessageResult = {
  __typename: 'WellbeingReportMonitoringMessageResult';
  messageType?: Maybe<WellbeingReportMessages>;
};

export type WellbeingReportScreenNode = ScreenNodeInterface & {
  __typename: 'WellbeingReportScreenNode';
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  platform: ScreenPlatform;
  icon?: Maybe<Scalars['String']>;
  iconLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenSections: Array<ScreenSectionNode>;
};

export type Who5SurveyNode = {
  __typename: 'Who5SurveyNode';
  id: Scalars['ID'];
  who5Goodspirits: Scalars['Int'];
  who5Calmrelaxed: Scalars['Int'];
  who5Activevigorous: Scalars['Int'];
  who5Freshrested: Scalars['Int'];
  who5Interestme: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  who5Althoughsick?: Maybe<Scalars['Int']>;
  who5Stickness?: Maybe<Scalars['Int']>;
  who5Burnedout?: Maybe<Scalars['Int']>;
  who5Recommendcompany?: Maybe<Scalars['Int']>;
  owner: MemberNode;
  score?: Maybe<Scalars['Int']>;
};

export type CreateOrUpdatePayerInformationResponse = {
  __typename: 'createOrUpdatePayerInformationResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  payerInformation?: Maybe<PayerInformationNode>;
};

export type CreateSamlPostPageResponse = {
  __typename: 'createSAMLPostPageResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  samlPage?: Maybe<Scalars['String']>;
};

export type UpdateAutoPaymentEnrollmentResponse = {
  __typename: 'updateAutoPaymentEnrollmentResponse';
  ok: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  enrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
};
